var _polygon, _polygon2, _polygon3, _path, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _path2, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _path3, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _line, _polygon111, _polygon112, _polygon113, _line2, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _polygon123, _polygon124, _polygon125, _polygon126, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _polygon136, _polygon137, _polygon138, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _polygon152, _polygon153, _polygon154, _polygon155, _polygon156, _path4, _polygon157, _polygon158, _polygon159, _polygon160, _polygon161, _polygon162, _polygon163, _polygon164, _polygon165, _polygon166, _polygon167, _polygon168, _polygon169, _polygon170, _polygon171, _polygon172, _polygon173, _polygon174, _polygon175, _polygon176, _polygon177, _polygon178, _polygon179, _polygon180, _polygon181, _polygon182, _polygon183, _polygon184, _polygon185, _polygon186, _polygon187, _polygon188, _polygon189, _polygon190, _polygon191, _polygon192, _polygon193, _polygon194, _polygon195, _polygon196, _polygon197, _polygon198, _polygon199, _polygon200, _polygon201, _polygon202, _polygon203, _polygon204, _polygon205, _polygon206, _polygon207, _polygon208, _polygon209, _polygon210, _polygon211, _polygon212, _polygon213, _polygon214, _polygon215, _polygon216, _polygon217, _polygon218, _polygon219, _polygon220, _polygon221, _polygon222, _polygon223, _polygon224, _polygon225, _polygon226, _polygon227, _polygon228, _polygon229, _polygon230, _polygon231, _polygon232, _polygon233, _polygon234, _polygon235, _polygon236, _polygon237, _polygon238, _polygon239, _polygon240, _polygon241, _polygon242, _polygon243, _polygon244, _polygon245, _polygon246, _polygon247, _polygon248, _polygon249, _polygon250, _polygon251, _polygon252, _polygon253, _polygon254, _polygon255, _polygon256, _polygon257, _polygon258, _polygon259, _polygon260, _polygon261, _polygon262, _polygon263, _polygon264, _polygon265, _polygon266, _polygon267, _polygon268, _polygon269, _polygon270, _polygon271, _polygon272, _polygon273, _polygon274, _polygon275, _polygon276, _polygon277, _polygon278, _polygon279, _polygon280, _polygon281, _polygon282, _polygon283, _polygon284, _polygon285, _polygon286, _polygon287, _polygon288, _polygon289, _polygon290, _polygon291, _polygon292, _polygon293, _polygon294, _polygon295, _polygon296, _polygon297, _polygon298, _polygon299, _polygon300, _polygon301, _polygon302, _polygon303, _polygon304, _polygon305, _polygon306, _polygon307, _polygon308, _polygon309, _polygon310, _polygon311, _polygon312, _polygon313, _polygon314, _polygon315, _polygon316, _polygon317, _polygon318, _polygon319, _polygon320, _polygon321, _polygon322, _polygon323, _polygon324, _polygon325, _polygon326, _polygon327, _polygon328, _polygon329, _polygon330, _polygon331, _polygon332, _polygon333, _polygon334, _polygon335, _polygon336, _polygon337, _polygon338, _polygon339, _polygon340, _polygon341, _polygon342, _polygon343, _polygon344, _polygon345, _polygon346, _polygon347, _polygon348, _polygon349, _polygon350, _polygon351, _polygon352, _polygon353, _polygon354, _polygon355, _polygon356, _polygon357, _polygon358, _polygon359, _polygon360, _polygon361, _polygon362, _polygon363, _polygon364, _polygon365, _polygon366, _polygon367, _polygon368, _polygon369, _polygon370, _polygon371, _polygon372, _polygon373, _polygon374, _polygon375, _polygon376, _polygon377, _polygon378, _polygon379, _polygon380, _polygon381, _polygon382, _polygon383, _polygon384, _polygon385, _polygon386, _polygon387, _polygon388, _polygon389, _polygon390, _polygon391, _polygon392, _polygon393, _polygon394, _polygon395, _polygon396, _polygon397, _polygon398, _polygon399, _polygon400, _polygon401, _polygon402, _polygon403, _polygon404, _polygon405, _polyline, _polygon406, _polygon407, _polygon408, _polygon409, _polygon410, _polygon411, _polygon412, _polygon413, _polygon414, _polygon415, _polygon416, _polygon417, _path5, _polygon418, _line3, _polygon419, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _polygon420, _path11, _polygon421, _polygon422, _polygon423, _polygon424, _polygon425, _polygon426, _polygon427, _polygon428, _polygon429, _polygon430, _polygon431, _polygon432, _polygon433, _polygon434, _polygon435, _polygon436, _polygon437, _polygon438, _polygon439, _polygon440, _polygon441, _polygon442, _path12, _polygon443, _path13, _polygon444, _polygon445, _polygon446, _polygon447, _polygon448, _path14, _path15, _path16, _polygon449, _path17, _polygon450, _polygon451, _polygon452, _polygon453, _polygon454, _polygon455, _polygon456, _polygon457, _path18, _polygon458, _path19, _polygon459, _polygon460, _path20, _path21, _path22, _polygon461, _polygon462, _polygon463, _polygon464, _path23, _polygon465, _path24, _path25, _polygon466, _polygon467, _path26, _polygon468, _polygon469, _polygon470, _polygon471, _path27, _polygon472, _polygon473, _polygon474, _polygon475, _polygon476, _path28, _polygon477, _path29, _polygon478, _polygon479, _polygon480, _polygon481, _polygon482, _polygon483, _polygon484, _polygon485, _polygon486, _polygon487, _polygon488, _polygon489, _polygon490, _polygon491, _polygon492, _polygon493, _path30, _polygon494, _polygon495, _polygon496, _polygon497, _polygon498, _polygon499, _path31, _polygon500, _polygon501, _polygon502, _polygon503, _polygon504, _polygon505, _polygon506, _polygon507, _polygon508, _polygon509, _polygon510, _polygon511, _polygon512, _polygon513, _polygon514, _path32, _path33, _polygon515, _polygon516, _polygon517, _polygon518, _path34, _path35, _polygon519, _polygon520, _polygon521, _polygon522, _polygon523, _polygon524, _polygon525, _polygon526, _polygon527, _polygon528, _polygon529, _polygon530, _polygon531, _path36, _path37, _polygon532, _polygon533, _polygon534, _polygon535, _polygon536, _polygon537, _polygon538, _polygon539, _polygon540, _polygon541, _polygon542, _polygon543, _polygon544, _polygon545, _polygon546, _polygon547, _polygon548, _polygon549, _polygon550, _polygon551, _polygon552, _polygon553, _path38, _polygon554, _polygon555, _path39, _path40, _path41, _polygon556, _path42, _polygon557, _path43, _polygon558, _polygon559, _polygon560, _path44, _polygon561, _polygon562, _polygon563, _polygon564, _path45, _path46, _path47, _polygon565, _polygon566, _polygon567, _polygon568, _polygon569, _polygon570, _path48, _polygon571, _polygon572, _polygon573, _path49, _polygon574, _path50, _polygon575, _polygon576, _polygon577, _polygon578, _polygon579, _polygon580, _polygon581, _polygon582, _polygon583, _path51, _polygon584, _polygon585, _polygon586, _polygon587, _polygon588, _polygon589, _polygon590, _polygon591, _polygon592, _polygon593, _polygon594, _polygon595, _polygon596, _polygon597, _polygon598, _polygon599, _polygon600, _polygon601, _polygon602, _polygon603, _polygon604, _polygon605, _polygon606, _polygon607, _polygon608, _polygon609, _polygon610, _polygon611, _polygon612, _polygon613, _path52, _polygon614, _polygon615, _polygon616, _polygon617, _polygon618, _polygon619, _polygon620, _path53, _polygon621, _polygon622, _polygon623, _polygon624, _path54, _polygon625, _polygon626, _polygon627, _polygon628, _path55, _path56, _polygon629, _polygon630, _polygon631, _path57, _polygon632, _polygon633, _polygon634, _polygon635, _polygon636, _path58, _polygon637, _polygon638, _polygon639, _polygon640, _polygon641, _path59, _polygon642, _polygon643, _path60, _path61, _polygon644, _polygon645, _polygon646, _path62, _polygon647, _polygon648, _polygon649, _path63, _polygon650, _polygon651, _polygon652, _polygon653, _polygon654, _polygon655, _path64, _polygon656, _polygon657, _path65, _path66, _path67, _path68, _polygon658, _path69, _polygon659, _polygon660, _polygon661, _polygon662, _polygon663, _polygon664, _polygon665, _polygon666, _polygon667, _polygon668, _polygon669, _polygon670, _polygon671, _polygon672, _polygon673, _polygon674, _path70, _polygon675, _path71, _polygon676, _path72, _polygon677, _path73, _path74, _polygon678, _polygon679, _polygon680, _polygon681, _polygon682, _polygon683, _polygon684, _polygon685, _polygon686, _polygon687, _polygon688, _polygon689, _polygon690, _path75, _polygon691, _polygon692, _polygon693, _polygon694, _path76, _polygon695, _polygon696, _polygon697, _polygon698, _polygon699, _polygon700, _polygon701, _polygon702, _path77, _path78, _polygon703, _polygon704, _path79, _polygon705, _polygon706, _polygon707, _polygon708, _polygon709, _polygon710, _polygon711, _polygon712, _polygon713, _polygon714, _polygon715, _path80, _polygon716, _polygon717, _polygon718, _polygon719, _polygon720, _path81, _polygon721, _polygon722, _polygon723, _polygon724, _polygon725, _polygon726, _polygon727, _polygon728, _polygon729, _path82, _polygon730, _path83, _polygon731, _polygon732, _polygon733, _polygon734, _polygon735, _polygon736, _path84, _path85, _polygon737, _polygon738, _polygon739, _polygon740, _path86, _path87, _polygon741, _polygon742, _path88, _polygon743, _polygon744, _path89, _path90, _polygon745, _polygon746, _polygon747, _polygon748, _polygon749, _path91, _polygon750, _polygon751, _polygon752, _polygon753, _polygon754, _polygon755, _polygon756, _polygon757, _path92, _polygon758, _polygon759, _path93, _path94, _path95, _polygon760, _polygon761, _polygon762, _polygon763, _polygon764, _polygon765, _polygon766, _polygon767, _polygon768, _polygon769, _polygon770, _polygon771, _polygon772, _polygon773, _polygon774, _polygon775, _path96, _polygon776, _polygon777, _polygon778, _polygon779, _polygon780, _polygon781, _polygon782, _path97, _path98, _path99, _polygon783, _polygon784, _polygon785, _path100, _polygon786, _path101, _polygon787, _path102, _polygon788, _polygon789, _polygon790, _polygon791, _path103, _path104, _polygon792, _polygon793, _polygon794, _polygon795, _polygon796, _path105, _path106, _path107, _path108, _path109, _polygon797, _polygon798, _path110, _polygon799, _polygon800, _polygon801, _path111, _path112, _polygon802, _polygon803, _polygon804, _polygon805, _polygon806, _polygon807, _polygon808, _path113, _polygon809, _path114, _polygon810, _path115, _polygon811, _polygon812, _polygon813, _polygon814, _polygon815, _polygon816, _polygon817, _polygon818, _polygon819, _path116, _polygon820, _path117, _polygon821, _polygon822, _polygon823, _polygon824, _polygon825, _polygon826, _path118, _polygon827, _path119, _polygon828, _polygon829, _polygon830, _polygon831, _polygon832, _polygon833, _path120, _polygon834, _path121, _polygon835, _polygon836, _polygon837, _polygon838, _polygon839, _polygon840, _polygon841, _polygon842, _polygon843, _path122, _polygon844, _polygon845, _polygon846, _polygon847, _polygon848, _polygon849, _polygon850, _polygon851, _polygon852, _polygon853, _path123, _polygon854, _polygon855, _polygon856, _polygon857, _polygon858, _polygon859, _polygon860, _polygon861, _polygon862, _polygon863, _polygon864, _polygon865, _polygon866, _polygon867, _polygon868, _polygon869, _polygon870, _path124, _polygon871, _polygon872, _polygon873, _polygon874, _path125, _polygon875, _polygon876, _polygon877, _polygon878, _polygon879, _polygon880, _path126, _polygon881, _polygon882, _polygon883, _polygon884, _polygon885, _polygon886, _path127, _polygon887, _polygon888, _path128, _polygon889, _polygon890, _polygon891, _polygon892, _polygon893, _polygon894, _polygon895, _polygon896, _polygon897, _polygon898, _polygon899, _polygon900, _polygon901, _polygon902, _polygon903, _polygon904, _polygon905, _polygon906, _polygon907, _polygon908, _polygon909, _polygon910, _polygon911, _polygon912, _polygon913, _polygon914, _polygon915, _polygon916, _polygon917, _polygon918, _polygon919, _polygon920, _path129, _polygon921, _polygon922, _path130, _polygon923, _polygon924, _polygon925, _path131, _polygon926, _polygon927, _polygon928, _polygon929, _polygon930, _polygon931, _polygon932, _polygon933, _polygon934, _polygon935, _polygon936, _polygon937, _polygon938, _polygon939, _path132, _polygon940, _path133, _polygon941, _polygon942, _polygon943, _polygon944, _polygon945, _polygon946, _path134, _polygon947, _polygon948, _polygon949, _path135, _path136, _path137, _polygon950, _polygon951, _polygon952, _polygon953, _polygon954, _polygon955, _polygon956, _polygon957, _polygon958, _polygon959, _path138, _polygon960, _polygon961, _polygon962, _polygon963, _polygon964, _polygon965, _polygon966, _polygon967, _path139, _polygon968, _polygon969, _polygon970, _polygon971, _path140, _polygon972, _path141, _polygon973, _path142, _polygon974, _polygon975, _polygon976, _polygon977, _path143, _polygon978;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewEcommbxLandingPageLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 830.8000488,
    height: 1061.399951,
    viewBox: "0 0 830.8000488 1061.399951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "413.4000244 841.900012 561.8000488 819.1000242 605.7000732 791.7999754 605.4837646 791.8502073 605.5473633 791.8123045 605.5999756 791.7999754 605.5916748 791.7859373 686.9000244 743.400012 686.8000488 743.400012 685.2015381 742.516284 686.9000244 743.400012 687 742.9999876 732.34375 691.6637449 732.4000244 691.6999998 779.6958008 637.5048704 779.8000488 637.4999876 779.7030029 637.4460325 779.8000488 637.4999876 829.4921875 495.3084593 829.7000732 494.9999876 829.0999756 431.900012 829.0991211 431.8998899 829.0999756 431.899951 829.0999756 431.900012 830.8000488 355.1999998 819.65271 312.6016722 819.7000732 312.5999632 812.2000732 287.5999632 779.7000732 207.4999876 779.6485596 207.5383177 691.9593506 102.6709471 692 102.6000242 563.5 26.2999754 413.6000366 .0000486 413.6062012 .104785 413.6000366 .0000486 258.4000244 31.0000486 258.4000244 31.0000486 145.2836914 95.9371824 145 95.9999876 145.1323853 96.0240355 145 96.1000242 145.2481689 96.0450315 145 96.1000242 145 96.4999876 91.4000244 161.9999876 91.4000244 162.0999632 50.2442017 212.1597776 49.9000244 212.400012 50.1051636 212.328845 50.0332031 212.4163694 49.8000488 212.4999876 49.8620605 212.6245604 49.8000488 212.6999998 49.8739624 212.6483641 49.8999634 212.7006712 19.7000122 273.2999754 .3000488 349.900012 .4251099 349.9544554 .4000244 349.900012 .3997192 349.9595823 .3887329 349.9617796 .3000488 349.900012 .3338013 349.972949 .2000122 349.9999876 .3987427 350.1383543 .0016479 422.5993528 0 422.5999632 .0016479 422.601428 0 422.900012 .2338257 422.8094358 0 422.900012 .2000122 495.0999632 .2778931 495.2045774 .2785034 495.2053709 23.604187 556.2491941 23.5 556.1999998 54.2327881 639.1486082 54.3000488 639.6000242 114 708.400012 114.0275879 708.3509398 144.8213501 744.7885618 144.9000244 745.1999998 145.1365356 745.2227049 234.2000122 800.6000242 234.1981201 800.4527464 234.2000122 800.6000242 271.3352661 817.9231443 271.4229736 817.9640379 271.4614868 817.9820433 271.4000244 817.9999876 413.4000244 841.900012",
    fill: "#c0ccd4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "19.7000122 273.2999754 .3000488 349.900012 52.1000366 339.4999876 19.7000122 273.2999754",
    fill: "#9db1b9"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "483 831.400012 559.5999756 802.6000242 503 776.7999754 483 831.400012",
    fill: "#9db1b9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m669.9000244,328.5999632l-61.9868164-13.0761108-.1217041-.0495605-15.7915039-47.4743042-4.3939209-54.8234253.0231934-.0091553,4.3707275,54.8325806,48.065918-8.9749756.4116211.1564331,40.6224365,42.7185669,36.1000977-13.6000366-.086792-.03302,19.5894775-48.6252441.1972656.0582886-.1356201-.2114258.0356445-.088562-.0819092.0166016-27.9180908-43.5166016-.1665039.1561279-42.1693115-49.1647339.0357666.008606-48.8056641-54.7940674.0057373-.0059204-.0125732-.00177-.0875244-.0982666.0307617.0903931-63.1307373-8.7904053-47.5999756,28.6000366,66.2547607,26.3422241.0004883.0003662-.0552979.057373.0073242.000061-30.2072754,32.5999756.0112305.0105591-31.9401855,39.8009644h-.0001221l31.9290771-39.8115234-64.4000244-8.7000122-41.2854614-22.9364014,30.9854736-63.963623-75.7999878,19.3000488-59.2999878,46.7999878,65.3999634-2.1000366.3641357.0018921.2406616.3824463-24.5541382,23.1790771-.350647-.0634155-.1364746,1.4660645.1259766-1.4453735.010498-.0206909-.0090942.0045166.0090942-.1044922-.0686035.1342163-57.2313843,28.5657959-71.7368164,31.9382935-25.8631592-43.3383179-69.3000488,12-76.0999756,68.5999756-21.7999878,78.9000244L.4251099,349.9544554l-.0250854-.0544434-.0003052.0595703-.0109863.0021973-.0886841-.0617676.0337524.072937-.1337891.0270386.1987305.1383667-.3987427,72.7616577.2000122,72.1999512.0784912.1054077,23.3256836,61.0438232-.104187-.0491943,30.800354,83.3942261-.0003052.0057983,22.5215454-35.9555054.0181885.0297241-22.5397339,35.9257812,52.0236206,3.9941406.076355.105835.041687-.1233521.1176147-.065918,25.2407227,33.3892822.147644-.1124878,70.852356,42.0124512,57.5999756,15.8000488,30.2999878-57.4000244-.3641968-.0076294.3621826.0059814.0020142.0016479,50,14.2000122,63.7999878-19.7000122.055542.0111084-.0415039.0128174-.0140381-.0239258-.0125122.0321045-63.6959839,19.6679077,29.9511108,67.0905151-.0426025.1094971-12.4525146,33.8709106-.2474976.1290894.211731-.0319214-.0117188.0319214.0809937-.0423584,58.1190186-8.7576904,31.4865723-38.0837402.0134277.0228271.005249-.0432739,50.8947754-40.895813-43.0841675-22.838562,52.5055542-83.3009033.0786133-.0604858-55.5-58.8000488-73.7000122-26.3999634-55.9342651,5.4837646-.0186157-.0630493.0062256-.0258789,55.9466553-5.3948364,36.5999756-31.8000488-34.0999756-13.2999878,22.5999756-33.7000122-.1411133-.2224121,18.9626465-39.4143677,30.5784912-9.2631836,53.340271-57.5357056.0596924.1356812.1026611-.1363525,75.4973145,23.7363892,46.8000488,24.5999756,51,27.5,36.0999756-43.4000244-46.5999756-32ZM132.7957153,628.5833006l-.7956543-39.916626.7996216,39.9144287-.0039673.0021973Zm-75.1958008-56.383606l-.0991211-97.4100342h0l.0992432,97.4103394,1.9464111-2.8031006-1.8776245,2.8004761-.0687866.0026245-.0001221.0020142v-.0021362l.0001221.0001221-.0001221-.0003052Zm184.4188843,64.8875122l-19.821106-12.3344727,19.9008789,12.3225098-.0797729.0119629Zm41.28125-56.5872192l-.0906982.0149536-.000061-.000061.0907593-.0148926-16.5449219-14.9307861,16.6448975,14.9307861,21.6761475,3.0001831-21.7405396-2.9680176-.0355835-.0321655Zm-41.6746826,52.7012329l-7.5228271-44.5862427.0263062-.0040283,99.9615479,37.9095459.0657959.0594482-99.8561401-37.8799438,7.3253174,44.5012207Zm-73.052124-230.3214722l15.9267578,39.0748291v.0999756l-15.9451294-39.1199951.0183716-.0548096Zm-51.6243286,92.5657349v.000061h-.000061v-.0001221l.000061.000061Zm.0355225.1784058l14.4299316,72.4439697-.026123-.0326538-14.4038696-72.4111938.000061-.0001221Zm14.9384155,73.0795898l3.7050171-2.2559204-3.6937256,2.2700195-.0112915-.0140991Zm36.463501-42.072876l-10.7060547-6.5356445,10.7300415,6.5080566-.0239868.0275879Zm-51.6478882-31.2608643l-58.1834106-20.9537964.0449829-.0159302-.0061646-.0054321,58.1447144,20.9750366-.0001221.0001221Zm-23.1033936,25.2854614l7.2415771,9.2404785-7.3228149-9.1534424.0812378-.0870361Zm140.5490112,67.9309692l-.0158691-.0137939,48.9626465-8.0446167.000061.000061-48.9468384,8.0583496Zm-49.7109985-173.0079346l.0269165-.0079956v.0297241l-.0269165-.0217285Zm.0942383-.0279541l60.4326782-17.9503174-60.4042358,17.9714966-.0284424-.0211792Zm148.1167603-170.8678589l18.0650024,24.3200684-18.0673828-24.2927246.0023804-.0273438Zm-20.5428467,52.5614624l14.5078735,15.999939-.0526123.0197754-14.4552612-16.0197144Zm103.4679565-32.887146l29.2456055,6.9611206-.0406494.013855-29.2049561-6.9749756Zm-35.4783325-8.1480713l-9.0076904,40.1880493-.0172119-.0231934,8.982666-40.175293.0422363.010437Zm-98.9407959,6.6237183l.0099487-.0324097,11.5339355-4.0760498-11.5438843,4.1084595Zm89.7225952,33.9620361l.0054321-.0084839.1409302,4.5765381-.1463623-4.5680542Zm-97.2001549-10.0880737l-.0124915-.0063477-.0333862.1099243-.0084839-.0032349-14.9338379-33.2736206,14.9881995,33.1732788Zm-156.7698158,208.4768066l-.0063477-.0128174,14.1896973-11.600708-14.1833496,11.6135254Zm15.2391968,74.6373901l18.3623657,38.517334-18.407959-38.5158081.0455933-.0015259Zm202.1143799,56.7799072l-.0012207-.0023193.0050049.0018921-.0075684-.0068359-.2469482-.4747925.2545166.4816284-.0037842.0004272Zm24.244751-44.9909058l-46.3696899,2.7802124-.2624512-.4286499,1.5665283-24.5751953,45.0462646,22.0756836.0507812.0896606-.0314331.0582886Zm-35.6173706-62.6654663l-29.0568848,36.1729126-31.166748-19.4169922-15.9143066,11.7628174-.1152344-.0187378-.2704468-.2440796-.0427246.1427002-25.2572632-33.8427124,23.6726685-52.9388428.1273193.0388184-.1084595-.0809937.0084839-.0189819-.057373-.0175171-12.130127-9.0574341,12.1875,9.0749512,60.4411621-60.3416138,2.9588013,68.8416138.1133423-.0643311-26.6133423,41.6643677,41.2236328,8.3440552Zm-67.7893677-170.2077026l.0010376-.0005493,50.0824585,50.8775024h0l-50.0834961-50.8769531Zm116.0469971-52.02771l.0925293.0263672,6.2102661,11.3718262-6.3027954-11.3981934Zm148.0670166-61.2069092l-8.2969971-24.5501709.1738281.1245117,8.1231689,24.4256592Zm-274.3513184-11.9785156l-53.296936,3.0767212,53.3973999-3.1878662-.1973877.0878906.0969238.0232544Zm-110.2205811,68.954834l-32.7665405,20.6893921-.0084229-.0578003,32.798584-20.7096558-.0236206.078064Zm10.5402832,179.3086548l-5.7290039-3.5384521,5.7593384,3.5350342-.0303345.003418Zm310.3303833,209.9094238l-.0471191.1295166-15.7675781-61.0162964,15.8146973,60.8867798Zm-31.6113892-346.8731689l22.1220093-16.7636108.0952759.0271606-.019104.0631104-22.1981812,16.6733398Zm47.6433716-87.1156006v-.000061l35.3258667,80.3763428-.0129395-.0021973-35.3129272-80.3740845Zm113.7684937-34.6836548l2.2756348.0679932.0002441.0027466-2.2758789-.0707397Zm-12.0020752-74.6345825l10.9080811,21.4177246-10.9882812-21.4795532.0802002.0618286Zm162.7570801,101.1520996l-36.689209-10.9093628,36.8433838,10.8781738-.1541748.031189Zm-102.5025635-100.5412598l74.9229736,57.15979-.0753174.0706787-74.8476562-57.2304688-15.973877-46.8232422.0251465-.026062,15.9487305,46.8493042Zm-46,73.7999878l.0014648.0187378-3.6601562-3.4481812,3.6586914,3.4294434Zm-483.1159058,118.0946045l6.2822876,42.776001-.005249.0181885-.0610962.0112305.0317993.0900269-.0317993.1099854.0662842-.0123291.0006104.0016479-23.1032104,62.3388672-.0424805-.0855713,23.0787964-62.442627s-14.9488525,8.4289551-27.0758667,15.2341919l27.0758667-15.2341919-6.2159424-42.8054199Zm-77.5455933,76.552002l1.9285889,4.1662598-.0061035.0023804-1.9224854-4.1686401Zm30.6049805,164.6774292l.0369873.1150513-22.6876221-30.5395508,22.6506348,30.4244995Zm49.3279419,71.211792l.0238037-.0133667,62.5645752,4.7593384.0174561.0089111-62.605835-4.7548828Zm347.4143066,38.3018799l.1453857.0680542-49.8602905-9.9525146.0140991-.0362549,49.7008057,9.9207153Zm-24.7269897-99.8621216l-.0056763.024231-.1233521-.0005493-66.8084106-39.5205078,66.937439,39.4968262Zm-121.0043945-112.9766235l19.6739502-11.1644897-19.4494019,11.1629639-.2245483.0015259Zm65.4568481-81.7813721l.0292358.0048218,4.815918,7.631958-4.8451538-7.6367798Zm138.2623901-65.7263184l-4.9890137,6.6953125-.0626221.0184937,5.0516357-6.7138062Z",
    fill: "#475d6a"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "324.5 732.6999998 370.7000122 758.6000242 340.7000122 691.400012 324.5 732.6999998",
    fill: "#9db1b9"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "92.8000488 519.7999754 132.8000488 569.7999754 57.6000366 572.2999754 92.8000488 519.7999754",
    fill: "#2c3d43"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "57.5 473.9999876 57.6000366 572.2999754 40.4000244 518.7999754 57.5 473.9999876",
    fill: "#2c3d43"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 422.900012 .2000122 495.0999937 58.6000366 474.400012 0 422.900012",
    fill: "#2c3d43"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "68.4000244 397.400012 87.6000366 436.0999937 57.5 474.3000059 68.4000244 397.400012",
    fill: "#2c3d43"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "52.1000366 339.4999876 19.7000122 273.3000059 .3000488 349.900012 52.1000366 339.4999876",
    fill: "#768c94"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "29 411.900012 .3000488 349.900012 68.6000366 397.4999876 29 411.900012",
    fill: "#768c94"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: ".2000122 349.9999876 52.1000366 339.4999876 68.4000244 397.4999876 .2000122 349.9999876",
    fill: "#5f7a86"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "28.8000488 411.6999998 57.5 474.400012 68.4000244 397.4999876 28.8000488 411.6999998",
    fill: "#475d6a"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "57.5 473.9999876 57.6000366 572.1999998 93.5 520.4999876 57.5 473.9999876",
    fill: "#475d6a"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "57.6000366 572.1999998 77.1000366 604.1000242 132.8000488 569.2999754 57.6000366 572.1999998",
    fill: "#475d6a"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.6000366 568.900012 178.9000244 540.1000242 168.5 526.4999876 131.6000366 568.900012",
    fill: "#475d6a"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "57.5 473.9999876 40.4000244 518.7999754 .2000122 495.0999937 57.5 473.9999876",
    fill: "#3a4a54"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: ".2000122 494.9999876 23.7000122 556.4999876 57.7000122 572.400012 .2000122 494.9999876",
    fill: "#475d6a"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "23.5 556.1999998 54.3003302 639.5942776 57.6000366 572.2999754 23.5 556.1999998",
    fill: "#43545b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m77.2000122,603.1000242l29.2000122,40.5-52.0999756-4,22.8999634-36.5Z",
    fill: "#6c8289"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "133.3000488 628.2999754 169.7000122 648.1000242 106.6000366 643.2999754 133.3000488 628.2999754",
    fill: "#6c8289"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "54.3000488 639.6000242 114 708.400012 131.8000488 676.6999998 54.3000488 639.6000242",
    fill: "#b9c6cd"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "113.9000244 708.1999998 145 744.9999876 131.8000488 676.6999998 113.9000244 708.1999998",
    fill: "#b0bdc5"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "77.1000366 603.1000242 131.7000122 568.7999754 106.4000244 643.6999998 77.1000366 603.1000242",
    fill: "#344851"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: ".4000244 349.900012 28.9000244 411.6999998 0 422.900012 .4000244 349.900012",
    fill: "#3c505a"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "19.7000122 273.3000059 73.9000244 260.5999937 52.1000366 339.4999876 19.7000122 273.3000059",
    fill: "#c4d1d8"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "49.8000488 212.5000029 112 190.1999998 74 261.0999937 49.8000488 212.5000029",
    fill: "#c4d1d8"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "73.9000244 260.5999937 131.3000488 273.400012 52.1000366 339.4999876 73.9000244 260.5999937",
    fill: "#88a0ab"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "52.1000366 339.4999876 110.7000122 373.6999998 101.9000244 313.0999937 52.1000366 339.4999876",
    fill: "#b0bec7"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "101.6000366 313.3000059 131.3000488 273.400012 134.7000122 292.400012 101.6000366 313.3000059",
    fill: "#b0bec7"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.3000488 273.400012 52.1000366 339.4999876 101.6000366 313.3000059 131.3000488 273.400012",
    fill: "#a1b6be"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "101.7000122 313.3000059 134.8000488 292.400012 121.4000244 336.400012 101.7000122 313.3000059",
    fill: "#57737f"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "52.1000366 339.4999876 68.4000244 397.4999876 110.7000122 373.6999998 52.1000366 339.4999876",
    fill: "#96aab3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m110.7000122,373.6999998l-23.0999756,62.5s-20-38.3999939-19.2000122-38.7999878c.7999878-.3000183,42.2999878-23.7000122,42.2999878-23.7000122Z",
    fill: "#637f8d"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "101.9000244 313.3000059 121.6000366 336.400012 110.8000488 373.900012 101.9000244 313.3000059",
    fill: "#637f8d"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "110.7000122 373.6999998 168.6000366 402.8000059 145.4000244 471.900012 110.7000122 373.6999998",
    fill: "#556c7b"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "121.5 336.3000059 194.2000122 341.4999876 164.5 363.9999876 121.5 336.3000059",
    fill: "#556c7b"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    points: "110.7000122 373.6999998 164.5 363.8000059 168.6000366 402.8000059 110.7000122 373.6999998",
    fill: "#4a6371"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    points: "168.5 402.6999998 184.5 415.5999937 184.6000366 442.1999998 168.5 402.6999998",
    fill: "#4a6371"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    points: "134.7000122 292.400012 181.8000488 299.9999876 121.4000244 336.400012 134.7000122 292.400012",
    fill: "#3e545f"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    points: "194 341.5999937 199.3000488 367.6999998 164.4000244 363.900012 194 341.5999937",
    fill: "#3e545f"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    points: "164.5 363.9999876 184.4000244 415.5999937 168.5 402.8000059 164.5 363.9999876",
    fill: "#3e545f"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "199.3000488 367.5999937 245 397.5999937 184.4000244 415.5999937 199.3000488 367.5999937",
    fill: "#324650"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    points: "168.5 402.8000059 184.6000366 442.3000059 145.4000244 471.8000059 168.5 402.8000059",
    fill: "#324650"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    points: "110.8000488 373.8000059 145.6000366 471.9999876 87.6000366 436.400012 110.8000488 373.8000059",
    fill: "#4f6974"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    points: "28.9000244 411.5999937 57.6000366 474.1999998 0 422.900012 28.9000244 411.5999937",
    fill: "#4f6974"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    points: "145.4000244 471.900012 116.9000244 495.1999998 87.6000366 436.1999998 145.4000244 471.900012",
    fill: "#66828f"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    points: "117.1000366 495.4999876 57.5 473.9999876 87.6000366 436.0999937 117.1000366 495.4999876",
    fill: "#3c505a"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    points: "116.9000244 495.1999998 93.2000122 520.1000242 131.6000366 569.1000242 116.9000244 495.1999998",
    fill: "#6b8490"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    points: "116.9000244 495.1999998 168.5 526.6999998 131.6000366 568.9999876 116.9000244 495.1999998",
    fill: "#587480"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    points: "57.4000244 473.9999876 117.1000366 495.4999876 93.5 520.7999754 57.4000244 473.9999876",
    fill: "#587480"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    points: ".2000122 495.0999937 40.4000244 518.6999998 57.6000366 572.1999998 .2000122 495.0999937",
    fill: "#587480"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    points: "116.8000488 495.3000059 145.5 471.8000059 168.9000244 526.900012 116.8000488 495.3000059",
    fill: "#627d89"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.8000488 676.6999998 202.8000488 718.7999754 144.9000244 745.1999998 131.8000488 676.6999998",
    fill: "#a0aeb7"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    points: "54.3000488 639.6000242 106.6000366 643.400012 131.8000488 676.900012 54.3000488 639.6000242",
    fill: "#a0aeb7"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.8000488 718.7999754 169.6000366 648.1000242 131.8000488 676.6999998 202.8000488 718.7999754",
    fill: "#3c505a"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    points: "224 675.9999876 242.6000366 636.9999876 169.3000488 647.9999876 224 675.9999876",
    fill: "#3c505a"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    points: "132.8000488 628.7999754 131.6000366 568.6000242 106.4000244 643.6000242 132.8000488 628.7999754",
    fill: "#3c505a"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    points: "177.5 597.2999754 178.5 540.1000242 131.8000488 568.7999754 177.5 597.2999754",
    fill: "#3c505a"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.8000488 718.7999754 224 675.900012 169.5 647.900012 202.8000488 718.7999754",
    fill: "#344851"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.8000488 676.900012 169.6000366 648.1000242 106.4000244 643.2999754 131.8000488 676.900012",
    fill: "#344851"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    points: "290.8000488 677.1999998 242.5 636.900012 223.9000244 676.1000242 290.8000488 677.1999998",
    fill: "#344851"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    points: "242.3000488 637.1999998 234.1000366 588.6000242 177.7000122 597.1999998 242.3000488 637.1999998",
    fill: "#516b77"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    points: "234.1000366 588.6000242 234.1000366 588.6000242 221.1000366 513.4999876 178.2000122 540.1000242 234.1000366 588.6000242",
    fill: "#607a86"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.8000488 718.7999754 233.5 753.6999998 144.9000244 745.1999998 202.8000488 718.7999754",
    fill: "#bdcad2"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    points: "292 772.6000242 271.5 817.9999876 234.2000122 800.6000242 292 772.6000242",
    fill: "#b9c6cd"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    points: "233.6000366 753.6999998 234.2000122 800.6000242 145.1000366 745.1999998 233.6000366 753.6999998",
    fill: "#b9c6cd"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.8000488 718.6999998 261.1000366 734.7999754 233.6000366 753.7999754 202.8000488 718.6999998",
    fill: "#d2dddf"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    points: "260.4000244 734.6000242 358.2000122 792.6000242 292.1000366 772.6000242 260.4000244 734.6000242",
    fill: "#b9c6cd"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    points: "223.9000244 675.7999754 260.4000244 734.6000242 202.8000488 718.7999754 223.9000244 675.7999754",
    fill: "#526671"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    points: "177.7000122 597.1999998 169.5 648.1000242 131.6000366 568.6000242 177.7000122 597.1999998",
    fill: "#526671"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.4000244 792.6000242 340.3000488 830.1000242 271.4000244 817.9999876 358.4000244 792.6000242",
    fill: "#b7c6cd"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.3000488 792.6000242 413.5 841.900012 340.3000488 830.1999998 358.3000488 792.6000242",
    fill: "#c5cfd6"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    points: "260.5 734.6000242 234.2000122 800.2999754 233.4000244 753.7999754 260.5 734.6000242",
    fill: "#c5cfd6"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.2000122 792.6000242 455.7000122 811.1000242 413.4000244 841.900012 358.2000122 792.6000242",
    fill: "#b7c6cd"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    points: "416.2000122 783.6000242 447.9000244 745.6999998 455.7000122 811.1000242 416.2000122 783.6000242",
    fill: "#adbfc9"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.2000122 792.6000242 324.5 732.6999998 370.7000122 758.6000242 358.2000122 792.6000242",
    fill: "#b9c6ce"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.7000122 758.6000242 358.2000122 792.6000242 447.9000244 745.6999998 370.7000122 758.6000242",
    fill: "#4f6570"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    points: "324.5 732.6999998 260.4000244 734.6000242 358.2000122 792.6000242 324.5 732.6999998",
    fill: "#a0b3ba"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    points: "324.5 732.6999998 290.7000122 677.1999998 260.4000244 734.6000242 324.5 732.6999998",
    fill: "#a5b8c1"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    points: "290.7000122 677.1999998 223.9000244 675.7999754 260.4000244 734.6000242 290.7000122 677.1999998",
    fill: "#4b636e"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    points: "169.5 647.9999876 131.6000366 568.6999998 132.8000488 628.6000242 169.5 647.9999876",
    fill: "#4b636e"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    points: "77.1000366 603.1999998 57.6000366 572.1999998 54.3000488 639.6000242 77.1000366 603.1999998",
    fill: "#4b636e"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.2000122 539.900012 234.2000122 588.6000242 177.5 597.2999754 178.2000122 539.900012",
    fill: "#4d6772"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    points: "177.6000366 596.9999876 242.2000122 637.1999998 169.5 647.9999876 177.6000366 596.9999876",
    fill: "#4d6772"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    points: "447.9000244 745.6999998 498.8000488 704.7999754 503 776.7999754 447.9000244 745.6999998",
    fill: "#c0ccd4"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    points: "503 776.7999754 455.7000122 811.1000242 447.9000244 745.6999998 503 776.7999754",
    fill: "#bccad1"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    points: "503 776.7999754 559.5999756 802.6000242 483 831.400012 503 776.7999754",
    fill: "#adbfc9"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    points: "455.7000122 811.1000242 413.4000244 841.900012 483.2000732 831.1999998 455.7000122 811.1000242",
    fill: "#d3dae0"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    points: "416.6000366 783.9999876 357.6000366 792.6000242 455.8000488 811.1000242 416.6000366 783.9999876",
    fill: "#d3dae0"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    points: "260.4000244 734.6000242 234.1000366 800.4999876 292 772.6000242 260.4000244 734.6000242",
    fill: "#d3dae0"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    points: "559.5999756 802.6000242 483 831.2999754 561.8000488 819.1000242 559.5999756 802.6000242",
    fill: "#d3dae0"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    points: "605.4000244 791.900012 588.0999756 762.6999998 686.9000244 743.400012 605.4000244 791.900012",
    fill: "#e5eaed"
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    points: "561.8000488 819.1000242 559.5999756 802.4999876 605.7000732 791.7999754 561.8000488 819.1000242",
    fill: "#e5eaed"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    points: "588.0999756 762.6000242 645 721.6000242 686.8000488 743.400012 588.0999756 762.6000242",
    fill: "#f5f7f9"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    points: "557.4000244 774.400012 554.5 720.6999998 588.4000244 762.6000242 557.4000244 774.400012",
    fill: "#f5f7f9"
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    points: "584.4000244 645.9999876 571.4000244 668.7999754 616.4000244 700.400012 584.4000244 645.9999876",
    fill: "#e5eaed"
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    points: "588.2000732 762.6000242 557.4000244 774.400012 559.7000732 802.6000242 588.2000732 762.6000242",
    fill: "#d7dfe2"
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    points: "559.7000732 802.6000242 557.5 774.400012 503 776.7999754 559.7000732 802.6000242",
    fill: "#e5eaed"
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    points: "483.2000732 831.1999998 503 776.7999754 455.7000122 811.1999998 483.2000732 831.1999998",
    fill: "#e5eaed"
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    points: "271.3000488 817.9999876 358.2000122 792.6000242 292.1000366 772.6000242 271.3000488 817.9999876",
    fill: "#e5eaed"
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    points: "616.3000488 700.400012 554.5 720.7999754 588.2000732 762.6000242 616.3000488 700.400012",
    fill: "#dfe6ec"
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    points: "554.5 720.7999754 503 776.7999754 557.5 774.400012 554.5 720.7999754",
    fill: "#ccd5db"
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    points: "554.5 720.7999754 498.8000488 704.7999754 503 776.7999754 554.5 720.7999754",
    fill: "#cfd7de"
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    points: "687 742.9999876 700.7000732 671.1999998 732.4000244 691.6000242 687 742.9999876",
    fill: "#d7dee2"
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    points: "732.4000244 691.6999998 700.7000732 671.2999754 779.7000732 637.4999876 732.4000244 691.6999998",
    fill: "#f3f4f6"
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    points: "700.7000732 671.1999998 645 721.6000242 686.9000244 743.400012 700.7000732 671.1999998",
    fill: "#ebeff1"
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    points: "619.9000244 606.6000242 616.3000488 700.400012 661.0999756 621.1999998 619.9000244 606.6000242",
    fill: "#e5eaed"
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    points: "542.0999756 620.9999876 515.8000488 655.6000242 584.3000488 646.2999754 542.0999756 620.9999876",
    fill: "#e5eaed"
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    points: "645 721.6000242 616.4000244 700.2999754 588.3000488 762.4999876 645 721.6000242",
    fill: "#e5eaed"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    points: "700.7000732 671.2999754 653.0999756 671.900012 645 721.6000242 700.7000732 671.2999754",
    fill: "#e5eaed"
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    points: "700.7000732 671.2999754 711.2000732 640.6000242 653.4000244 671.7999754 700.7000732 671.2999754",
    fill: "#f3f4f6"
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    points: "605.5999756 791.7999754 588.2000732 762.400012 559.5999756 802.6000242 605.5999756 791.7999754",
    fill: "#f3f4f6"
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    points: "653.4000244 671.6999998 616.3000488 700.400012 645 721.6000242 653.4000244 671.6999998",
    fill: "#d7dee2"
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    points: "620.0999756 606.6000242 584.2000732 645.7999754 616.3000488 700.400012 620.0999756 606.6000242",
    fill: "#dee5eb"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 619.3000488,
    y1: 605.7999754,
    x2: 616.3000488,
    y2: 700.400012,
    fill: "none"
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    points: "783.5999756 563.6000242 722.7000732 605.7999754 779.7000732 637.4999876 783.5999756 563.6000242",
    fill: "#f2f4fa"
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    points: "711.2000732 640.6000242 700.7000732 671.2999754 779.5999756 637.4999876 711.2000732 640.6000242",
    fill: "#dee5eb"
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    points: "661.3000488 620.900012 616.2000732 700.4999876 653.4000244 671.6999998 661.3000488 620.900012",
    fill: "#dee5eb"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 571.5,
    y1: 668.7999754,
    x2: 616.3000488,
    y2: 700.400012,
    fill: "none"
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    points: "571.5 668.7999754 554.5 720.7999754 616.3000488 700.400012 571.5 668.7999754",
    fill: "#dee6e9"
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    points: "553.9000244 580.900012 542 621.1999998 620.0999756 606.6999998 553.9000244 580.900012",
    fill: "#dee6e9"
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    points: "515.8000488 655.6000242 571.5999756 668.7999754 584.3000488 646.1999998 515.8000488 655.6000242",
    fill: "#dee6e9"
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    points: "554.5 720.7999754 515.8000488 655.6000242 498.8000488 704.7999754 554.5 720.7999754",
    fill: "#dae0e7"
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    points: "515.8000488 655.6000242 571.5 668.7999754 554.5 720.7999754 515.8000488 655.6000242",
    fill: "#e9ecee"
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    points: "619.9000244 606.6999998 542.2000732 620.9999876 584.3000488 646.1999998 619.9000244 606.6999998",
    fill: "#d7dfe2"
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    points: "722.9000244 605.900012 779.8000488 637.4999876 711.2000732 640.6999998 722.9000244 605.900012",
    fill: "#d7dee2"
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    points: "661.0999756 621.1999998 711.3000488 640.6000242 653.3000488 671.9999876 661.0999756 621.1999998",
    fill: "#d7dee2"
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    points: "698.0999756 552.1000242 722.9000244 605.9999876 660.9000244 621.4999876 698.0999756 552.1000242",
    fill: "#d7dee2"
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    points: "783.5999756 563.6999998 788.7000732 492.4999876 727.5 552.2999754 783.5999756 563.6999998",
    fill: "#e5eaed"
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    points: "736.7000732 497.4999876 710 452.0999937 698.0999756 552.1000242 736.7000732 497.4999876",
    fill: "#e5eaed"
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    points: "711.5 640.6999998 722.9000244 605.7999754 661 621.400012 711.5 640.6999998",
    fill: "#e5eaed"
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    points: "698 552.400012 710 452.0999937 682 500.0999937 698 552.400012",
    fill: "#f2f4fa"
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    points: "779.8000488 637.4999876 829.5999756 494.9999876 783.4000244 563.7999754 779.8000488 637.4999876",
    fill: "#e5eaed"
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    points: "722.9000244 605.7999754 783.5999756 563.6999998 727.5999756 552.2999754 722.9000244 605.7999754",
    fill: "#ebeff1"
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    points: "697.9000244 552.2999754 727.9000244 552.2999754 736.5 497.0999937 697.9000244 552.2999754",
    fill: "#ebeff1"
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    points: "788.7000732 492.5999937 829.0999756 431.900012 783.5999756 425.4999876 788.7000732 492.5999937",
    fill: "#ebeff1"
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    points: "736.8000488 497.9999876 754.7000732 431.1999998 709.9000244 452.3000059 736.8000488 497.9999876",
    fill: "#ebeff1"
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    points: "682 500.400012 710.0999756 452.0999937 680.3000488 403.9999876 682 500.400012",
    fill: "#ebeff1"
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    points: "590.4000244 542.1999998 619.7000732 547.400012 621.0999756 490.6999998 590.4000244 542.1999998",
    fill: "#ebeff1"
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.9000244 514.4999876 560.7000732 499.8000059 549.0999756 465.4999876 499.9000244 514.4999876",
    fill: "#ebeff1"
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    points: "508.4000244 598.6999998 542.2000732 620.7999754 554.2000732 580.7999754 508.4000244 598.6999998",
    fill: "#ebeff1"
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    points: "620.0999756 606.7999754 619.8000488 547.400012 554 580.9999876 620.0999756 606.7999754",
    fill: "#d8e0e7"
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    points: "554.0999756 580.9999876 590.5 541.9999876 524.9000244 542.1999998 554.0999756 580.9999876",
    fill: "#d8e0e7"
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    points: "829.0999756 431.900012 788.7000732 492.4999876 829.7000732 494.9999876 829.0999756 431.900012",
    fill: "#d2dbe4"
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    points: "788.7000732 492.4999876 736.5 497.3000059 727.5 552.2999754 788.7000732 492.4999876",
    fill: "#cad8df"
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    points: "639.2000732 533.1999998 619.7000732 546.900012 620 606.900012 639.2000732 533.1999998",
    fill: "#cad8df"
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    points: "783.5999756 425.4999876 754.8000488 431.3000059 788.7000732 492.4999876 783.5999756 425.4999876",
    fill: "#d5dde4"
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    points: "779.7000732 207.5000029 736.8000488 239.3999968 786.3000488 314.0999937 779.7000732 207.5000029",
    fill: "#ebeff1"
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    points: "691.9000244 102.6000013 666.5 147.0000029 708.8000488 196.5000029 691.9000244 102.6000013",
    fill: "#ebeff1"
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    points: "830.8000488 355.1999998 750.5 376.400012 783.5 425.6999998 830.8000488 355.1999998",
    fill: "#ebeff1"
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    points: "812.2000732 287.5999937 786.0999756 313.8000059 819.7000732 312.5999937 812.2000732 287.5999937",
    fill: "#ebeff1"
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    points: "786.3000488 314.0999937 779.7000732 207.5000029 812.2000732 287.5999937 786.3000488 314.0999937",
    fill: "#cdd7e0"
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    points: "830.8000488 355.1999998 786.3000488 313.900012 819.5999756 312.400012 830.8000488 355.1999998",
    fill: "#cdd7e0"
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    points: "786.0999756 313.5999937 750.5999756 376.400012 830.8000488 355.1999998 786.0999756 313.5999937",
    fill: "#d5dde4"
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    points: "750.5999756 376.400012 710 452.3000059 754.7000732 431.1999998 750.5999756 376.400012",
    fill: "#cad2d8"
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    points: "779.7000732 207.5999937 708.8000488 196.5000029 736.5 239.6999998 779.7000732 207.5999937",
    fill: "#cdd7e0"
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    points: "717.2000732 288.3000059 681.0999756 301.900012 750.5999756 376.400012 717.2000732 288.3000059",
    fill: "#d5dde4"
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    points: "783.5999756 425.4999876 750.4000244 376.4999876 754.7000732 431.3000059 783.5999756 425.4999876",
    fill: "#dee5eb"
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    points: "727.5 552.2999754 698.0999756 552.1000242 722.9000244 606.1999998 727.5 552.2999754",
    fill: "#dee5eb"
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    points: "682.2000732 500.0999937 620.9000244 490.5999937 639.3000488 533.1000242 682.2000732 500.0999937",
    fill: "#dee5eb"
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    points: "698.0999756 552.1000242 620 606.6000242 661.0999756 621.1999998 698.0999756 552.1000242",
    fill: "#dee5eb"
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    points: "681.0999756 301.8000059 669.9000244 328.5999937 716.5 360.6999998 681.0999756 301.8000059",
    fill: "#d5dde4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m750.5999756,376.400012l-70.1999512,27.6000061,36.0999756-43.3999939c0-.0000305,34.9000244,15.7999878,34.0999756,15.7999878Z",
    fill: "#93a9b0"
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    points: "750.5999756 376.400012 716.5 360.5999937 681 301.5999937 750.5999756 376.400012",
    fill: "#dee5eb"
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    points: "716.5 360.5999937 680.4000244 403.9999876 669.9000244 328.5999937 716.5 360.5999937",
    fill: "#7791a0"
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    points: "680.4000244 403.9999876 710 452.3000059 750.5999756 376.400012 680.4000244 403.9999876",
    fill: "#c0ccd4"
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    points: "717.2000732 288.3000059 750.5 376.4999876 786.0999756 313.6999998 717.2000732 288.3000059",
    fill: "#c0ccd4"
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    points: "500.0999756 514.6000242 445.3000488 454.900012 452.8000488 539.900012 500.0999756 514.6000242",
    fill: "#c9d1d9"
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    points: "590 423.6999998 527.2000732 413.4999876 548.9000244 465.400012 590 423.6999998",
    fill: "#cbd4da"
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    points: "548.9000244 465.3000059 590 423.6999998 560.5 499.8000059 548.9000244 465.3000059",
    fill: "#d7dfe2"
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    points: "481.7000732 438.8000059 527.2000732 413.3000059 549.0999756 465.4999876 481.7000732 438.8000059",
    fill: "#d7dfe2"
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    points: "680.4000244 403.9999876 629.4000244 376.4999876 590 423.8000059 680.4000244 403.9999876",
    fill: "#e0e8eb"
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    points: "590 423.6999998 582.5999756 351.8000059 527.5 413.4999876 590 423.6999998",
    fill: "#e0e8eb"
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    points: "527.3000488 413.6999998 506.9000244 328.0999937 475.4000244 413.0999937 527.3000488 413.6999998",
    fill: "#e0e8eb"
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    points: "621 490.8000059 589.9000244 423.6999998 560.5 499.900012 621 490.8000059",
    fill: "#e0e8eb"
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    points: "590.3000488 541.9999876 560.5 499.8000059 524.9000244 542.2999754 590.3000488 541.9999876",
    fill: "#e0e8eb"
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    points: "680.4000244 403.9999876 669.9000244 328.5999937 629.4000244 376.4999876 680.4000244 403.9999876",
    fill: "#88a0ac"
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    points: "640.2000732 258.9999876 592 267.9999876 670 328.9999876 640.2000732 258.9999876",
    fill: "#a9bac3"
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    points: "736.8000488 239.3999968 640 258.9999876 717.0999756 288.3000059 736.8000488 239.3999968",
    fill: "#a9bac3"
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    points: "640.0999756 258.900012 669.9000244 328.900012 681.0999756 301.900012 640.0999756 258.900012",
    fill: "#c1ced6"
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    points: "592 267.9999876 607.8000488 315.5999937 669.4000244 328.400012 592 267.9999876",
    fill: "#bdcad2"
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    points: "607.8000488 315.4999876 629.4000244 376.4999876 669.9000244 328.5999937 607.8000488 315.4999876",
    fill: "#a1b3bc"
  })), _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    points: "607.8000488 315.4999876 582.5999756 351.900012 629.4000244 376.4999876 607.8000488 315.4999876",
    fill: "#8198a7"
  })), _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    points: "582.5999756 351.900012 590 423.8000059 629.4000244 376.4999876 582.5999756 351.900012",
    fill: "#ced5db"
  })), _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    points: "475.4000244 413.0999937 445.2000122 455.0999937 482 438.8000059 475.4000244 413.0999937",
    fill: "#dee5eb"
  })), _polygon179 || (_polygon179 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.9000244 394.900012 404.2000122 434.4999876 445.6000366 455.0999937 422.9000244 394.900012",
    fill: "#dee5eb"
  })), _polygon180 || (_polygon180 = /*#__PURE__*/React.createElement("polygon", {
    points: "445.6000366 454.9999876 381.5 468.3000059 415.7000122 481.8000059 445.6000366 454.9999876",
    fill: "#dee5eb"
  })), _polygon181 || (_polygon181 = /*#__PURE__*/React.createElement("polygon", {
    points: "482 438.8000059 445.4000244 454.9999876 500 514.6000242 482 438.8000059",
    fill: "#c0ccd4"
  })), _polygon182 || (_polygon182 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.8000488 514.2999754 508.3000488 598.6000242 525 542.2999754 499.8000488 514.2999754",
    fill: "#b9c9d0"
  })), _polygon183 || (_polygon183 = /*#__PURE__*/React.createElement("polygon", {
    points: "508.3000488 598.6000242 515.8000488 655.6000242 542.2000732 620.7999754 508.3000488 598.6000242",
    fill: "#bcc9d1"
  })), _polygon184 || (_polygon184 = /*#__PURE__*/React.createElement("polygon", {
    points: "508.3000488 598.6000242 429.6000366 581.7999754 477.1000366 622.6000242 508.3000488 598.6000242",
    fill: "#58737e"
  })), _polygon185 || (_polygon185 = /*#__PURE__*/React.createElement("polygon", {
    points: "429.6000366 581.7999754 455.6000366 681.900012 477.1000366 622.4999876 429.6000366 581.7999754",
    fill: "#5d7883"
  })), _polygon186 || (_polygon186 = /*#__PURE__*/React.createElement("polygon", {
    points: "455.6000366 681.900012 498.8000488 704.7999754 515.8000488 655.6000242 455.6000366 681.900012",
    fill: "#cfd7de"
  })), _polygon187 || (_polygon187 = /*#__PURE__*/React.createElement("polygon", {
    points: "455.6000366 681.900012 447.9000244 745.6999998 498.8000488 704.7999754 455.6000366 681.900012",
    fill: "#8fa3ae"
  })), _polygon188 || (_polygon188 = /*#__PURE__*/React.createElement("polygon", {
    points: "515.8000488 655.6000242 477.1000366 622.4999876 508.2000732 598.4999876 515.8000488 655.6000242",
    fill: "#8fa3ae"
  })), _polygon189 || (_polygon189 = /*#__PURE__*/React.createElement("polygon", {
    points: "455.6000366 681.9390865 404.5 671.7390743 447.9000244 745.7390743 455.6000366 681.9390865",
    fill: "#68828d"
  })), _polygon190 || (_polygon190 = /*#__PURE__*/React.createElement("polygon", {
    points: "447.9000244 745.6999998 416.4000244 783.7999754 358 792.6000242 447.9000244 745.6999998",
    fill: "#68828d"
  })), _polygon191 || (_polygon191 = /*#__PURE__*/React.createElement("polygon", {
    points: "404.5 671.6999998 370.7000122 758.6000242 447.9000244 745.6999998 404.5 671.6999998",
    fill: "#90a7af"
  })), _polygon192 || (_polygon192 = /*#__PURE__*/React.createElement("polygon", {
    points: "404.5914632 671.6999998 340.7914754 691.400012 370.7914754 758.6000242 404.5914632 671.6999998",
    fill: "#485c65"
  })), _polygon193 || (_polygon193 = /*#__PURE__*/React.createElement("polygon", {
    points: "340.7000122 691.400012 324.5 732.6999998 370.7000122 758.6000242 340.7000122 691.400012",
    fill: "#4f6570"
  })), _polygon194 || (_polygon194 = /*#__PURE__*/React.createElement("polygon", {
    points: "340.7000122 691.400012 290.7000122 677.1999998 324.5 732.6999998 340.7000122 691.400012",
    fill: "#a0b3ba"
  })), _polygon195 || (_polygon195 = /*#__PURE__*/React.createElement("polygon", {
    points: "340.7000122 691.400012 373.9000244 643.900012 404.5 671.6999998 340.7000122 691.400012",
    fill: "#8397a2"
  })), _polygon196 || (_polygon196 = /*#__PURE__*/React.createElement("polygon", {
    points: "373.9000244 643.900012 455.6000366 681.900012 404.5 671.6999998 373.9000244 643.900012",
    fill: "#97afb8"
  })), _polygon197 || (_polygon197 = /*#__PURE__*/React.createElement("polygon", {
    points: "477.1000366 622.4999876 515.8000488 655.6000242 455.4000244 682.1000242 477.1000366 622.4999876",
    fill: "#97afb8"
  })), _polygon198 || (_polygon198 = /*#__PURE__*/React.createElement("polygon", {
    points: "429.6000366 581.6000242 455.7000122 682.6000242 417.5 632.9999876 429.6000366 581.6000242",
    fill: "#97afb8"
  })), _polygon199 || (_polygon199 = /*#__PURE__*/React.createElement("polygon", {
    points: "290.7000122 677.1999998 334.3000488 626.6000242 242.3000488 637.1999998 290.7000122 677.1999998",
    fill: "#4b636e"
  })), _polygon200 || (_polygon200 = /*#__PURE__*/React.createElement("polygon", {
    points: "334.4000244 626.7999754 312.4000244 584.4999876 283.1000366 580.4999876 334.4000244 626.7999754",
    fill: "#4b636e"
  })), _polygon201 || (_polygon201 = /*#__PURE__*/React.createElement("polygon", {
    points: "290.7000122 677.1999998 334.3000488 626.6000242 340.7000122 691.400012 290.7000122 677.1999998",
    fill: "#556875"
  })), _polygon202 || (_polygon202 = /*#__PURE__*/React.createElement("polygon", {
    points: "334.3000488 626.6000242 373.9000244 643.900012 340.7000122 691.400012 334.3000488 626.6000242",
    fill: "#5e727f"
  })), _polygon203 || (_polygon203 = /*#__PURE__*/React.createElement("polygon", {
    points: "234.3000488 588.6999998 335 626.900012 242.3000488 637.2999754 234.3000488 588.6999998",
    fill: "#5e727f"
  })), _polygon204 || (_polygon204 = /*#__PURE__*/React.createElement("polygon", {
    points: "373.9000244 643.900012 429.6000366 581.7999754 358.6000366 581.4999876 373.9000244 643.900012",
    fill: "#68808e"
  })), _polygon205 || (_polygon205 = /*#__PURE__*/React.createElement("polygon", {
    points: "455.7000122 682.2999754 417.5 632.9999876 373.7000122 643.900012 455.7000122 682.2999754",
    fill: "#68808e"
  })), _polygon206 || (_polygon206 = /*#__PURE__*/React.createElement("polygon", {
    points: "373.9000244 643.900012 417.5 632.9999876 429.6000366 581.7999754 373.9000244 643.900012",
    fill: "#708c99"
  })), _polygon207 || (_polygon207 = /*#__PURE__*/React.createElement("polygon", {
    points: "312.3000488 584.6000242 294.3000488 555.1999998 246.4000244 547.400012 312.3000488 584.6000242",
    fill: "#708c99"
  })), _polygon208 || (_polygon208 = /*#__PURE__*/React.createElement("polygon", {
    points: "429.6000366 581.7999754 452.8000488 539.7999754 508.3000488 598.6000242 429.6000366 581.7999754",
    fill: "#6a848f"
  })), _polygon209 || (_polygon209 = /*#__PURE__*/React.createElement("polygon", {
    points: "452.8000488 539.7999754 500 514.4999876 508.3000488 598.6000242 452.8000488 539.7999754",
    fill: "#acbfc6"
  })), _polygon210 || (_polygon210 = /*#__PURE__*/React.createElement("polygon", {
    points: "415.7000122 481.6999998 445.4000244 455.1999998 452.9000244 539.900012 415.7000122 481.6999998",
    fill: "#acbfc6"
  })), _polygon211 || (_polygon211 = /*#__PURE__*/React.createElement("polygon", {
    points: "452.8000488 539.7999754 379.1000366 513.400012 415.7000122 481.4999876 452.8000488 539.7999754",
    fill: "#bac9d0"
  })), _polygon212 || (_polygon212 = /*#__PURE__*/React.createElement("polygon", {
    points: "445.6000366 455.0999937 381.7000122 468.1999998 404 434.5999937 445.6000366 455.0999937",
    fill: "#bac9d0"
  })), _polygon213 || (_polygon213 = /*#__PURE__*/React.createElement("polygon", {
    points: "452.8000488 539.7999754 429.6000366 581.7999754 379.1000366 513.400012 452.8000488 539.7999754",
    fill: "#67828d"
  })), _polygon214 || (_polygon214 = /*#__PURE__*/React.createElement("polygon", {
    points: "429.6000366 581.7999754 323 518.900012 379.1000366 513.400012 429.6000366 581.7999754",
    fill: "#90a4af"
  })), _polygon215 || (_polygon215 = /*#__PURE__*/React.createElement("polygon", {
    points: "429.6000366 581.900012 358.6000366 581.6000242 323.1000366 518.900012 429.6000366 581.900012",
    fill: "#99aeb7"
  })), _polygon216 || (_polygon216 = /*#__PURE__*/React.createElement("polygon", {
    points: "312.3000488 584.4999876 283.4000244 580.4999876 246.5 547.400012 312.3000488 584.4999876",
    fill: "#99aeb7"
  })), _polygon217 || (_polygon217 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.6000366 581.4999876 334.3000488 626.6000242 373.9000244 643.900012 358.6000366 581.4999876",
    fill: "#516571"
  })), _polygon218 || (_polygon218 = /*#__PURE__*/React.createElement("polygon", {
    points: "246.4000244 547.1999998 234 588.6000242 283.3000488 580.4999876 246.4000244 547.1999998",
    fill: "#516571"
  })), _polygon219 || (_polygon219 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.7000122 581.6000242 312 584.400012 334.3000488 626.6000242 358.7000122 581.6000242",
    fill: "#637e89"
  })), _polygon220 || (_polygon220 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.6000366 581.4999876 323.1000366 518.7999754 313.3000488 559.2999754 358.6000366 581.4999876",
    fill: "#75909d"
  })), _polygon221 || (_polygon221 = /*#__PURE__*/React.createElement("polygon", {
    points: "283.3000488 580.4999876 234.1000366 588.6000242 334.3000488 626.6000242 283.3000488 580.4999876",
    fill: "#748c98"
  })), _polygon222 || (_polygon222 = /*#__PURE__*/React.createElement("polygon", {
    points: "221.1000366 513.4999876 246.4000244 547.400012 234.1000366 588.6000242 221.1000366 513.4999876",
    fill: "#7b96a1"
  })), _polygon223 || (_polygon223 = /*#__PURE__*/React.createElement("polygon", {
    points: "168.5 526.6999998 221.1000366 513.4999876 178.5 540.4999876 168.5 526.6999998",
    fill: "#55717e"
  })), _polygon224 || (_polygon224 = /*#__PURE__*/React.createElement("polygon", {
    points: "221.1000366 513.4999876 281.7000122 510.6000242 262.6000366 535.6999998 221.1000366 513.4999876",
    fill: "#96aab5"
  })), _polygon225 || (_polygon225 = /*#__PURE__*/React.createElement("polygon", {
    points: "293.8000488 555.1999998 313.5 558.9999876 311.9000244 584.1000242 293.8000488 555.1999998",
    fill: "#96aab5"
  })), _polygon226 || (_polygon226 = /*#__PURE__*/React.createElement("polygon", {
    points: "281.6000366 510.4999876 323 518.900012 293.8000488 555.2999754 281.6000366 510.4999876",
    fill: "#a1b5be"
  })), _polygon227 || (_polygon227 = /*#__PURE__*/React.createElement("polygon", {
    points: "221.1000366 513.4999876 145.4000244 471.900012 168.5 526.6999998 221.1000366 513.4999876",
    fill: "#324650"
  })), _polygon228 || (_polygon228 = /*#__PURE__*/React.createElement("polygon", {
    points: "221.1000366 513.4999876 244.8000488 460.4999876 145.1000366 471.8000059 221.1000366 513.4999876",
    fill: "#8397a2"
  })), _polygon229 || (_polygon229 = /*#__PURE__*/React.createElement("polygon", {
    points: "244.8000488 460.4999876 281.7000122 510.6000242 221.1000366 513.4999876 244.8000488 460.4999876",
    fill: "#b4c5cd"
  })), _polygon230 || (_polygon230 = /*#__PURE__*/React.createElement("polygon", {
    points: "281.7000122 510.6000242 293.9000244 555.1999998 262.5 535.6999998 281.7000122 510.6000242",
    fill: "#b4c5cd"
  })), _polygon231 || (_polygon231 = /*#__PURE__*/React.createElement("polygon", {
    points: "244.8000488 460.4999876 308.4000244 468.8000059 281.7000122 510.6000242 244.8000488 460.4999876",
    fill: "#cdd6dd"
  })), _polygon232 || (_polygon232 = /*#__PURE__*/React.createElement("polygon", {
    points: "221 513.2999754 262.8000488 535.6999998 246.6000366 547.6000242 221 513.2999754",
    fill: "#cdd6dd"
  })), _polygon233 || (_polygon233 = /*#__PURE__*/React.createElement("polygon", {
    points: "311.9000244 584.2999754 313.3000488 559.1000242 358.8000488 581.6999998 311.9000244 584.2999754",
    fill: "#cdd6dd"
  })), _polygon234 || (_polygon234 = /*#__PURE__*/React.createElement("polygon", {
    points: "308.4000244 468.8000059 323.2000122 518.9999876 281.7000122 510.6000242 308.4000244 468.8000059",
    fill: "#869fad"
  })), _polygon235 || (_polygon235 = /*#__PURE__*/React.createElement("polygon", {
    points: "323.2000122 518.6000242 313.5 559.1000242 293.8000488 555.1999998 323.2000122 518.6000242",
    fill: "#869fad"
  })), _polygon236 || (_polygon236 = /*#__PURE__*/React.createElement("polygon", {
    points: "262.7000122 535.6999998 294 555.1999998 246.6000366 547.6000242 262.7000122 535.6999998",
    fill: "#869fad"
  })), _polygon237 || (_polygon237 = /*#__PURE__*/React.createElement("polygon", {
    points: "244.8000488 460.4999876 184.5 442.0999937 145.4000244 471.8000059 244.8000488 460.4999876",
    fill: "#627d89"
  })), _polygon238 || (_polygon238 = /*#__PURE__*/React.createElement("polygon", {
    points: "244.8000488 460.4999876 245 397.5999937 184.5 415.5999937 244.8000488 460.4999876",
    fill: "#64808d"
  })), _polygon239 || (_polygon239 = /*#__PURE__*/React.createElement("polygon", {
    points: "244.8000488 460.4999876 305.5 399.900012 245 397.5999937 244.8000488 460.4999876",
    fill: "#7b95a3"
  })), _polygon240 || (_polygon240 = /*#__PURE__*/React.createElement("polygon", {
    points: "184.5 442.1999998 244.9000244 460.5999937 184.5 415.4999876 184.5 442.1999998",
    fill: "#7b95a3"
  })), _polygon241 || (_polygon241 = /*#__PURE__*/React.createElement("polygon", {
    points: "244.5 460.4999876 308.2000122 468.8000059 305.3000488 399.9999876 244.5 460.4999876",
    fill: "#a5b7c1"
  })), _polygon242 || (_polygon242 = /*#__PURE__*/React.createElement("polygon", {
    points: "308.4000244 468.8000059 381.6000366 468.3000059 323.1000366 518.7999754 308.4000244 468.8000059",
    fill: "#668391"
  })), _polygon243 || (_polygon243 = /*#__PURE__*/React.createElement("polygon", {
    points: "381.6000366 468.3000059 379.1000366 513.400012 323.1000366 518.7999754 381.6000366 468.3000059",
    fill: "#56717f"
  })), _polygon244 || (_polygon244 = /*#__PURE__*/React.createElement("polygon", {
    points: "381.6000366 468.3000059 415.7000122 481.5999937 379.1000366 513.400012 381.6000366 468.3000059",
    fill: "#8ea6b1"
  })), _polygon245 || (_polygon245 = /*#__PURE__*/React.createElement("polygon", {
    points: "381.6000366 468.3000059 337.1000366 452.900012 360.8000488 413.3000059 381.6000366 468.3000059",
    fill: "#405762"
  })), _polygon246 || (_polygon246 = /*#__PURE__*/React.createElement("polygon", {
    points: "360.8000488 413.3000059 404.2000122 434.5999937 381.6000366 468.3000059 360.8000488 413.3000059",
    fill: "#668490"
  })), _polygon247 || (_polygon247 = /*#__PURE__*/React.createElement("polygon", {
    points: "337 452.5999937 308.6000366 468.900012 381.6000366 468.3000059 337 452.5999937",
    fill: "#758e9c"
  })), _polygon248 || (_polygon248 = /*#__PURE__*/React.createElement("polygon", {
    points: "337.1000366 452.5999937 305.2000122 399.1999998 308.2000122 468.9999876 337.1000366 452.5999937",
    fill: "#98acb5"
  })), _polygon249 || (_polygon249 = /*#__PURE__*/React.createElement("polygon", {
    points: "337.1000366 452.900012 339.9000244 415.9999876 305.5 399.900012 337.1000366 452.900012",
    fill: "#6f8a99"
  })), _polygon250 || (_polygon250 = /*#__PURE__*/React.createElement("polygon", {
    points: "339.9000244 415.9999876 360.8000488 413.3000059 337.1000366 452.900012 339.9000244 415.9999876",
    fill: "#56717f"
  })), _polygon251 || (_polygon251 = /*#__PURE__*/React.createElement("polygon", {
    points: "339.9000244 415.9999876 339.8000488 386.9999876 360.8000488 413.3000059 339.9000244 415.9999876",
    fill: "#627b89"
  })), _polygon252 || (_polygon252 = /*#__PURE__*/React.createElement("polygon", {
    points: "339.9000244 415.9999876 339.8000488 386.9999876 305.5 399.900012 339.9000244 415.9999876",
    fill: "#728c99"
  })), _polygon253 || (_polygon253 = /*#__PURE__*/React.createElement("polygon", {
    points: "339.8000488 386.9999876 374 386.9999876 360.8000488 413.3000059 339.8000488 386.9999876",
    fill: "#324650"
  })), _polygon254 || (_polygon254 = /*#__PURE__*/React.createElement("polygon", {
    points: "374 386.9999876 404.2000122 434.5999937 360.8000488 413.3000059 374 386.9999876",
    fill: "#96aab5"
  })), _polygon255 || (_polygon255 = /*#__PURE__*/React.createElement("polygon", {
    points: "373.9000244 386.8000059 423.1000366 394.8000059 404 434.4999876 373.9000244 386.8000059",
    fill: "#a1b5be"
  })), _polygon256 || (_polygon256 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.9000244 394.9999876 446.3000488 317.5999937 453.6000366 385.6999998 422.9000244 394.9999876",
    fill: "#a1b5be"
  })), _polygon257 || (_polygon257 = /*#__PURE__*/React.createElement("polygon", {
    points: "453.5 385.3000059 475.5 413.0999937 445.3000488 454.900012 453.5 385.3000059",
    fill: "#c9d1d9"
  })), _polygon258 || (_polygon258 = /*#__PURE__*/React.createElement("polygon", {
    points: "305.5 399.900012 311.7000122 345.6999998 339.8000488 386.9999876 305.5 399.900012",
    fill: "#99abb4"
  })), _polygon259 || (_polygon259 = /*#__PURE__*/React.createElement("polygon", {
    points: "311.7000122 345.6999998 345 336.900012 339.8000488 386.9999876 311.7000122 345.6999998",
    fill: "#abbdc7"
  })), _polygon260 || (_polygon260 = /*#__PURE__*/React.createElement("polygon", {
    points: "345 336.900012 374 386.9999876 339.8000488 386.9999876 345 336.900012",
    fill: "#869da7"
  })), _polygon261 || (_polygon261 = /*#__PURE__*/React.createElement("polygon", {
    points: "373.8000488 386.900012 370.9000244 296.400012 345 336.900012 373.8000488 386.900012",
    fill: "#75909d"
  })), _polygon262 || (_polygon262 = /*#__PURE__*/React.createElement("polygon", {
    points: "371.1000366 296.400012 380.2000122 255.6999998 332.4000244 244.3000059 371.1000366 296.400012",
    fill: "#75909d"
  })), _polygon263 || (_polygon263 = /*#__PURE__*/React.createElement("polygon", {
    points: "373.7000122 387.0999937 401.7000122 351.900012 370.9000244 296.1999998 373.7000122 387.0999937",
    fill: "#587481"
  })), _polygon264 || (_polygon264 = /*#__PURE__*/React.createElement("polygon", {
    points: "311.7000122 345.6999998 255.1000366 348.6999998 305.5 399.900012 311.7000122 345.6999998",
    fill: "#58747f"
  })), _polygon265 || (_polygon265 = /*#__PURE__*/React.createElement("polygon", {
    points: "305.5 399.900012 245 397.5999937 255 348.5999937 305.5 399.900012",
    fill: "#60808f"
  })), _polygon266 || (_polygon266 = /*#__PURE__*/React.createElement("polygon", {
    points: "255 348.5999937 199.2000122 367.5999937 193.9000244 341.4999876 255 348.5999937",
    fill: "#60808f"
  })), _polygon267 || (_polygon267 = /*#__PURE__*/React.createElement("polygon", {
    points: "255 348.5999937 199.2000122 367.5999937 245 397.5999937 255 348.5999937",
    fill: "#5b7583"
  })), _polygon268 || (_polygon268 = /*#__PURE__*/React.createElement("polygon", {
    points: "181.9000244 299.6999998 121.4000244 336.400012 194.1000366 341.6999998 181.9000244 299.6999998",
    fill: "#5b7583"
  })), _polygon269 || (_polygon269 = /*#__PURE__*/React.createElement("polygon", {
    points: "199.3000488 367.5999937 164.4000244 363.900012 184.4000244 415.5999937 199.3000488 367.5999937",
    fill: "#5b7583"
  })), _polygon270 || (_polygon270 = /*#__PURE__*/React.createElement("polygon", {
    points: "164.4000244 363.900012 121.6000366 336.1999998 110.7000122 373.900012 164.4000244 363.900012",
    fill: "#5b7583"
  })), _polygon271 || (_polygon271 = /*#__PURE__*/React.createElement("polygon", {
    points: "255.1000366 348.6999998 181.8000488 299.9999876 194 341.5999937 255.1000366 348.6999998",
    fill: "#526a78"
  })), _polygon272 || (_polygon272 = /*#__PURE__*/React.createElement("polygon", {
    points: "255.1000366 348.6999998 311.7000122 345.6999998 326.7000122 313.3000059 255.1000366 348.6999998",
    fill: "#99adb6"
  })), _polygon273 || (_polygon273 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.7000122 313.3000059 345.2000122 337.0999937 311.7000122 345.6999998 326.7000122 313.3000059",
    fill: "#c2cfd8"
  })), _polygon274 || (_polygon274 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.5 313.3000059 371.1000366 296.4999876 345.2000122 337.1999998 326.5 313.3000059",
    fill: "#b5c4cb"
  })), _polygon275 || (_polygon275 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.7000122 313.3000059 332.6000366 244.5999937 371.2000122 296.4999876 326.7000122 313.3000059",
    fill: "#9eb4bb"
  })), _polygon276 || (_polygon276 = /*#__PURE__*/React.createElement("polygon", {
    points: "281.2000122 262.8000059 245 223.5000029 332.7000122 244.5999937 281.2000122 262.8000059",
    fill: "#9eb4bb"
  })), _polygon277 || (_polygon277 = /*#__PURE__*/React.createElement("polygon", {
    points: "380.2000122 255.900012 445.1000366 271.400012 371.1000366 296.4999876 380.2000122 255.900012",
    fill: "#41565f"
  })), _polygon278 || (_polygon278 = /*#__PURE__*/React.createElement("polygon", {
    points: "369.2000122 212.6999998 395.1000366 223.3000059 380.4000244 256.5999937 369.2000122 212.6999998",
    fill: "#41565f"
  })), _polygon279 || (_polygon279 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.8000488 296.5999937 446.2000122 318.0999937 445.2000122 271.1999998 370.8000488 296.5999937",
    fill: "#748c98"
  })), _polygon280 || (_polygon280 = /*#__PURE__*/React.createElement("polygon", {
    points: "431.1000366 218.3999968 471.8000488 247.6999998 445.6000366 209.5000029 431.1000366 218.3999968",
    fill: "#748c98"
  })), _polygon281 || (_polygon281 = /*#__PURE__*/React.createElement("polygon", {
    points: "446.2000122 318.0999937 506.9000244 328.0999937 445 271.1999998 446.2000122 318.0999937",
    fill: "#a6b9c2"
  })), _polygon282 || (_polygon282 = /*#__PURE__*/React.createElement("polygon", {
    points: "453.6000366 385.4999876 475.4000244 412.9999876 506.9000244 328.0999937 453.6000366 385.4999876",
    fill: "#cad8e0"
  })), _polygon283 || (_polygon283 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.9000244 394.9999876 445.5 454.9999876 453.5 385.6999998 422.9000244 394.9999876",
    fill: "#cad8e0"
  })), _polygon284 || (_polygon284 = /*#__PURE__*/React.createElement("polygon", {
    points: "506.9000244 328.0999937 582.5999756 351.900012 527.3000488 413.5999937 506.9000244 328.0999937",
    fill: "#c3ced4"
  })), _polygon285 || (_polygon285 = /*#__PURE__*/React.createElement("polygon", {
    points: "506.9000244 328.0999937 555.4000244 313.8000059 582.5999756 351.900012 506.9000244 328.0999937",
    fill: "#5a747e"
  })), _polygon286 || (_polygon286 = /*#__PURE__*/React.createElement("polygon", {
    points: "401.2000122 351.900012 446.2000122 318.0999937 422.9000244 395.1999998 401.2000122 351.900012",
    fill: "#5a747e"
  })), _polygon287 || (_polygon287 = /*#__PURE__*/React.createElement("polygon", {
    points: "453.6000366 385.6999998 446.3000488 317.6999998 507 328.0999937 453.6000366 385.6999998",
    fill: "#5a747e"
  })), _polygon288 || (_polygon288 = /*#__PURE__*/React.createElement("polygon", {
    points: "555.3000488 313.6999998 607.8000488 315.4999876 582.5999756 351.900012 555.3000488 313.6999998",
    fill: "#5f7983"
  })), _polygon289 || (_polygon289 = /*#__PURE__*/React.createElement("polygon", {
    points: "537.4000244 286.900012 592 267.9999876 607.8000488 315.4999876 537.4000244 286.900012",
    fill: "#4f6974"
  })), _polygon290 || (_polygon290 = /*#__PURE__*/React.createElement("polygon", {
    points: "471.4000244 247.3000059 507 328.3000059 538 287.0999937 471.4000244 247.3000059",
    fill: "#41525b"
  })), _polygon291 || (_polygon291 = /*#__PURE__*/React.createElement("polygon", {
    points: "371.2000122 296.5999937 401.4000244 351.900012 446.4000244 317.8000059 371.2000122 296.5999937",
    fill: "#41525b"
  })), _polygon292 || (_polygon292 = /*#__PURE__*/React.createElement("polygon", {
    points: "471.4000244 247.3000059 445 271.1999998 506.9000244 328.0999937 471.4000244 247.3000059",
    fill: "#637783"
  })), _polygon293 || (_polygon293 = /*#__PURE__*/React.createElement("polygon", {
    points: "401.2000122 351.400012 373.3000488 386.900012 422.9000244 395.0999937 401.2000122 351.400012",
    fill: "#637783"
  })), _polygon294 || (_polygon294 = /*#__PURE__*/React.createElement("polygon", {
    points: "395.1000366 223.0999937 380.5 255.9999876 445.2000122 271.400012 395.1000366 223.0999937",
    fill: "#637783"
  })), _polygon295 || (_polygon295 = /*#__PURE__*/React.createElement("polygon", {
    points: "418.8000488 170.8000059 395.2000122 223.3000059 431.4000244 218.3000059 418.8000488 170.8000059",
    fill: "#637783"
  })), _polygon296 || (_polygon296 = /*#__PURE__*/React.createElement("polygon", {
    points: "679.8000488 222.8000059 640.2000732 258.9999876 736.3000488 239.5999937 679.8000488 222.8000059",
    fill: "#6b8795"
  })), _polygon297 || (_polygon297 = /*#__PURE__*/React.createElement("polygon", {
    points: "680.3000488 222.8000059 629.3000488 181.3999968 640.2000732 258.9999876 680.3000488 222.8000059",
    fill: "#4b6671"
  })), _polygon298 || (_polygon298 = /*#__PURE__*/React.createElement("polygon", {
    points: "708.8000488 196.5000029 691.9000244 102.6000013 779.7000732 207.5999937 708.8000488 196.5000029",
    fill: "#c4d1d8"
  })), _polygon299 || (_polygon299 = /*#__PURE__*/React.createElement("polygon", {
    points: "666.5 147.0999937 617.8000488 92.1000013 692 102.6000013 666.5 147.0999937",
    fill: "#afbec5"
  })), _polygon300 || (_polygon300 = /*#__PURE__*/React.createElement("polygon", {
    points: "717.0999756 288.3000059 736.5999756 239.3999968 786.0999756 313.6999998 717.0999756 288.3000059",
    fill: "#afbec5"
  })), _polygon301 || (_polygon301 = /*#__PURE__*/React.createElement("polygon", {
    points: "680 222.8999968 708.8000488 195.8999968 736.9000244 239.6999998 680 222.8999968",
    fill: "#afbec5"
  })), _polygon302 || (_polygon302 = /*#__PURE__*/React.createElement("polygon", {
    points: "708.8000488 196.5000029 629.3000488 181.5000029 633.5999756 139.0000029 708.8000488 196.5000029",
    fill: "#b9c8d0"
  })), _polygon303 || (_polygon303 = /*#__PURE__*/React.createElement("polygon", {
    points: "633.5999756 139.0000029 617.5999756 92.0000029 666.5 146.8999968 633.5999756 139.0000029",
    fill: "#9cadb5"
  })), _polygon304 || (_polygon304 = /*#__PURE__*/React.createElement("polygon", {
    points: "633.5999756 139.0000029 573.0999756 138.3000059 617.5999756 92.1000013 633.5999756 139.0000029",
    fill: "#4e6873"
  })), _polygon305 || (_polygon305 = /*#__PURE__*/React.createElement("polygon", {
    points: "633.5999756 139.0000029 573.0999756 138.1999998 629.3000488 181.5000029 633.5999756 139.0000029",
    fill: "#afbec5"
  })), _polygon306 || (_polygon306 = /*#__PURE__*/React.createElement("polygon", {
    points: "629.3000488 181.1999998 587.5999756 212.8000059 640.2000732 258.9999876 629.3000488 181.1999998",
    fill: "#7992a0"
  })), _polygon307 || (_polygon307 = /*#__PURE__*/React.createElement("polygon", {
    points: "717.2000732 288.3000059 640.4000244 259.0999937 681.0999756 301.900012 717.2000732 288.3000059",
    fill: "#7992a0"
  })), _polygon308 || (_polygon308 = /*#__PURE__*/React.createElement("polygon", {
    points: "640.2000732 258.9999876 587.5999756 212.8000059 592 267.9999876 640.2000732 258.9999876",
    fill: "#566a78"
  })), _polygon309 || (_polygon309 = /*#__PURE__*/React.createElement("polygon", {
    points: "608.0999756 315.5999937 537.9000244 286.9999876 555.5 313.900012 608.0999756 315.5999937",
    fill: "#566a78"
  })), _polygon310 || (_polygon310 = /*#__PURE__*/React.createElement("polygon", {
    points: "592 267.9999876 540.2000732 231.3999968 587.5999756 213.0999937 592 267.9999876",
    fill: "#364a54"
  })), _polygon311 || (_polygon311 = /*#__PURE__*/React.createElement("polygon", {
    points: "538 287.0999937 471.4000244 247.4999876 525.8000488 253.9999876 538 287.0999937",
    fill: "#364a54"
  })), _polygon312 || (_polygon312 = /*#__PURE__*/React.createElement("polygon", {
    points: "555.5999756 313.8000059 507.2000732 328.0999937 537.9000244 286.900012 555.5999756 313.8000059",
    fill: "#364a54"
  })), _polygon313 || (_polygon313 = /*#__PURE__*/React.createElement("polygon", {
    points: "592 267.9999876 541 231.5999937 525.5999756 254.0999937 592 267.9999876",
    fill: "#41515b"
  })), _polygon314 || (_polygon314 = /*#__PURE__*/React.createElement("polygon", {
    points: "525.5 253.9999876 510.9000244 210.8000059 471.1000366 247.4999876 525.5 253.9999876",
    fill: "#455b64"
  })), _polygon315 || (_polygon315 = /*#__PURE__*/React.createElement("polygon", {
    points: "510.9000244 210.8000059 543 170.8000059 587.9000244 213.0999937 510.9000244 210.8000059",
    fill: "#425865"
  })), _polygon316 || (_polygon316 = /*#__PURE__*/React.createElement("polygon", {
    points: "537.9000244 286.9999876 525.7000732 253.9999876 592 267.9999876 537.9000244 286.9999876",
    fill: "#425865"
  })), _polygon317 || (_polygon317 = /*#__PURE__*/React.createElement("polygon", {
    points: "629.3000488 181.3999968 595.2000732 181.3000059 587.5999756 212.8000059 629.3000488 181.3999968",
    fill: "#859ea9"
  })), _polygon318 || (_polygon318 = /*#__PURE__*/React.createElement("polygon", {
    points: "666.3000488 146.6999998 633.5999756 139.0000029 709.0999756 196.5999937 666.3000488 146.6999998",
    fill: "#859ea9"
  })), _polygon319 || (_polygon319 = /*#__PURE__*/React.createElement("polygon", {
    points: "587.8000488 213.0999937 510.5999756 210.6999998 540.2000732 231.8999968 587.8000488 213.0999937",
    fill: "#667881"
  })), _polygon320 || (_polygon320 = /*#__PURE__*/React.createElement("polygon", {
    points: "708.5999756 196.3999968 629.0999756 181.3999968 680.3000488 222.8000059 708.5999756 196.3999968",
    fill: "#667881"
  })), _polygon321 || (_polygon321 = /*#__PURE__*/React.createElement("polygon", {
    points: "595.3000488 181.3999968 542.9000244 170.8999968 587.5999756 212.8000059 595.3000488 181.3999968",
    fill: "#667881"
  })), _polygon322 || (_polygon322 = /*#__PURE__*/React.createElement("polygon", {
    points: "595.2000732 181.3000059 573.3000488 138.3000059 629.4000244 181.5000029 595.2000732 181.3000059",
    fill: "#cfd8df"
  })), _polygon323 || (_polygon323 = /*#__PURE__*/React.createElement("polygon", {
    points: "595.3000488 181.3999968 573.2000732 138.1999998 542.9000244 170.8999968 595.3000488 181.3999968",
    fill: "#afbec5"
  })), _polygon324 || (_polygon324 = /*#__PURE__*/React.createElement("polygon", {
    points: "617.7000732 92.1000013 563.5 26.2999983 692 102.6000013 617.7000732 92.1000013",
    fill: "#dbe1e7"
  })), _polygon325 || (_polygon325 = /*#__PURE__*/React.createElement("polygon", {
    points: "617.7000732 92.1000013 554.5 83.2999983 563.5 26.2999983 617.7000732 92.1000013",
    fill: "#b0bfc6"
  })), _polygon326 || (_polygon326 = /*#__PURE__*/React.createElement("polygon", {
    points: "554.5 83.2999983 468.2000122 75.2999983 463.5 39.1000013 554.5 83.2999983",
    fill: "#b0bfc6"
  })), _polygon327 || (_polygon327 = /*#__PURE__*/React.createElement("polygon", {
    points: "617.7000732 92.1000013 573.2000732 138.3000059 554.5 83.2999983 617.7000732 92.1000013",
    fill: "#607d8a"
  })), _polygon328 || (_polygon328 = /*#__PURE__*/React.createElement("polygon", {
    points: "554.5 83.2999983 506.9000244 111.8999968 573.3000488 138.3000059 554.5 83.2999983",
    fill: "#7f97a3"
  })), _polygon329 || (_polygon329 = /*#__PURE__*/React.createElement("polygon", {
    points: "573.0999756 138.3000059 506.9000244 111.8999968 542.9000244 170.8999968 573.0999756 138.3000059",
    fill: "#c3cfd7"
  })), _polygon330 || (_polygon330 = /*#__PURE__*/React.createElement("polygon", {
    points: "506.9000244 111.8999968 478.5 162.1999998 543 171.0000029 506.9000244 111.8999968",
    fill: "#b4c3cb"
  })), _polygon331 || (_polygon331 = /*#__PURE__*/React.createElement("polygon", {
    points: "478.5 162.1999998 510.9000244 210.8000059 542.9000244 170.8999968 478.5 162.1999998",
    fill: "#7f97a3"
  })), _polygon332 || (_polygon332 = /*#__PURE__*/React.createElement("polygon", {
    points: "478.5 162.1999998 476 186.1999998 510.9000244 210.8000059 478.5 162.1999998",
    fill: "#a6b9c1"
  })), _polygon333 || (_polygon333 = /*#__PURE__*/React.createElement("polygon", {
    points: "418.8000488 170.8999968 445.5 210.0000029 476 186.1999998 418.8000488 170.8999968",
    fill: "#a6b9c1"
  })), _polygon334 || (_polygon334 = /*#__PURE__*/React.createElement("polygon", {
    points: "476 186.1999998 471.4000244 247.3000059 510.9000244 210.8000059 476 186.1999998",
    fill: "#58737e"
  })), _polygon335 || (_polygon335 = /*#__PURE__*/React.createElement("polygon", {
    points: "431 218.3000059 445 271.3000059 471.7000122 247.5999937 431 218.3000059",
    fill: "#58737e"
  })), _polygon336 || (_polygon336 = /*#__PURE__*/React.createElement("polygon", {
    points: "511 210.6999998 525.5 254.3000059 541 231.8999968 511 210.6999998",
    fill: "#58737e"
  })), _polygon337 || (_polygon337 = /*#__PURE__*/React.createElement("polygon", {
    points: "418.9000244 170.8999968 369.5 212.8999968 395.2000122 223.3999968 418.9000244 170.8999968",
    fill: "#58737e"
  })), _polygon338 || (_polygon338 = /*#__PURE__*/React.createElement("polygon", {
    points: "369.5 212.5999937 332.4000244 244.3999968 380.5 256.3000059 369.5 212.5999937",
    fill: "#58737e"
  })), _polygon339 || (_polygon339 = /*#__PURE__*/React.createElement("polygon", {
    points: "445.7000122 209.5000029 418.8000488 170.8999968 431.4000244 218.3000059 445.7000122 209.5000029",
    fill: "#496370"
  })), _polygon340 || (_polygon340 = /*#__PURE__*/React.createElement("polygon", {
    points: "471.4000244 247.3000059 476 186.1999998 445.5 209.5000029 471.4000244 247.3000059",
    fill: "#496370"
  })), _polygon341 || (_polygon341 = /*#__PURE__*/React.createElement("polygon", {
    points: "478.5 162.1999998 418.8000488 170.8999968 476 186.1999998 478.5 162.1999998",
    fill: "#8598a2"
  })), _polygon342 || (_polygon342 = /*#__PURE__*/React.createElement("polygon", {
    points: "478.5 162.1999998 437.1000366 139.1999998 418.8000488 171.1999998 478.5 162.1999998",
    fill: "#aab8c1"
  })), _polygon343 || (_polygon343 = /*#__PURE__*/React.createElement("polygon", {
    points: "437.1000366 139.1999998 398.8000488 139.1999998 419 171.3000059 437.1000366 139.1999998",
    fill: "#bfc9d1"
  })), _polygon344 || (_polygon344 = /*#__PURE__*/React.createElement("polygon", {
    points: "437.1000366 139.1999998 468.2000122 75.2999983 478.5 162.1999998 437.1000366 139.1999998",
    fill: "#c8d3dc"
  })), _polygon345 || (_polygon345 = /*#__PURE__*/React.createElement("polygon", {
    points: "463.5 39.1000013 563.5 26.2999983 413.6000366 0 463.5 39.1000013",
    fill: "#dfe6ec"
  })), _polygon346 || (_polygon346 = /*#__PURE__*/React.createElement("polygon", {
    points: "463.5 39.1999998 554.5 83.2999983 563.5 26.2999983 463.5 39.1999998",
    fill: "#d3dce2"
  })), _polygon347 || (_polygon347 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.3000488 94.6000013 468.2000122 75.3999968 463.5 39.1999998 392.3000488 94.6000013",
    fill: "#d3dce2"
  })), _polygon348 || (_polygon348 = /*#__PURE__*/React.createElement("polygon", {
    points: "413.6000366 .0999994 416.3000488 45.9000006 463.6000366 39.1000013 413.6000366 .0999994",
    fill: "#d3dce2"
  })), _polygon349 || (_polygon349 = /*#__PURE__*/React.createElement("polygon", {
    points: "468.2000122 75.1999998 506.9000244 111.8999968 554.5 83.2999983 468.2000122 75.1999998",
    fill: "#bbc5cc"
  })), _polygon350 || (_polygon350 = /*#__PURE__*/React.createElement("polygon", {
    points: "506.9000244 111.8999968 478.5 162.1999998 468.2000122 75.2999983 506.9000244 111.8999968",
    fill: "#d3dce2"
  })), _polygon351 || (_polygon351 = /*#__PURE__*/React.createElement("polygon", {
    points: "468.2000122 75.2999983 392.4000244 94.6000013 437.1000366 139.5000029 468.2000122 75.2999983",
    fill: "#9caeba"
  })), _polygon352 || (_polygon352 = /*#__PURE__*/React.createElement("polygon", {
    points: "437.1000366 139.5000029 392.4000244 94.6000013 398.5 139.3000059 437.1000366 139.5000029",
    fill: "#7b95a3"
  })), _polygon353 || (_polygon353 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.4000244 94.6000013 416.3000488 45.999999 463.6000366 38.999999 392.4000244 94.6000013",
    fill: "#c1ced6"
  })), _polygon354 || (_polygon354 = /*#__PURE__*/React.createElement("polygon", {
    points: "241.1000366 74.7999983 308.1000366 41.4000006 321.2000122 81.6000013 241.1000366 74.7999983",
    fill: "#cad7dd"
  })), _polygon355 || (_polygon355 = /*#__PURE__*/React.createElement("polygon", {
    points: "226 110.6999998 145 96.0000029 241.2000122 74.6999998 226 110.6999998",
    fill: "#cadae0"
  })), _polygon356 || (_polygon356 = /*#__PURE__*/React.createElement("polygon", {
    points: "416.3000488 45.999999 321.2000122 81.3999968 413.6000366 0 416.3000488 45.999999",
    fill: "#c8d3dc"
  })), _polygon357 || (_polygon357 = /*#__PURE__*/React.createElement("polygon", {
    points: "416.3000488 45.999999 321.2000122 81.3999968 392.4000244 94.6000013 416.3000488 45.999999",
    fill: "#b9c8d0"
  })), _polygon358 || (_polygon358 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.4000244 94.6000013 333.1000366 141.3999968 398.5 139.3000059 392.4000244 94.6000013",
    fill: "#91a9b4"
  })), _polygon359 || (_polygon359 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.4000244 94.6000013 321.2000122 81.3999968 333.1000366 141.3999968 392.4000244 94.6000013",
    fill: "#a9bcc5"
  })), _polygon360 || (_polygon360 = /*#__PURE__*/React.createElement("polygon", {
    points: "399.4000244 139.3000059 374.8000488 163.0999937 332.6000366 141.1999998 399.4000244 139.3000059",
    fill: "#77919f"
  })), _polygon361 || (_polygon361 = /*#__PURE__*/React.createElement("polygon", {
    points: "399.3000488 139.5000029 418.8000488 170.8999968 374.3000488 163.0999937 399.3000488 139.5000029",
    fill: "#637e8b"
  })), _polygon362 || (_polygon362 = /*#__PURE__*/React.createElement("polygon", {
    points: "431.4000244 218.1999998 395.1000366 223.1999998 445.1000366 271.4999876 431.4000244 218.1999998",
    fill: "#54707e"
  })), _polygon363 || (_polygon363 = /*#__PURE__*/React.createElement("polygon", {
    points: "369.8000488 213.1999998 374.2000122 162.6999998 332.4000244 244.5000029 369.8000488 213.1999998",
    fill: "#54707e"
  })), _polygon364 || (_polygon364 = /*#__PURE__*/React.createElement("polygon", {
    points: "419 170.8999968 374.2000122 162.8000059 369.5 213.3000059 419 170.8999968",
    fill: "#4c6974"
  })), _polygon365 || (_polygon365 = /*#__PURE__*/React.createElement("polygon", {
    points: "374.2000122 162.8000059 316.9000244 191.3999968 332.6000366 244.5999937 374.2000122 162.8000059",
    fill: "#597581"
  })), _polygon366 || (_polygon366 = /*#__PURE__*/React.createElement("polygon", {
    points: "374.2000122 162.8000059 333.1000366 141.3999968 316.9000244 191.3999968 374.2000122 162.8000059",
    fill: "#a6b8c2"
  })), _polygon367 || (_polygon367 = /*#__PURE__*/React.createElement("polygon", {
    points: "333.1000366 141.3999968 321.2000122 81.3999968 316.9000244 191.3999968 333.1000366 141.3999968",
    fill: "#a3b6bf"
  })), _polygon368 || (_polygon368 = /*#__PURE__*/React.createElement("polygon", {
    points: "321.2000122 81.3999968 281.6000366 165.5999937 316.9000244 191.3999968 321.2000122 81.3999968",
    fill: "#bbcad2"
  })), _polygon369 || (_polygon369 = /*#__PURE__*/React.createElement("polygon", {
    points: "316.9000244 191.3999968 245.2000122 223.3000059 281.6000366 165.5999937 316.9000244 191.3999968",
    fill: "#c8d2dc"
  })), _polygon370 || (_polygon370 = /*#__PURE__*/React.createElement("polygon", {
    points: "316.9000244 191.3999968 332.7000122 244.5999937 244.8000488 223.5000029 316.9000244 191.3999968",
    fill: "#a8bac3"
  })), _polygon371 || (_polygon371 = /*#__PURE__*/React.createElement("polygon", {
    points: "332.7000122 244.5000029 326.7000122 313.3000059 281 262.900012 332.7000122 244.5000029",
    fill: "#77919f"
  })), _polygon372 || (_polygon372 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.9000244 313.5999937 280.7000122 262.400012 273.7000122 286.900012 326.9000244 313.5999937",
    fill: "#8ba3ae"
  })), _polygon373 || (_polygon373 = /*#__PURE__*/React.createElement("polygon", {
    points: "273.9000244 286.900012 217.4000244 265.0999937 255.1000366 348.6999998 273.9000244 286.900012",
    fill: "#637f8d"
  })), _polygon374 || (_polygon374 = /*#__PURE__*/React.createElement("polygon", {
    points: "217.4000244 265.0999937 181.8000488 299.9999876 255.1000366 348.6999998 217.4000244 265.0999937",
    fill: "#5b7786"
  })), _polygon375 || (_polygon375 = /*#__PURE__*/React.createElement("polygon", {
    points: "217.4000244 265.0999937 245.2000122 223.3999968 273.7000122 286.900012 217.4000244 265.0999937",
    fill: "#819ba9"
  })), _polygon376 || (_polygon376 = /*#__PURE__*/React.createElement("polygon", {
    points: "245.2000122 223.3999968 166.9000244 205.6999998 191.6000366 226.5999937 245.2000122 223.3999968",
    fill: "#8299a7"
  })), _polygon377 || (_polygon377 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.6000366 226.5999937 217.4000244 265.0999937 245.3000488 223.5000029 191.6000366 226.5999937",
    fill: "#678897"
  })), _polygon378 || (_polygon378 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.6000366 226.5999937 158.8000488 230.3999968 217.4000244 265.0999937 191.6000366 226.5999937",
    fill: "#708c9a"
  })), _polygon379 || (_polygon379 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.6000366 226.5999937 166.9000244 205.6999998 158.8000488 230.3999968 191.6000366 226.5999937",
    fill: "#768992"
  })), _polygon380 || (_polygon380 = /*#__PURE__*/React.createElement("polygon", {
    points: "166.9000244 205.6999998 219.3000488 180.0000029 245.2000122 223.3999968 166.9000244 205.6999998",
    fill: "#9eb4bb"
  })), _polygon381 || (_polygon381 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.3000488 180.0000029 281.6000366 165.5999937 245.2000122 223.3999968 219.3000488 180.0000029",
    fill: "#bfccd4"
  })), _polygon382 || (_polygon382 = /*#__PURE__*/React.createElement("polygon", {
    points: "226.5 110.3999968 281.6000366 165.5999937 219.3000488 180.0000029 226.5 110.3999968",
    fill: "#9eb2ba"
  })), _polygon383 || (_polygon383 = /*#__PURE__*/React.createElement("polygon", {
    points: "226.5 110.3999968 321.2000122 81.6000013 281.6000366 165.5999937 226.5 110.3999968",
    fill: "#92a9b4"
  })), _polygon384 || (_polygon384 = /*#__PURE__*/React.createElement("polygon", {
    points: "308.1000366 41.7999983 413.6000366 0 321.1000366 81.6000013 308.1000366 41.7999983",
    fill: "#becad2"
  })), _polygon385 || (_polygon385 = /*#__PURE__*/React.createElement("polygon", {
    points: "241.2000122 74.6999998 320.9000244 81.6000013 226 111.1000013 241.2000122 74.6999998",
    fill: "#becad2"
  })), _polygon386 || (_polygon386 = /*#__PURE__*/React.createElement("polygon", {
    points: "307.4000244 42.1000013 258.4000244 30.999999 413.6000366 0 307.4000244 42.1000013",
    fill: "#e1e9eb"
  })), _polygon387 || (_polygon387 = /*#__PURE__*/React.createElement("polygon", {
    points: "258.4000244 30.999999 145 96.1000013 241.1000366 74.7999983 258.4000244 30.999999",
    fill: "#dce4e6"
  })), _polygon388 || (_polygon388 = /*#__PURE__*/React.createElement("polygon", {
    points: "147.3000488 144.0999937 150.5 192.0999937 219.4000244 180.0999937 147.3000488 144.0999937",
    fill: "#dce4e6"
  })), _polygon389 || (_polygon389 = /*#__PURE__*/React.createElement("polygon", {
    points: "49.9000244 212.3999968 111.3000488 191.0999937 147.6000366 144.1999998 49.9000244 212.3999968",
    fill: "#dce4e6"
  })), _polygon390 || (_polygon390 = /*#__PURE__*/React.createElement("polygon", {
    points: "145 96.1000013 147.6000366 144.3999968 226.5 110.3999968 145 96.1000013",
    fill: "#cdd6dd"
  })), _polygon391 || (_polygon391 = /*#__PURE__*/React.createElement("polygon", {
    points: "258.4000244 30.999999 241.2000122 74.6999998 308.4000244 42.1000013 258.4000244 30.999999",
    fill: "#cdd6dd"
  })), _polygon392 || (_polygon392 = /*#__PURE__*/React.createElement("polygon", {
    points: "226.5 110.3999968 147.3000488 144.3999968 219.3000488 180.0000029 226.5 110.3999968",
    fill: "#96a9b5"
  })), _polygon393 || (_polygon393 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.3000488 180.0000029 150 192.0000029 166.9000244 205.6999998 219.3000488 180.0000029",
    fill: "#88a0ab"
  })), _polygon394 || (_polygon394 = /*#__PURE__*/React.createElement("polygon", {
    points: "166.9000244 205.6999998 150 192.0000029 73.9000244 260.5999937 166.9000244 205.6999998",
    fill: "#96a9b5"
  })), _polygon395 || (_polygon395 = /*#__PURE__*/React.createElement("polygon", {
    points: "166.9000244 205.6999998 158.8000488 230.3999968 73.9000244 260.5999937 166.9000244 205.6999998",
    fill: "#bdcad2"
  })), _polygon396 || (_polygon396 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.8000488 230.3999968 131.3000488 273.400012 73.9000244 260.5999937 158.8000488 230.3999968",
    fill: "#a1b6be"
  })), _polygon397 || (_polygon397 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.8000488 230.3999968 217.4000244 265.0999937 131.3000488 273.400012 158.8000488 230.3999968",
    fill: "#678390"
  })), _polygon398 || (_polygon398 = /*#__PURE__*/React.createElement("polygon", {
    points: "217.4000244 265.0999937 134.7000122 292.400012 131.3000488 273.400012 217.4000244 265.0999937",
    fill: "#536f7c"
  })), _polygon399 || (_polygon399 = /*#__PURE__*/React.createElement("polygon", {
    points: "281.2000122 262.8000059 273.8000488 286.900012 245.2000122 223.5999937 281.2000122 262.8000059",
    fill: "#536f7c"
  })), _polygon400 || (_polygon400 = /*#__PURE__*/React.createElement("polygon", {
    points: "217.4000244 265.0999937 181.8000488 299.9999876 134.7000122 292.400012 217.4000244 265.0999937",
    fill: "#4d6976"
  })), _polygon401 || (_polygon401 = /*#__PURE__*/React.createElement("polygon", {
    points: "73.9000244 260.5999937 50 212.5000029 19.7000122 273.3000059 73.9000244 260.5999937",
    fill: "#c6cbd1"
  })), _polygon402 || (_polygon402 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.9000244 192.5000029 147.3000488 144.3999968 111.6000366 190.8000059 150.9000244 192.5000029",
    fill: "#c6cbd1"
  })), _polygon403 || (_polygon403 = /*#__PURE__*/React.createElement("polygon", {
    points: "111.6000366 190.8000059 150.2000122 192.0999937 73.9000244 260.5999937 111.6000366 190.8000059",
    fill: "#d9dfe6"
  })), _polygon404 || (_polygon404 = /*#__PURE__*/React.createElement("polygon", {
    points: "49.8000488 212.6999998 91.4000244 162.0999937 147.6000366 144.3999968 49.8000488 212.6999998",
    fill: "#e1e9eb"
  })), _polygon405 || (_polygon405 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.4000244 162.0000029 145 96.5000029 147.6000366 144.5000029 91.4000244 162.0000029",
    fill: "#d2dbe1"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "326.9000244 313.5999937 254.8000488 348.900012 273.7000122 286.6999998",
    fill: "#9db1b9"
  })), _polygon406 || (_polygon406 = /*#__PURE__*/React.createElement("polygon", {
    points: "590 423.8000059 680.4000244 403.9999876 621 490.6999998 590 423.8000059",
    fill: "#c0ccd4"
  })), _polygon407 || (_polygon407 = /*#__PURE__*/React.createElement("polygon", {
    points: "621 490.6999998 682.2000732 500.1999998 680.4000244 403.9999876 621 490.6999998",
    fill: "#d7dfe2"
  })), _polygon408 || (_polygon408 = /*#__PURE__*/React.createElement("polygon", {
    points: "620.0999756 606.6000242 697.9000244 552.2999754 639.2000732 533.1000242 620.0999756 606.6000242",
    fill: "#d7dfe2"
  })), _polygon409 || (_polygon409 = /*#__PURE__*/React.createElement("polygon", {
    points: "621 490.6999998 619.7000732 547.6000242 639.3000488 533.1999998 621 490.6999998",
    fill: "#c9d1d9"
  })), _polygon410 || (_polygon410 = /*#__PURE__*/React.createElement("polygon", {
    points: "590.3000488 542.1000242 553.9000244 581.1000242 619.8000488 547.400012 590.3000488 542.1000242",
    fill: "#c9d1d9"
  })), _polygon411 || (_polygon411 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.9000244 514.4999876 525 542.1999998 560.5999756 499.8000059 499.9000244 514.4999876",
    fill: "#c9d1d9"
  })), _polygon412 || (_polygon412 = /*#__PURE__*/React.createElement("polygon", {
    points: "560.5 499.8000059 621 490.6999998 590.4000244 542.1999998 560.5 499.8000059",
    fill: "#cad8df"
  })), _polygon413 || (_polygon413 = /*#__PURE__*/React.createElement("polygon", {
    points: "475.4000244 413.0999937 527.2000732 413.3000059 481.9000244 438.8000059 475.4000244 413.0999937",
    fill: "#cad8df"
  })), _polygon414 || (_polygon414 = /*#__PURE__*/React.createElement("polygon", {
    points: "482 438.900012 548.9000244 465.4999876 500 514.4999876 482 438.900012",
    fill: "#cad8df"
  })), _polygon415 || (_polygon415 = /*#__PURE__*/React.createElement("polygon", {
    points: "525 542.2999754 554 580.900012 508.3000488 598.6999998 525 542.2999754",
    fill: "#cad8df"
  })), _polygon416 || (_polygon416 = /*#__PURE__*/React.createElement("polygon", {
    points: "754.8000488 431.1999998 736.9000244 497.3000059 788.7000732 492.4999876 754.8000488 431.1999998",
    fill: "#e5eaed"
  })), _polygon417 || (_polygon417 = /*#__PURE__*/React.createElement("polygon", {
    points: "682.2000732 500.0999937 639.2000732 533.1000242 698.0999756 552.2999754 682.2000732 500.0999937",
    fill: "#e5eaed"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m783.5999756,425.4999876c1.3000488,3.5,45.5,6.3999939,45.5,6.3999939l-14-53.2999878-31.5,46.8999939Z",
    fill: "#d2dbe4"
  })), _polygon418 || (_polygon418 = /*#__PURE__*/React.createElement("polygon", {
    points: "830.8000488 355.1999998 815.0999756 378.5999937 829.0999756 431.900012 830.8000488 355.1999998",
    fill: "#dee5eb"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 294.1812134,
    y1: 822.0007811,
    x2: 294.187439,
    y2: 822.0018187,
    fill: "#ce2b27"
  })), _polygon419 || (_polygon419 = /*#__PURE__*/React.createElement("polygon", {
    points: "783.4000244 563.6999998 829.7000732 494.9999876 788.5 492.400012 783.4000244 563.6999998",
    fill: "#ebeff1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m502.4000244,798.3000364v-.000061l-6-10.5999756-.1142578-.0586548-7.8857422-10.9413452s-6.6000977-6.2000122-6.8000488-6.4000244c0,0-9.7999878-7.7999878-10.0999756-8.0999756,0,0,.3000488.0999756.000061,0-.2000122,0-11.9000244-11.7000122-11.9000244-11.7000122l-7.2000122-9-10.7000122-6.2000122,1.7000122,9.9000244,1.9000244,8.9000244,3.5,15.8999634.6999512,2.1873779v.3126221l.1229248.0740356,1.2770996,4.1259766,13.7999878,7s10.6000366,13.9000244,11.2000122,14.5l6.9000244,6.5,9.0999756,8.9000244-.0008545-.0015869c0,.000061.0008545.0015259.0008545.0015259v.000061l8.0999756,10.6999512c.4000244.4000244,2,7.2000122,2,7.2000122l-1.2999268,4.4000244.9976807.3261719c-.0476074.8405762-3.9854736,31.2618408-4.2788086,33.5274048l-.1188965.3464355,5.2998047,5.4960327.0001221.0039673.0004883-.0032349.0996094.1032104-.0231934-.5496826,3.1231689-18.2503052c0-.7999878,1.5-14.0999756,1.5-14.0999756l-1.4000244-5.2000122,8.3000488,1.8999634.2827148-4.0908203c.9521484.3544922,1.8435059.717041,2.0172119.8908081l2.5-3.1999512,1.5999756-5.3000488-3.8999023-6.1999512-4.3000488-5.1000366-7.8389893-12.5026245-2.1610107-5.6973267Zm-13.6999512-1.000061h0Z",
    fill: "#af937e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m533,679.4999876l-6.3370361,17.5256348-.0629883.0744019-.3885498,9.3239746.3885498-9.4240112-3.3999023,8,2.9998779,1.6999512v.000061l.9991455.4050293-6.4990234,32.0949707-1.0820312,7.4749756-.0180664.0250244-2.5,14-.8999023,5.9000244-3,17.6999512-4.8029785,25.8156738,1.3657227,2.1780396,2.637207,4.2062988,9.4000244-48.7999878h0s5.3184814-24.5395508,5.9500732-26.4761353l.0499268-.1238403,6.6999512-31.6000366.0126953-.0195923,4.4873047-.7803955s.6999512-7.3999023,1-7.7000122v.000061s1.0999756-16.1000366,1.0999756-16.4000244l.8000488-24.5-8.9000244,19.3999634Z",
    fill: "#af937e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m510.8000488,842.7999754l3.4000244-3.2999268-8.3000488-1.9000244,1.4000244,5.1999512h3.5Z",
    fill: "#af937e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m351.5999756,744.5000486h0l-7.7999268,8.0999756c-.5999756.5999756-3.2000122,6.6999512-3.2000122,6.6999512l-19.7000122-2.7000122-21.2171631,14.045166-.1828613.0548706c-.7999878.7999878-10.5,18.7999878-10.5,18.7999878l-4.5999756,19.4000244.2000122,23.3999634,6.8999634,36.3000488,13.1000366,25.0999756,9.5,11.0999756,8.5999756,7.2000122,17.9000244,6.6000366-4.6000366,23.8999634-5.7999878,4.1000366-3.2000122,11-6.5,28.6999512-1.8999634,15.3000488-2.2000122,11.6999512-4.7000122,13.4000244,3.2000122.9000244-.7999878,5.4000244-5.2000122,4.3999023-3.9000244,2.7000732-7.3999634,7.4000244.5999756,3.0999756c.7243652,0,10.1380005,4.3447266,11.9121094,5.1665039l.1879272.1334229,4.0999756,1.9000244,16.2999878-1.9000244-.7000122-4.0999756-2.0999756-2.7999268.9000244-9.8000488,1.1999512-13.5999756.0397949-.0437012,1.6602173,1.5437012,4.1000366-14.5,12.6999512-29-.0004883-.0022583.0004883.0021973s4.9000244-18.7999878,5.9000244-19.7999878l3.4000244-4.6999512-3.8000488-7.9000244-3.3999634-18-3.2999878-14.7999878-.6801147-11.2999878-.1199341-31.8000488,2.6908569-36.6749268.0091553-.0250244-.0061646-.0162354.0061646-.0838013-.0186157.0509033-.2724609-.7189331,5.0007324-38.2548828-.0571289.0751953,3.534729-28.5493774.0127563-.0028687,3.7000122-22.4000244,2.2999878-11.9000244-4.4000244,1.8000488-7.4000244,5.9000244Zm-21.3959351,226.2232056l.0161743.899231-.0202026-.9224854.0040283.0232544Zm2.7959595-124.123291l.0004883.0013428-.0004883-.0012817v-.000061Z",
    fill: "#7d624d"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m423.9000244,1045.7999754l-9.4000244-4.5999756-.0999756-11.5,3.2000122-18.4000244c0-1.2000122,5-21.2999878,5-21.2999878l2.2999878-11.3999634-8.1605225-4.7193604c.0041504-.0499268.0067139-.0806885.0067139-.0806885l-19.1461792-5.8999634-9.7999878,3.2000122,4.2999878,19.3999634,1,19.5,1,14.500061-3.4000244,16.3999023-.2000122,4.7000732,3.8000488,2.6999512-1.8000488,7.4000244-1.1999512,3.8000488s4.5,1.1999512,5.5999756,1.1999512l10.5999756.6999512,9.3000488-3.7999268,10-4,.6999512-3.4000244-1.6999512-1-1.9000244-3.4000244Z",
    fill: "#af937e"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m481.5697021,966.1236448l-11.7696533,47.8763428-8.7000122,33.500061,3.0999756,1.6999512,4.5.5999756,6.6000366-33.1999512s10.9000244-48.4000244,10.9000244-49.2000122l-4.5-2.4000244-.1303711,1.1236572Z",
    fill: "#af937e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m422.9000244,715.6999998l3.7000122-14-1.2000122-14.3999634-5.7000122-8.7000122-10.5-4.7000122-.6890869,18.7028809-.1497803.2971191.1356201.0492554-1.2967529,19.5507202-1.0999756,10.1000366v.9924316c-.6082764-.1138306-1.046875-.1924438-1.0999756-.1924438-.024353.024353.0414429.1036377.1707764.2211304l-.1708374-.1211548-.5999756,3.9000244-5.6960449.7628784-.6039429-5.2628784.3928833-9.4296265.1071167-.1703491-.0952759.0029907.2952881-6.0030518-.3000488-10.499939s-.0027466.0003662-.0029297.0003662l-.3970337-13.6004028-1-8.9000244-9.7999878,4.7000122-7.1000366,14.5,2.4000244,13.4000244c0,.7999878,2.2000122,12.5,2.2000122,12.5l-5,6.2000122,4.6999512,3.5,15,6-.5639038-4.9143677,5.8639526,1.3143311.7307129-.1735229.2692871,4.173584s9.7000122-3.4000244,10.2999878-3.4000244l12.0999756-7.3000488-4.4885864-3.6905518-.8114014-5.4094238Zm-8.184021,5.005127l-.0154419-.0007324-.0005493-.0043945.0159912.005127Zm-1.6159668-37.2051392c.0172729.0172729.1348877.411377.3164673,1.0410767l-.3164673-1.0410767Zm-26.0905762,15.1830444c.0219116.0546875.0712891.1265259.1654663.2260742l-.2749023-.2091064.109436-.0169678Zm19.0905762,29.6210938v.0552368c-1.0667725.2380981-2.0285034.4607544-2.4975586.5700073l-.4024658-.0293579,2.9000244-.5958862Z",
    fill: "#af937e"
  })), _polygon420 || (_polygon420 = /*#__PURE__*/React.createElement("polygon", {
    points: "346 896.7999754 347.2999878 918.399951 352.2999878 905.9999266 346 896.7999754",
    fill: "#ce2b27"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m356.000061,779.1999388l-.000061.000061-4.1999512,30.7999878-3.5,33.2000122-1.7000122,27.0999756-.5999756,26.5,1.2999268,21.5999756.000061.000061,6.6999512,32.7999878,9.7000122,20.2000122,13.7999878,16.2999878v-7.2999878l7.9000244-8.5,12.1514893-3.9840698,19.0485229,5.8840332,13,7.6000366,18.7999878.2999878,12.5999756-10.0999756,7.2000122-3.2000122,15.000061-2.6000366v.000061-.000061h0l8.3999023,4.6000366,5.6000977,6.2000122,16.7999268,3.5s21.0999756-6.1000366,21.4000244-6.2000122l30.3000488-22.4000244h0l19.3999023-9,14.7000732,14.2999878,8.102417,14.2525024c.0378418.3295898.0712891.5001831.0976562.4475098.015625-.0206909.0412598-.0751343.0725098-.1481323l.0273438.0481567-.0068359-.095459c.6245117-1.5182495,3.6069336-10.904541,3.6069336-10.904541l-2.7000732-9.9000244c-.8000488-.7999878-7.5-9.9000244-7.5-9.9000244l-21.4000244-15.3999634-30.5999756-16.9000244-21.1999512-11.8999634-20.8000488-15.7000122-13.2999268-13.9000244-.2541504-.2131348-12.3459473-17.086853-10.1999512-17.8999634-.0808716-.0869751-7.6191406-17.6130371c.0310669-.0186157.0216675-.0383911-.0227051-.0591431l-6.7772827-17.6408691-8.0999756-26.2000122-4.9000244-22.5-.0264893-.0526733-2.4735107-14.2473145-5.0999756-.7999878-4.7000122-6.4000244-1.7000122,1.1000366-5.7999878-3.4000244h0l-2.6000366,1.4000244-8.7999878,4.5.0263672.0174561-6.6671143,1.5784302.0407715-8.5958862,1.0999756-10.1000366.6885986-7.5741577.0114136-.0258179c.2000122-.2999878,1.0999756-23.9000244,1.0999756-23.9000244l.2000122-7.0999756h.000061l-.000061-.0001221-.5-12.5999146-6.7000122-.1999512-6.1999512.7999878.7999878,8.0999756,1.5,13.2000122.0025635.0031128.5974121,24.0968628-.5999756,15.7000122.6582031,7.145813-5.5582275-1.2457886-11.5-2.4000244-5.0999756,4-3.7999878-.3999634-4.6000366,2.7999878-4.8999634,3.8999634-2.2000122,12-5.1000366,30.4000244",
    fill: "#ce2b27"
  })), _polygon421 || (_polygon421 = /*#__PURE__*/React.createElement("polygon", {
    points: "363.3000488 736.7999754 361.1000366 748.7999754 367.3000488 741.9999876 363.3000488 736.7999754",
    fill: "#d93128"
  })), _polygon422 || (_polygon422 = /*#__PURE__*/React.createElement("polygon", {
    points: "368.2000122 732.900012 367.3000488 741.9999876 363.3000488 736.7999754 368.2000122 732.900012",
    fill: "#d42f27"
  })), _polygon423 || (_polygon423 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.1000366 741.9999876 367.3000488 741.9999876 368.2000122 732.900012 370.1000366 741.9999876",
    fill: "#a82323"
  })), _polygon424 || (_polygon424 = /*#__PURE__*/React.createElement("polygon", {
    points: "372.8000488 730.1000242 376.6000366 730.4999876 374.4000244 741.7999754 372.8000488 730.1000242",
    fill: "#bd2827"
  })), _polygon425 || (_polygon425 = /*#__PURE__*/React.createElement("polygon", {
    points: "368.2000122 732.900012 372.8000488 730.1000242 370.1000366 742.1000242 368.2000122 732.900012",
    fill: "#bd2827"
  })), _polygon426 || (_polygon426 = /*#__PURE__*/React.createElement("polygon", {
    points: "381.7000122 726.4999876 384.5 736.2999754 376.6000366 730.4999876 381.7000122 726.4999876",
    fill: "#d42f27"
  })), _polygon427 || (_polygon427 = /*#__PURE__*/React.createElement("polygon", {
    points: "381.7000122 726.4999876 393.2000122 728.900012 384.5 736.2999754 381.7000122 726.4999876",
    fill: "#bd2827"
  })), _polygon428 || (_polygon428 = /*#__PURE__*/React.createElement("polygon", {
    points: "393.2000122 728.900012 404.8000488 731.4999876 384.5 736.2999754 393.2000122 728.900012",
    fill: "#c52627"
  })), _polygon429 || (_polygon429 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.5 725.1000242 424.1000366 723.6999998 424.9000244 735.1000242 421.5 725.1000242",
    fill: "#b72e27"
  })), _polygon430 || (_polygon430 = /*#__PURE__*/React.createElement("polygon", {
    points: "429.9000244 727.1000242 431.6000366 725.9999876 436.3000488 732.400012 429.9000244 727.1000242",
    fill: "#db3027"
  })), _polygon431 || (_polygon431 = /*#__PURE__*/React.createElement("polygon", {
    points: "429.9000244 727.1000242 429.3000488 739.7999754 424.1000366 723.6999998 429.9000244 727.1000242",
    fill: "#d2352c"
  })), _polygon432 || (_polygon432 = /*#__PURE__*/React.createElement("polygon", {
    points: "424.9000244 734.9999876 429.3000488 739.7999754 424.1000366 723.6999998 424.9000244 734.9999876",
    fill: "#d32c28"
  })), _polygon433 || (_polygon433 = /*#__PURE__*/React.createElement("polygon", {
    points: "429.9000244 727.1000242 432.1000366 744.400012 429.3000488 739.7999754 429.9000244 727.1000242",
    fill: "#a82123"
  })), _polygon434 || (_polygon434 = /*#__PURE__*/React.createElement("polygon", {
    points: "436.3000488 732.400012 432.1000366 744.400012 429.9000244 727.1000242 436.3000488 732.400012",
    fill: "#d22d27"
  })), _polygon435 || (_polygon435 = /*#__PURE__*/React.createElement("polygon", {
    points: "412.8000488 729.6000242 419 733.6999998 415.4000244 739.7999754 412.8000488 729.6000242",
    fill: "#cf332d"
  })), _polygon436 || (_polygon436 = /*#__PURE__*/React.createElement("polygon", {
    points: "418.9000244 733.6999998 421.5 725.1000242 412.7000122 729.6000242 418.9000244 733.6999998",
    fill: "#b72e27"
  })), _polygon437 || (_polygon437 = /*#__PURE__*/React.createElement("polygon", {
    points: "418.9000244 733.6999998 424.9000244 734.9999876 421.5 725.1000242 418.9000244 733.6999998",
    fill: "#b72e27"
  })), _polygon438 || (_polygon438 = /*#__PURE__*/React.createElement("polygon", {
    points: "424.9000244 734.9999876 425.2000122 756.400012 429.3000488 739.7999754 424.9000244 734.9999876",
    fill: "#d2352c"
  })), _polygon439 || (_polygon439 = /*#__PURE__*/React.createElement("polygon", {
    points: "415.4000244 739.7999754 405.9500427 743.5556775 412.8000488 729.6000242 415.4000244 739.7999754",
    fill: "#c52627"
  })), _polygon440 || (_polygon440 = /*#__PURE__*/React.createElement("polygon", {
    points: "405.9500427 743.5556775 392.8000488 740.9999876 412.8000488 729.6000242 405.9500427 743.5556775",
    fill: "#cf332d"
  })), _polygon441 || (_polygon441 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.8000488 740.9999876 384.5 736.2999754 412.8000488 729.6000242 392.8000488 740.9999876",
    fill: "#c52627"
  })), _polygon442 || (_polygon442 = /*#__PURE__*/React.createElement("polygon", {
    points: "384.5 736.2999754 391.3000488 741.9999876 392.8000488 740.9999876 384.5 736.2999754",
    fill: "#bd2827"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m391.3000488,741.9999876s10.5999756,4.9000244,10.9000244,4.7999878c.4000244-.0999756-9.4000244-5.7999878-9.4000244-5.7999878l-1.5,1Z",
    fill: "#a62923"
  })), _polygon443 || (_polygon443 = /*#__PURE__*/React.createElement("polygon", {
    points: "402.2000122 746.900012 404.8000488 743.1000242 392.8000488 740.9999876 402.2000122 746.900012",
    fill: "#a62923"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m402.2000122,746.900012c.7999878,0,12.2999878-2.0999756,12.2999878-2.0999756l-8.5499573-1.244359-3.7500305,3.3443345Z",
    fill: "#b32b26"
  })), _polygon444 || (_polygon444 = /*#__PURE__*/React.createElement("polygon", {
    points: "405.9500427 743.5556775 415.4000244 739.7999754 414.5 744.7999754 405.9500427 743.5556775",
    fill: "#a62923"
  })), _polygon445 || (_polygon445 = /*#__PURE__*/React.createElement("polygon", {
    points: "414.5 744.7999754 419 733.6999998 415.4000244 739.7999754 414.5 744.7999754",
    fill: "#a62923"
  })), _polygon446 || (_polygon446 = /*#__PURE__*/React.createElement("polygon", {
    points: "414.5 744.7999754 411.4000244 749.6000242 402.2000122 746.900012 414.5 744.7999754",
    fill: "#c52627"
  })), _polygon447 || (_polygon447 = /*#__PURE__*/React.createElement("polygon", {
    points: "414.5 744.7999754 419.4000244 745.9999876 419 733.6999998 414.5 744.7999754",
    fill: "#c52627"
  })), _polygon448 || (_polygon448 = /*#__PURE__*/React.createElement("polygon", {
    points: "419.4000244 745.9999876 424.9000244 734.9999876 419 733.6999998 419.4000244 745.9999876",
    fill: "#b72e27"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m384.5,736.2999754c0,.2000122,6.2999878,11,6.2999878,11l.5-5.2999878-6.7999878-5.7000122Z",
    fill: "#bd2826"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m391.3000488,741.9999876c.2000122.2000122,8.5,9.1000366,8.5,9.1000366l2.5-4.3000488-11-4.7999878Z",
    fill: "#d83127"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m399.8000488,751.1000242c.5,0,11.5999756-1.5,11.5999756-1.5l-9.2000122-2.7000122-2.3999634,4.2000122Z",
    fill: "#d1362d"
  })), _polygon449 || (_polygon449 = /*#__PURE__*/React.createElement("polygon", {
    points: "390.7999878 747.2999754 399.8000488 751.1000242 391.3000488 741.9999876 390.7999878 747.2999754",
    fill: "#bd2826"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m390.7999878,747.2999754l8.1000366,9,.9000244-5.1999512-9.000061-3.8000488Z",
    fill: "#a92423"
  })), _polygon450 || (_polygon450 = /*#__PURE__*/React.createElement("polygon", {
    points: "398.9000244 756.2999754 409.6000366 757.1000242 399.8000488 751.1000242 398.9000244 756.2999754",
    fill: "#b32b26"
  })), _polygon451 || (_polygon451 = /*#__PURE__*/React.createElement("polygon", {
    points: "399.8000488 751.1000242 411.4000244 749.6000242 409.6000366 757.1000242 399.8000488 751.1000242",
    fill: "#a92423"
  })), _polygon452 || (_polygon452 = /*#__PURE__*/React.createElement("polygon", {
    points: "411.4000244 749.6000242 414.5 744.7999754 409.6000366 757.1000242 411.4000244 749.6000242",
    fill: "#a92423"
  })), _polygon453 || (_polygon453 = /*#__PURE__*/React.createElement("polygon", {
    points: "419.4000244 745.9999876 409.6000366 757.1000242 414.5 744.7999754 419.4000244 745.9999876",
    fill: "#b32b26"
  })), _polygon454 || (_polygon454 = /*#__PURE__*/React.createElement("polygon", {
    points: "419.4000244 745.9999876 425.2000122 756.400012 424.9000244 734.9999876 419.4000244 745.9999876",
    fill: "#bd2726"
  })), _polygon455 || (_polygon455 = /*#__PURE__*/React.createElement("polygon", {
    points: "419.4000244 745.9999876 411.7000122 764.400012 409.6000366 757.1000242 419.4000244 745.9999876",
    fill: "#c52827"
  })), _polygon456 || (_polygon456 = /*#__PURE__*/React.createElement("polygon", {
    points: "411.7000122 764.400012 403.2000122 767.2999754 409.6000366 757.1000242 411.7000122 764.400012",
    fill: "#d02d28"
  })), _polygon457 || (_polygon457 = /*#__PURE__*/React.createElement("polygon", {
    points: "403.2000122 767.2999754 398.9000244 756.2999754 409.6000366 757.1000242 403.2000122 767.2999754",
    fill: "#c52827"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m403.2000122,767.2999754c-.7000122-.7000122-9.9000244-11.7999878-9.9000244-11.7999878l5.7000122.7999878,4.2000122,11Z",
    fill: "#d02d28"
  })), _polygon458 || (_polygon458 = /*#__PURE__*/React.createElement("polygon", {
    points: "393.3000488 755.4999876 390.7999878 747.2999754 398.9000244 756.2999754 393.3000488 755.4999876",
    fill: "#d02d28"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m393.3000488,755.4999876c-.5-.5-8.7999878-19.2000122-8.7999878-19.2000122l6.2999878,11,2.5,8.2000122Z",
    fill: "#d83127"
  })), _polygon459 || (_polygon459 = /*#__PURE__*/React.createElement("polygon", {
    points: "376.6000366 730.4999876 379.3000488 752.1999998 374.4000244 741.6999998 376.6000366 730.4999876",
    fill: "#ac2124"
  })), _polygon460 || (_polygon460 = /*#__PURE__*/React.createElement("polygon", {
    points: "379.3000488 752.2999754 384.5 736.2999754 376.6000366 730.4999876 379.3000488 752.2999754",
    fill: "#d83127"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m384.5,736.2999754l2.8000488,17.5,6.0920924,1.8000488-8.8921413-19.3000488Z",
    fill: "#c02e27"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m379.3000488,752.1999998c0,.5.2000122,12.7999878.2000122,12.7999878l7.7999878-11.2000122-8-1.5999756Z",
    fill: "#d83127"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m379.3000488,752.2999754c0-.4000244,5.1999512-16,5.1999512-16l2.8000488,17.5-8-1.5Z",
    fill: "#e33c2f"
  })), _polygon461 || (_polygon461 = /*#__PURE__*/React.createElement("polygon", {
    points: "367.3000488 741.9999876 364.3000488 759.6999998 370.1000366 741.9999876 367.3000488 741.9999876",
    fill: "#a82323"
  })), _polygon462 || (_polygon462 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.1000366 741.9999876 367.8000488 766.2999754 364.3000488 759.6999998 370.1000366 741.9999876",
    fill: "#971d1e"
  })), _polygon463 || (_polygon463 = /*#__PURE__*/React.createElement("polygon", {
    points: "374.4000244 741.7999754 370.1000366 741.9999876 372.8000488 730.1000242 374.4000244 741.7999754",
    fill: "#d42f27"
  })), _polygon464 || (_polygon464 = /*#__PURE__*/React.createElement("polygon", {
    points: "374.4000244 741.6999998 372.9000244 762.400012 379.3000488 752.1999998 374.4000244 741.6999998",
    fill: "#ac2124"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m372.9000244,762.400012l6.5999756,2.5999756-.2000122-12.7999878-6.3999634,10.2000122Z",
    fill: "#971d1e"
  })), _polygon465 || (_polygon465 = /*#__PURE__*/React.createElement("polygon", {
    points: "379.500061 764.9999876 380.5 784.6000242 372.9000244 762.400012 379.500061 764.9999876",
    fill: "#a82523"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m372.9000244,762.400012l-2.7999878-20.4000244,4.2999878-.2000122-1.5,20.6000366Z",
    fill: "#d42f27"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m372.9000244,762.400012c-.4000244.4000244-5.1292676,4.1081789-5.1292676,4.1081789l2.3292798-24.5082033,2.7999878,20.4000244Z",
    fill: "#d42f27"
  })), _polygon466 || (_polygon466 = /*#__PURE__*/React.createElement("polygon", {
    points: "364.3000488 759.6999998 361.1000366 748.7999754 367.3000488 741.9999876 364.3000488 759.6999998",
    fill: "#d42f27"
  })), _polygon467 || (_polygon467 = /*#__PURE__*/React.createElement("polygon", {
    points: "361.1000366 748.7999754 356 779.1999998 364.3000488 759.6999998 361.1000366 748.7999754",
    fill: "#d93128"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m364.3000488,759.6999998c0,.5-2.6000366,16.5-2.6000366,16.5l-5.6999512,3,8.2999878-19.5Z",
    fill: "#d22d28"
  })), _polygon468 || (_polygon468 = /*#__PURE__*/React.createElement("polygon", {
    points: "361.7000122 776.1999998 367.8000488 766.2999754 364.3000488 759.6999998 361.7000122 776.1999998",
    fill: "#a82323"
  })), _polygon469 || (_polygon469 = /*#__PURE__*/React.createElement("polygon", {
    points: "361.7000122 776.1999998 366.4000244 789.1000242 367.8000488 766.2999754 361.7000122 776.1999998",
    fill: "#a32022"
  })), _polygon470 || (_polygon470 = /*#__PURE__*/React.createElement("polygon", {
    points: "367.8000488 766.2999754 371.6000366 782.2999754 372.9000244 762.400012 367.8000488 766.2999754",
    fill: "#dc392d"
  })), _polygon471 || (_polygon471 = /*#__PURE__*/React.createElement("polygon", {
    points: "367.8000488 766.2999754 366.4000244 789.1000242 371.6000366 782.2999754 367.8000488 766.2999754",
    fill: "#d42d27"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m371.6000366,782.2999754c0,.2000122,8.8999634,2.3000488,8.8999634,2.3000488l-7.5999146-22.2000122-1.3000488,19.8999634Z",
    fill: "#971d1e"
  })), _polygon472 || (_polygon472 = /*#__PURE__*/React.createElement("polygon", {
    points: "380.5 784.6000242 384 806.900012 371.6000366 782.2999754 380.5 784.6000242",
    fill: "#ac2124"
  })), _polygon473 || (_polygon473 = /*#__PURE__*/React.createElement("polygon", {
    points: "371.6000366 782.2999754 370.3000488 811.9999876 375.9000244 800.400012 371.6000366 782.2999754",
    fill: "#ae2524"
  })), _polygon474 || (_polygon474 = /*#__PURE__*/React.createElement("polygon", {
    points: "375.9000244 800.400012 371.6000366 782.2999754 384 806.900012 375.9000244 800.400012",
    fill: "#971d1e"
  })), _polygon475 || (_polygon475 = /*#__PURE__*/React.createElement("polygon", {
    points: "366.4000244 789.1000242 370.3000488 811.9999876 371.6000366 782.2999754 366.4000244 789.1000242",
    fill: "#d42d27"
  })), _polygon476 || (_polygon476 = /*#__PURE__*/React.createElement("polygon", {
    points: "366.4000244 789.1000242 363.2000122 812.4999876 361.7000122 776.1999998 366.4000244 789.1000242",
    fill: "#af2625"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m361.7000122,776.1999998c0,1-3.2000122,23.0999756-3.2000122,23.0999756l-2.5-20.0999756,5.7000122-3Z",
    fill: "#d22d28"
  })), _polygon477 || (_polygon477 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.5 799.1999998 361.7000122 776.1999998 363.2000122 812.4999876 358.5 799.1999998",
    fill: "#af2625"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m358.5,799.1999998l-2.4000244,25.5,7.1000366-12.2000122-4.7000122-13.2999878Z",
    fill: "#b72725"
  })), _polygon478 || (_polygon478 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.5 799.1999998 351.8000488 809.9999876 356 779.1999998 358.5 799.1999998",
    fill: "#d6372c"
  })), _polygon479 || (_polygon479 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.5 799.1999998 351.8000488 809.9999876 356.1000366 824.6999998 358.5 799.1999998",
    fill: "#d22d28"
  })), _polygon480 || (_polygon480 = /*#__PURE__*/React.createElement("polygon", {
    points: "366.4000244 789.1000242 363.2000122 812.4999876 370.3000488 811.9999876 366.4000244 789.1000242",
    fill: "#cf2928"
  })), _polygon481 || (_polygon481 = /*#__PURE__*/React.createElement("polygon", {
    points: "375.9000244 800.400012 382.5 830.400012 384 806.900012 375.9000244 800.400012",
    fill: "#a82523"
  })), _polygon482 || (_polygon482 = /*#__PURE__*/React.createElement("polygon", {
    points: "375.9000244 800.400012 370.3000488 811.9999876 369.2000122 831.400012 375.9000244 800.400012",
    fill: "#ae2524"
  })), _polygon483 || (_polygon483 = /*#__PURE__*/React.createElement("polygon", {
    points: "351.8000488 809.9999876 348.3000488 843.1999998 356.1000366 824.6999998 351.8000488 809.9999876",
    fill: "#e03127"
  })), _polygon484 || (_polygon484 = /*#__PURE__*/React.createElement("polygon", {
    points: "356.1000366 824.6999998 355 846.1999998 348.3000488 843.1999998 356.1000366 824.6999998",
    fill: "#cf2928"
  })), _polygon485 || (_polygon485 = /*#__PURE__*/React.createElement("polygon", {
    points: "363.2000122 812.4999876 362.1000366 839.9999876 356.1000366 824.6999998 363.2000122 812.4999876",
    fill: "#be2826"
  })), _polygon486 || (_polygon486 = /*#__PURE__*/React.createElement("polygon", {
    points: "363.2000122 812.4999876 369.2000122 831.400012 370.3000488 811.9999876 363.2000122 812.4999876",
    fill: "#be2826"
  })), _polygon487 || (_polygon487 = /*#__PURE__*/React.createElement("polygon", {
    points: "363.2000122 812.4999876 369.2000122 831.400012 362.1000366 839.9999876 363.2000122 812.4999876",
    fill: "#d42d27"
  })), _polygon488 || (_polygon488 = /*#__PURE__*/React.createElement("polygon", {
    points: "369.2000122 831.400012 382.4000244 861.7999754 375.9000244 800.4458214 369.2000122 831.400012",
    fill: "#a32022"
  })), _polygon489 || (_polygon489 = /*#__PURE__*/React.createElement("polygon", {
    points: "382.5 830.2999754 382.4000244 861.900012 386.3000488 849.6999998 382.5 830.2999754",
    fill: "#a32022"
  })), _polygon490 || (_polygon490 = /*#__PURE__*/React.createElement("polygon", {
    points: "382.4000244 861.7999754 382.6000366 830.6000242 375.8910189 800.3621048 382.4000244 861.7999754",
    fill: "#8e1b1c"
  })), _polygon491 || (_polygon491 = /*#__PURE__*/React.createElement("polygon", {
    points: "348.3000488 843.1999998 346.6000366 870.2999754 355 846.1999998 348.3000488 843.1999998",
    fill: "#cf2928"
  })), _polygon492 || (_polygon492 = /*#__PURE__*/React.createElement("polygon", {
    points: "355 846.1999998 355.8000488 870.6000242 346.6000366 870.2999754 355 846.1999998",
    fill: "#d7382c"
  })), _polygon493 || (_polygon493 = /*#__PURE__*/React.createElement("polygon", {
    points: "362.1000366 839.9999876 355 846.1999998 356.1000366 824.6999998 362.1000366 839.9999876",
    fill: "#b72725"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m362.1000366,839.9999876c.5999756.5999756.7000122,24.9000244.7000122,24.9000244l-7.8000488-18.7000122,7.1000366-6.2000122Z",
    fill: "#be2826"
  })), _polygon494 || (_polygon494 = /*#__PURE__*/React.createElement("polygon", {
    points: "362.1000366 839.9999876 370.4000244 857.900012 369.2000122 831.400012 362.1000366 839.9999876",
    fill: "#c92727"
  })), _polygon495 || (_polygon495 = /*#__PURE__*/React.createElement("polygon", {
    points: "362.1000366 839.9999876 362.8000488 864.900012 370.4000244 857.900012 362.1000366 839.9999876",
    fill: "#be2826"
  })), _polygon496 || (_polygon496 = /*#__PURE__*/React.createElement("polygon", {
    points: "369.2000122 831.400012 370.4000244 857.900012 382.4000244 861.7999754 369.2000122 831.400012",
    fill: "#b42625"
  })), _polygon497 || (_polygon497 = /*#__PURE__*/React.createElement("polygon", {
    points: "384 806.900012 391.6000366 840.6999998 382.5 830.400012 384 806.900012",
    fill: "#ac2124"
  })), _polygon498 || (_polygon498 = /*#__PURE__*/React.createElement("polygon", {
    points: "391.6000366 840.6999998 400.6000366 867.7999754 386.3000488 849.6000242 391.6000366 840.6999998",
    fill: "#bf2927"
  })), _polygon499 || (_polygon499 = /*#__PURE__*/React.createElement("polygon", {
    points: "386.3000488 849.6999998 382.5 830.400012 391.6000366 840.6999998 386.3000488 849.6999998",
    fill: "#971d1e"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m386.3000488,849.6000242c0,1.2000122,12.7999878,38.2999878,12.7999878,38.2999878l1.5-20.1999512-14.2999878-18.1000366Z",
    fill: "#ac2124"
  })), _polygon500 || (_polygon500 = /*#__PURE__*/React.createElement("polygon", {
    points: "382.4000244 861.7999754 399.1000366 887.900012 386.3000488 849.6000242 382.4000244 861.7999754",
    fill: "#7b1819"
  })), _polygon501 || (_polygon501 = /*#__PURE__*/React.createElement("polygon", {
    points: "382.4000244 861.7999754 370.4000244 857.900012 373.4000244 879.4999876 382.4000244 861.7999754",
    fill: "#8e1b1c"
  })), _polygon502 || (_polygon502 = /*#__PURE__*/React.createElement("polygon", {
    points: "346.6000366 870.2999754 346 896.7999754 355.8000488 870.6000242 346.6000366 870.2999754",
    fill: "#cf2928"
  })), _polygon503 || (_polygon503 = /*#__PURE__*/React.createElement("polygon", {
    points: "355 846.1999998 355.8000488 870.6000242 362.8000488 864.900012 355 846.1999998",
    fill: "#c32827"
  })), _polygon504 || (_polygon504 = /*#__PURE__*/React.createElement("polygon", {
    points: "362.8000488 864.900012 365.2000122 889.2999754 370.4000244 857.900012 362.8000488 864.900012",
    fill: "#c02927"
  })), _polygon505 || (_polygon505 = /*#__PURE__*/React.createElement("polygon", {
    points: "373.4000244 879.4999876 378.3000488 904.1000242 365.2000122 889.2999754 373.4000244 879.4999876",
    fill: "#c02927"
  })), _polygon506 || (_polygon506 = /*#__PURE__*/React.createElement("polygon", {
    points: "373.4000244 879.4999876 365.2000122 889.2999754 370.4000244 857.900012 373.4000244 879.4999876",
    fill: "#ae2524"
  })), _polygon507 || (_polygon507 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.7000122 880.400012 382.4000244 861.7999754 399.1000366 887.900012 387.7000122 880.400012",
    fill: "#8e1b1c"
  })), _polygon508 || (_polygon508 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.7000122 880.400012 382.4000244 861.7999754 378.3000488 904.1000242 387.7000122 880.400012",
    fill: "#7b1819"
  })), _polygon509 || (_polygon509 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.7000122 880.400012 394.7000122 909.1000242 399.1000366 887.900012 387.7000122 880.400012",
    fill: "#7b1819"
  })), _polygon510 || (_polygon510 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.7000122 880.400012 378.3000488 904.1000242 394.7000122 909.1000242 387.7000122 880.400012",
    fill: "#8e1b1c"
  })), _polygon511 || (_polygon511 = /*#__PURE__*/React.createElement("polygon", {
    points: "382.4000244 861.7999754 378.3000488 904.1000242 373.4000244 879.4999876 382.4000244 861.7999754",
    fill: "#ab2825"
  })), _polygon512 || (_polygon512 = /*#__PURE__*/React.createElement("polygon", {
    points: "400.6000366 867.7999754 408.9000244 892.1999998 399.1000366 887.900012 400.6000366 867.7999754",
    fill: "#bf2927"
  })), _polygon513 || (_polygon513 = /*#__PURE__*/React.createElement("polygon", {
    points: "399.1000366 887.900012 409.6000366 907.6999998 408.9000244 892.1999998 399.1000366 887.900012",
    fill: "#bd2627"
  })), _polygon514 || (_polygon514 = /*#__PURE__*/React.createElement("polygon", {
    points: "355.8000488 870.6000242 365.2000122 889.2999754 362.8000488 864.900012 355.8000488 870.6000242",
    fill: "#cf2928"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m346,896.7999754l1.2999878,21.5999756,5-12.4000244-6.2999878-9.1999512Z",
    fill: "#d8382d"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m352.3000488,905.9999876l-6.2999878-9.2000122,9.7999878-26.1999512-3.5,35.3999634Z",
    fill: "#d7382c"
  })), _polygon515 || (_polygon515 = /*#__PURE__*/React.createElement("polygon", {
    points: "352.3000488 905.9999876 365.2000122 889.2999754 355.8000488 870.6000242 352.3000488 905.9999876",
    fill: "#cf2928"
  })), _polygon516 || (_polygon516 = /*#__PURE__*/React.createElement("polygon", {
    points: "369.4000244 918.6999998 378.3000488 904.1000242 365.2000122 889.2999754 369.4000244 918.6999998",
    fill: "#d7382c"
  })), _polygon517 || (_polygon517 = /*#__PURE__*/React.createElement("polygon", {
    points: "378.3000488 904.1000242 390 937.1999998 379.9000244 920.6999998 378.3000488 904.1000242",
    fill: "#b42625"
  })), _polygon518 || (_polygon518 = /*#__PURE__*/React.createElement("polygon", {
    points: "378.3000488 904.1000242 394.7000122 909.1000242 390 937.400012 378.3000488 904.1000242",
    fill: "#7b1819"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m352.3000488,905.9999876c.5999756.5999756,12.5999756,31.2999878,12.5999756,31.2999878l-17.6000366-18.9000244,5.000061-12.3999634Z",
    fill: "#c8322c"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m352.3000488,905.9999876l17.0999756,12.7000122-4.5,18.5999756s-12.7000122-31.6999512-12.5999756-31.2999878Z",
    fill: "#d8382d"
  })), _polygon519 || (_polygon519 = /*#__PURE__*/React.createElement("polygon", {
    points: "369.4000244 918.6999998 379.9000244 920.6000242 378.3000488 904.1000242 369.4000244 918.6999998",
    fill: "#d52e28"
  })), _polygon520 || (_polygon520 = /*#__PURE__*/React.createElement("polygon", {
    points: "369.4000244 918.6999998 380.3000488 943.1000242 364.9000244 937.2999754 369.4000244 918.6999998",
    fill: "#db3027"
  })), _polygon521 || (_polygon521 = /*#__PURE__*/React.createElement("polygon", {
    points: "347.3000488 918.400012 354 951.1999998 364.9000244 937.2999754 347.3000488 918.400012",
    fill: "#c22927"
  })), _polygon522 || (_polygon522 = /*#__PURE__*/React.createElement("polygon", {
    points: "379.9000244 920.6000242 369.4000244 918.6999998 380.3000488 943.1000242 379.9000244 920.6000242",
    fill: "#db3027"
  })), _polygon523 || (_polygon523 = /*#__PURE__*/React.createElement("polygon", {
    points: "379.9000244 920.6000242 390 937.1999998 380.3000488 943.1000242 379.9000244 920.6000242",
    fill: "#d52e28"
  })), _polygon524 || (_polygon524 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.9000244 919.6000242 405.6000366 942.6000242 390 937.1999998 392.9000244 919.6000242",
    fill: "#991e1f"
  })), _polygon525 || (_polygon525 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.7000122 909.1000242 392.9000244 919.6999998 405.6000366 942.6000242 394.7000122 909.1000242",
    fill: "#8e1b1c"
  })), _polygon526 || (_polygon526 = /*#__PURE__*/React.createElement("polygon", {
    points: "399.1000366 887.900012 409.6000366 907.6999998 394.7000122 909.1000242 399.1000366 887.900012",
    fill: "#8f1b1c"
  })), _polygon527 || (_polygon527 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.7000122 909.1000242 413.7000122 923.6999998 409.1000366 934.6000242 394.7000122 909.1000242",
    fill: "#88171a"
  })), _polygon528 || (_polygon528 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.7000122 909.1000242 409.1000366 934.6000242 405.6000366 942.6000242 394.7000122 909.1000242",
    fill: "#7b1819"
  })), _polygon529 || (_polygon529 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.7000122 909.1000242 409.6000366 907.6999998 413.7000122 923.6999998 394.7000122 909.1000242",
    fill: "#9a1e20"
  })), _polygon530 || (_polygon530 = /*#__PURE__*/React.createElement("polygon", {
    points: "408.9000244 892.1999998 422.5 915.900012 409.6000366 907.6999998 408.9000244 892.1999998",
    fill: "#bd2627"
  })), _polygon531 || (_polygon531 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.4000244 915.7999754 434.8000488 934.6999998 413.7000122 923.6999998 422.4000244 915.7999754",
    fill: "#ac2124"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m422.4000244,915.7999754l-12.7999878-8.0999756,4.0999756,16,8.7000122-7.9000244Z",
    fill: "#a52022"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m354,951.1999998l9.7000122,20.2000122,1.2000122-34.1000366-10.9000244,13.9000244Z",
    fill: "#b82726"
  })), _polygon532 || (_polygon532 = /*#__PURE__*/React.createElement("polygon", {
    points: "363.7000122 971.400012 377.5 987.6999998 377.5 980.400012 363.7000122 971.400012",
    fill: "#851819"
  })), _polygon533 || (_polygon533 = /*#__PURE__*/React.createElement("polygon", {
    points: "377.5 980.400012 385.4000244 971.900012 363.7000122 971.400012 377.5 980.400012",
    fill: "#9a2021"
  })), _polygon534 || (_polygon534 = /*#__PURE__*/React.createElement("polygon", {
    points: "363.7000122 971.400012 364.9000244 937.2999754 385.4000244 971.900012 363.7000122 971.400012",
    fill: "#ae2324"
  })), _polygon535 || (_polygon535 = /*#__PURE__*/React.createElement("polygon", {
    points: "364.9000244 937.2999754 380.3000488 943.1000242 385.4000244 971.900012 364.9000244 937.2999754",
    fill: "#d52e28"
  })), _polygon536 || (_polygon536 = /*#__PURE__*/React.createElement("polygon", {
    points: "380.3000488 943.1000242 397.6000366 967.900012 385.4000244 971.900012 380.3000488 943.1000242",
    fill: "#df3127"
  })), _polygon537 || (_polygon537 = /*#__PURE__*/React.createElement("polygon", {
    points: "380.3000488 943.1000242 416.6000366 973.7999754 397.5 967.900012 380.3000488 943.1000242",
    fill: "#df3127"
  })), _polygon538 || (_polygon538 = /*#__PURE__*/React.createElement("polygon", {
    points: "390 937.1999998 416.6000366 973.7999754 380.3000488 943.1000242 390 937.1999998",
    fill: "#d52e28"
  })), _polygon539 || (_polygon539 = /*#__PURE__*/React.createElement("polygon", {
    points: "390 937.1999998 405.6000366 942.6000242 416.6000366 973.7999754 390 937.1999998",
    fill: "#7b1819"
  })), _polygon540 || (_polygon540 = /*#__PURE__*/React.createElement("polygon", {
    points: "405.6000366 942.6000242 416.4000244 960.1000242 416.6000366 973.7999754 405.6000366 942.6000242",
    fill: "#991e1f"
  })), _polygon541 || (_polygon541 = /*#__PURE__*/React.createElement("polygon", {
    points: "416.4000244 960.1000242 429.6000366 981.400012 416.6000366 973.7999754 416.4000244 960.1000242",
    fill: "#7b1819"
  })), _polygon542 || (_polygon542 = /*#__PURE__*/React.createElement("polygon", {
    points: "409.1000366 934.6000242 416.4000244 960.1000242 405.6000366 942.6000242 409.1000366 934.6000242",
    fill: "#88171a"
  })), _polygon543 || (_polygon543 = /*#__PURE__*/React.createElement("polygon", {
    points: "409.1000366 934.6000242 421.3000488 945.7999754 416.4000244 960.1000242 409.1000366 934.6000242",
    fill: "#7b1819"
  })), _polygon544 || (_polygon544 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.3000488 945.7999754 435.3000488 964.2999754 416.4000244 960.1000242 421.3000488 945.7999754",
    fill: "#8f1b1c"
  })), _polygon545 || (_polygon545 = /*#__PURE__*/React.createElement("polygon", {
    points: "435.3000488 964.2999754 429.6000366 981.400012 416.4000244 960.1000242 435.3000488 964.2999754",
    fill: "#851819"
  })), _polygon546 || (_polygon546 = /*#__PURE__*/React.createElement("polygon", {
    points: "435.3000488 964.2999754 448.4000244 981.6999998 429.6000366 981.400012 435.3000488 964.2999754",
    fill: "#851819"
  })), _polygon547 || (_polygon547 = /*#__PURE__*/React.createElement("polygon", {
    points: "435.3000488 964.2999754 461 971.6000242 448.4000244 981.6999998 435.3000488 964.2999754",
    fill: "#8f1b1c"
  })), _polygon548 || (_polygon548 = /*#__PURE__*/React.createElement("polygon", {
    points: "413.7000122 923.6999998 421.3000488 945.7999754 409.1000366 934.6000242 413.7000122 923.6999998",
    fill: "#88171a"
  })), _polygon549 || (_polygon549 = /*#__PURE__*/React.createElement("polygon", {
    points: "413.7000122 923.6999998 432.4000244 947.9999876 421.3000488 945.7999754 413.7000122 923.6999998",
    fill: "#9a1e20"
  })), _polygon550 || (_polygon550 = /*#__PURE__*/React.createElement("polygon", {
    points: "432.4000244 947.9999876 421.3000488 945.7999754 435.3000488 964.2999754 432.4000244 947.9999876",
    fill: "#a52022"
  })), _polygon551 || (_polygon551 = /*#__PURE__*/React.createElement("polygon", {
    points: "432.4000244 947.9999876 461 971.6000242 435.3000488 964.2999754 432.4000244 947.9999876",
    fill: "#a52022"
  })), _polygon552 || (_polygon552 = /*#__PURE__*/React.createElement("polygon", {
    points: "434.6000366 934.400012 432.4000244 947.9999876 413.7000122 923.6999998 434.6000366 934.400012",
    fill: "#ac2124"
  })), _polygon553 || (_polygon553 = /*#__PURE__*/React.createElement("polygon", {
    points: "434.6000366 934.400012 454.1000366 956.1999998 432.4000244 947.9999876 434.6000366 934.400012",
    fill: "#b82527"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m454.1000366,956.1999998l6.8999634,15.4000244s-29.0999146-23.7000122-28.5999146-23.6000366c.5999146.1000366,21.6999512,8.2000122,21.6999512,8.2000122Z",
    fill: "#bd2627"
  })), _polygon554 || (_polygon554 = /*#__PURE__*/React.createElement("polygon", {
    points: "454.1000366 956.1999998 468.2000122 968.400012 461 971.6000242 454.1000366 956.1999998",
    fill: "#cb342c"
  })), _polygon555 || (_polygon555 = /*#__PURE__*/React.createElement("polygon", {
    points: "454.1000366 956.1999998 450.1000366 936.900012 434.6000366 934.400012 454.1000366 956.1999998",
    fill: "#db3127"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m450.1000366,936.900012c.4000244.4000244,18.0999756,31.5,18.0999756,31.5l-14.0999756-12.2000122-4-19.2999878Z",
    fill: "#d52e27"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m450.1000366,936.900012c.5999756,0,14.2999878,13.7000122,14.2999878,13.7000122l3.7999878,17.7999878-18.0999756-31.5Z",
    fill: "#dc3a2e"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m450.1000366,936.900012l14.7000122.5999756-.4000244,13.1000366-14.2999878-13.7000122Z",
    fill: "#df3127"
  })), _polygon556 || (_polygon556 = /*#__PURE__*/React.createElement("polygon", {
    points: "464.8000488 937.4999876 480.3000488 956.6000242 464.4000244 950.6000242 464.8000488 937.4999876",
    fill: "#ce2b27"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m480.3000488,956.6000242l2.9000244,9.2000122-18.7999878-15.2000122,15.8999634,6Z",
    fill: "#db3127"
  })), _polygon557 || (_polygon557 = /*#__PURE__*/React.createElement("polygon", {
    points: "464.8000488 937.4999876 441.4000244 908.2999754 450.1000366 936.900012 464.8000488 937.4999876",
    fill: "#df3127"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m441.4000244,908.2999754c-.2999878.2999878-3.7000122,14.5999756-3.7000122,14.5999756l12.4000244,14-8.7000122-28.5999756Z",
    fill: "#df3127"
  })), _polygon558 || (_polygon558 = /*#__PURE__*/React.createElement("polygon", {
    points: "437.7000122 922.900012 422.3000488 894.5090369 435.3000488 898.4999876 437.7000122 922.900012",
    fill: "#e63125"
  })), _polygon559 || (_polygon559 = /*#__PURE__*/React.createElement("polygon", {
    points: "441.4000244 908.2999754 435.3000488 898.4999876 437.7000122 922.900012 441.4000244 908.2999754",
    fill: "#df3127"
  })), _polygon560 || (_polygon560 = /*#__PURE__*/React.createElement("polygon", {
    points: "437.7000122 922.900012 434.6000366 934.400012 450.1000366 936.900012 437.7000122 922.900012",
    fill: "#db3127"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m437.7000122,922.900012c-.5-.5-15.2999878-7.0999756-15.2999878-7.0999756l12.2000122,18.5999756,3.0999756-11.5Z",
    fill: "#d52e27"
  })), _polygon561 || (_polygon561 = /*#__PURE__*/React.createElement("polygon", {
    points: "437.8000488 922.900012 422.3000488 894.4999876 422.4000244 915.7999754 437.8000488 922.900012",
    fill: "#df3127"
  })), _polygon562 || (_polygon562 = /*#__PURE__*/React.createElement("polygon", {
    points: "435.3000488 898.4999876 418 863.6000242 422.3000488 894.5090369 435.3000488 898.4999876",
    fill: "#ce2b27"
  })), _polygon563 || (_polygon563 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.3000488 894.5090369 408.9000244 892.1999998 422.4000244 915.7999754 422.3000488 894.5090369",
    fill: "#db3127"
  })), _polygon564 || (_polygon564 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.3000488 894.5090369 413.6000366 872.1999998 418 863.6000242 422.3000488 894.5090369",
    fill: "#db3127"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m413.7000122,872.1000242c-.4000244.4000244-4.7999878,20.0999756-4.7999878,20.0999756l13.4117012,2.3305641-8.6117134-22.4305397Z",
    fill: "#df3127"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m413.7000122,872.1000242s-13-4.7999878-13.0999756-4.4000244c-.0999756.5,8.2999878,24.5,8.2999878,24.5,0,0,5.0999756-20.0999756,4.7999878-20.0999756Z",
    fill: "#db3127"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m413.7000122,872.1000242c-.2999878-.2999878-9.0999756-23.5999756-9.0999756-23.5999756l13.5,15-4.4000244,8.5999756Z",
    fill: "#e03b2e"
  })), _polygon565 || (_polygon565 = /*#__PURE__*/React.createElement("polygon", {
    points: "418 863.6000242 407.8000488 829.9999876 404.6000366 848.4999876 418 863.6000242",
    fill: "#db3127"
  })), _polygon566 || (_polygon566 = /*#__PURE__*/React.createElement("polygon", {
    points: "404.6000366 848.4999876 400.6000366 867.7999754 413.7000122 872.1000242 404.6000366 848.4999876",
    fill: "#db3127"
  })), _polygon567 || (_polygon567 = /*#__PURE__*/React.createElement("polygon", {
    points: "404.6000366 848.4999876 391.6000366 840.6999998 400.6000366 867.6999998 404.6000366 848.4999876",
    fill: "#db3127"
  })), _polygon568 || (_polygon568 = /*#__PURE__*/React.createElement("polygon", {
    points: "404.6000366 848.4999876 393.6000366 808.7999754 391.6000366 840.6999998 404.6000366 848.4999876",
    fill: "#e03127"
  })), _polygon569 || (_polygon569 = /*#__PURE__*/React.createElement("polygon", {
    points: "407.8000488 829.9999876 393.6000366 808.7999754 404.6000366 848.4999876 407.8000488 829.9999876",
    fill: "#e03127"
  })), _polygon570 || (_polygon570 = /*#__PURE__*/React.createElement("polygon", {
    points: "407.8000488 829.9999876 396.5 791.400012 393.6000366 808.7999754 407.8000488 829.9999876",
    fill: "#e03127"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m393.6000366,808.7999754c-.4000244-.0999756-9.6000366-1.8999634-9.6000366-1.8999634l7.6000366,33.8999634c0-.0999756,2.3999634-31.8999634,2-32Z",
    fill: "#d02d28"
  })), _polygon571 || (_polygon571 = /*#__PURE__*/React.createElement("polygon", {
    points: "393.6000366 808.7999754 380.5 784.6000242 384 806.900012 393.6000366 808.7999754",
    fill: "#d02d28"
  })), _polygon572 || (_polygon572 = /*#__PURE__*/React.createElement("polygon", {
    points: "393.6000366 808.7999754 396.5 791.400012 380.5 784.6000242 393.6000366 808.7999754",
    fill: "#e03127"
  })), _polygon573 || (_polygon573 = /*#__PURE__*/React.createElement("polygon", {
    points: "396.4997986 791.3989143 387.3000488 753.7999754 380.4997986 784.5989265 396.4997986 791.3989143",
    fill: "#e03127"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m387.3000488,753.7999754l-7.7999878,11.2000122.999939,19.6000366,6.8000488-30.8000488Z",
    fill: "#d42f27"
  })), _polygon574 || (_polygon574 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.3000488 753.7999754 397.9000244 767.900012 393.3000488 755.4999876 387.3000488 753.7999754",
    fill: "#b42d26"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m397.9000244,767.900012h.4000244l4.8999634-.6000366-10.0579332-12.1223508,4.7579454,12.7223874Z",
    fill: "#a62222"
  })), _polygon575 || (_polygon575 = /*#__PURE__*/React.createElement("polygon", {
    points: "397.9000244 767.900012 406.8000488 772.4999876 403.2000122 767.2999754 397.9000244 767.900012",
    fill: "#af2524"
  })), _polygon576 || (_polygon576 = /*#__PURE__*/React.createElement("polygon", {
    points: "403.2000122 767.2999754 411.7000122 764.400012 406.8000488 772.4999876 403.2000122 767.2999754",
    fill: "#a62222"
  })), _polygon577 || (_polygon577 = /*#__PURE__*/React.createElement("polygon", {
    points: "411.7000122 764.400012 412.5 768.9999876 406.8000488 772.4999876 411.7000122 764.400012",
    fill: "#af2524"
  })), _polygon578 || (_polygon578 = /*#__PURE__*/React.createElement("polygon", {
    points: "411.7000122 764.400012 416.5 759.9999876 412.5 768.9999876 411.7000122 764.400012",
    fill: "#af2524"
  })), _polygon579 || (_polygon579 = /*#__PURE__*/React.createElement("polygon", {
    points: "416.5 759.9999876 419.4000244 745.9999876 411.7000122 764.400012 416.5 759.9999876",
    fill: "#af2524"
  })), _polygon580 || (_polygon580 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.3000488 753.7999754 397.9000244 767.900012 396.5 791.400012 387.3000488 753.7999754",
    fill: "#db3027"
  })), _polygon581 || (_polygon581 = /*#__PURE__*/React.createElement("polygon", {
    points: "397.9000244 767.900012 406.8000488 786.400012 406.8000488 772.4999876 397.9000244 767.900012",
    fill: "#d42b27"
  })), _polygon582 || (_polygon582 = /*#__PURE__*/React.createElement("polygon", {
    points: "397.9000244 767.900012 406.8000488 786.400012 396.5 791.400012 397.9000244 767.900012",
    fill: "#ce2728"
  })), _polygon583 || (_polygon583 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.8000488 786.400012 416.9000244 775.4999876 406.8000488 772.4999876 406.8000488 786.400012",
    fill: "#db3027"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m416.9000244,775.4999876c0-.5-4.4000244-6.5999756-4.4000244-6.5999756l-5.6999512,3.5999756,10.0999756,3Z",
    fill: "#d42b27"
  })), _polygon584 || (_polygon584 = /*#__PURE__*/React.createElement("polygon", {
    points: "416.9000244 775.4999876 416.5 759.9999876 412.5 768.9999876 416.9000244 775.4999876",
    fill: "#d42b27"
  })), _polygon585 || (_polygon585 = /*#__PURE__*/React.createElement("polygon", {
    points: "419.4000244 745.9999876 422 762.1999998 416.5 759.9999876 419.4000244 745.9999876",
    fill: "#d42b27"
  })), _polygon586 || (_polygon586 = /*#__PURE__*/React.createElement("polygon", {
    points: "422 762.1999998 416.9000244 775.4999876 416.5 759.9999876 422 762.1999998",
    fill: "#c82627"
  })), _polygon587 || (_polygon587 = /*#__PURE__*/React.createElement("polygon", {
    points: "422 762.1999998 419.4000244 783.6000242 416.9000244 775.4999876 422 762.1999998",
    fill: "#c82627"
  })), _polygon588 || (_polygon588 = /*#__PURE__*/React.createElement("polygon", {
    points: "425.2000122 756.400012 430.5 777.9999876 429.3000488 739.7999754 425.2000122 756.400012",
    fill: "#cb2a27"
  })), _polygon589 || (_polygon589 = /*#__PURE__*/React.createElement("polygon", {
    points: "432.1000366 744.400012 434.9000244 766.6000242 429.3000488 739.7999754 432.1000366 744.400012",
    fill: "#a82123"
  })), _polygon590 || (_polygon590 = /*#__PURE__*/React.createElement("polygon", {
    points: "434.9000244 766.6000242 432.2000122 774.900012 429.3000488 739.7999754 434.9000244 766.6000242",
    fill: "#a82123"
  })), _polygon591 || (_polygon591 = /*#__PURE__*/React.createElement("polygon", {
    points: "432.2000122 774.900012 437.1000366 798.2999754 434.9000244 766.6000242 432.2000122 774.900012",
    fill: "#a82123"
  })), _polygon592 || (_polygon592 = /*#__PURE__*/React.createElement("polygon", {
    points: "434.9000244 766.6000242 441.5 799.9999876 437.1000366 798.2999754 434.9000244 766.6000242",
    fill: "#b62925"
  })), _polygon593 || (_polygon593 = /*#__PURE__*/React.createElement("polygon", {
    points: "432.2000122 774.7999754 430.5 777.9999876 429.3000488 739.7999754 432.2000122 774.7999754",
    fill: "#d32c28"
  })), _polygon594 || (_polygon594 = /*#__PURE__*/React.createElement("polygon", {
    points: "430.5 777.9999876 427.2000122 808.900012 425.1000366 779.6000242 430.5 777.9999876",
    fill: "#c82627"
  })), _polygon595 || (_polygon595 = /*#__PURE__*/React.createElement("polygon", {
    points: "425.1000366 779.6000242 425.2000122 756.400012 430.5 777.9999876 425.1000366 779.6000242",
    fill: "#d32c28"
  })), _polygon596 || (_polygon596 = /*#__PURE__*/React.createElement("polygon", {
    points: "425.2000122 756.400012 422 762.1999998 419.4000244 745.9999876 425.2000122 756.400012",
    fill: "#c82627"
  })), _polygon597 || (_polygon597 = /*#__PURE__*/React.createElement("polygon", {
    points: "425.2000122 756.400012 425.1000366 779.6000242 422 762.1999998 425.2000122 756.400012",
    fill: "#bd2726"
  })), _polygon598 || (_polygon598 = /*#__PURE__*/React.createElement("polygon", {
    points: "422 762.1999998 425.1000366 779.6000242 419.4000244 783.6000242 422 762.1999998",
    fill: "#c82627"
  })), _polygon599 || (_polygon599 = /*#__PURE__*/React.createElement("polygon", {
    points: "419.4000244 783.6000242 410.8000488 801.1000242 416.9000244 775.4999876 419.4000244 783.6000242",
    fill: "#ce2728"
  })), _polygon600 || (_polygon600 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.8000488 786.400012 410.8000488 801.1000242 416.9000244 775.4999876 406.8000488 786.400012",
    fill: "#d42b27"
  })), _polygon601 || (_polygon601 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.8000488 786.400012 402.8000488 795.6000242 410.8000488 800.9999876 406.8000488 786.400012",
    fill: "#ce2728"
  })), _polygon602 || (_polygon602 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.8000488 786.400012 396.5 791.400012 402.8000488 795.6000242 406.8000488 786.400012",
    fill: "#d42b27"
  })), _polygon603 || (_polygon603 = /*#__PURE__*/React.createElement("polygon", {
    points: "419.4000244 783.6000242 427.2000122 808.900012 425.1000366 779.6000242 419.4000244 783.6000242",
    fill: "#c82627"
  })), _polygon604 || (_polygon604 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.8000488 800.9999876 427.2000122 808.900012 419.4000244 783.6000242 410.8000488 800.9999876",
    fill: "#c82627"
  })), _polygon605 || (_polygon605 = /*#__PURE__*/React.createElement("polygon", {
    points: "427.2000122 808.900012 422.8000488 838.6999998 410.8000488 800.9999876 427.2000122 808.900012",
    fill: "#ce2728"
  })), _polygon606 || (_polygon606 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.8000488 800.9999876 408.5 814.2999754 402.8000488 795.6000242 410.8000488 800.9999876",
    fill: "#ce2728"
  })), _polygon607 || (_polygon607 = /*#__PURE__*/React.createElement("polygon", {
    points: "402.9000244 795.4999876 407.8000488 829.9999876 396.4000244 791.2999754 402.9000244 795.4999876",
    fill: "#ce2728"
  })), _polygon608 || (_polygon608 = /*#__PURE__*/React.createElement("polygon", {
    points: "408.5 814.2999754 410.8000488 800.9999876 422.8000488 838.6999998 408.5 814.2999754",
    fill: "#c82627"
  })), _polygon609 || (_polygon609 = /*#__PURE__*/React.createElement("polygon", {
    points: "408.5 814.2999754 402.8000488 795.6000242 407.8000488 829.9999876 408.5 814.2999754",
    fill: "#c82627"
  })), _polygon610 || (_polygon610 = /*#__PURE__*/React.createElement("polygon", {
    points: "408.5 814.2999754 422.8000488 838.6999998 407.8000488 829.9999876 408.5 814.2999754",
    fill: "#c82627"
  })), _polygon611 || (_polygon611 = /*#__PURE__*/React.createElement("polygon", {
    points: "430.5 777.9999876 433.8000183 810.8333756 427.2000122 808.900012 430.5 777.9999876",
    fill: "#cb2a27"
  })), _polygon612 || (_polygon612 = /*#__PURE__*/React.createElement("polygon", {
    points: "430.5 777.9999876 432.2000122 774.7999754 437.1000366 798.2999754 430.5 777.9999876",
    fill: "#cb2a27"
  })), _polygon613 || (_polygon613 = /*#__PURE__*/React.createElement("polygon", {
    points: "430.5 777.9999876 437.1000366 798.1999998 433.7000122 810.6999998 430.5 777.9999876",
    fill: "#cb2a27"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m437.0500806,798.1158946l7.3978548,27.2601506-2.8478988-25.4760332-4.549956-1.7841174Z",
    fill: "#a82123"
  })), _polygon614 || (_polygon614 = /*#__PURE__*/React.createElement("polygon", {
    points: "444.4000244 825.1999998 452.9000244 836.9999876 441.5 799.900012 444.4000244 825.1999998",
    fill: "#a82123"
  })), _polygon615 || (_polygon615 = /*#__PURE__*/React.createElement("polygon", {
    points: "437.0500806 798.1158946 433.7000122 810.6999998 444.4000244 825.1999998 437.0500806 798.1158946",
    fill: "#b32525"
  })), _polygon616 || (_polygon616 = /*#__PURE__*/React.createElement("polygon", {
    points: "433.7000122 810.6999998 428.3000488 852.1000242 422.8000488 838.6999998 433.7000122 810.6999998",
    fill: "#c32727"
  })), _polygon617 || (_polygon617 = /*#__PURE__*/React.createElement("polygon", {
    points: "433.7000122 810.6999998 427.2000122 808.900012 422.8000488 838.6999998 433.7000122 810.6999998",
    fill: "#c32727"
  })), _polygon618 || (_polygon618 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.8000488 838.6999998 407.8000488 829.9999876 418 863.6000242 422.8000488 838.6999998",
    fill: "#be2627"
  })), _polygon619 || (_polygon619 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.8000488 838.6999998 428.3000488 852.1000242 418 863.6000242 422.8000488 838.6999998",
    fill: "#b72526"
  })), _polygon620 || (_polygon620 = /*#__PURE__*/React.createElement("polygon", {
    points: "428.3000488 852.1000242 435.3000488 898.4999876 418 863.6000242 428.3000488 852.1000242",
    fill: "#a82123"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m428.3000488,852.1000242l36.0999756,51.9000244-29.0999756-5.500061-7-46.3999634Z",
    fill: "#a42022"
  })), _polygon621 || (_polygon621 = /*#__PURE__*/React.createElement("polygon", {
    points: "433.7000122 810.6999998 449.7000122 861.6000242 428.3000488 852.1000242 433.7000122 810.6999998",
    fill: "#b72526"
  })), _polygon622 || (_polygon622 = /*#__PURE__*/React.createElement("polygon", {
    points: "452.9000244 836.9999876 463.4000244 861.900012 448.7000122 840.9999876 452.9000244 836.9999876",
    fill: "#b62925"
  })), _polygon623 || (_polygon623 = /*#__PURE__*/React.createElement("polygon", {
    points: "448.7000122 841.1000242 444.4000244 825.1999998 453 836.9999876 448.7000122 841.1000242",
    fill: "#ae2324"
  })), _polygon624 || (_polygon624 = /*#__PURE__*/React.createElement("polygon", {
    points: "448.7000122 840.9999876 433.7000122 810.6999998 444.4000244 825.1999998 448.7000122 840.9999876",
    fill: "#b32525"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m448.7000122,840.9999876s-15.0999756-31-15-30.2999878c.0999756.5999756,16,50.9000244,16,50.9000244l-1-20.6000366Z",
    fill: "#b32525"
  })), _polygon625 || (_polygon625 = /*#__PURE__*/React.createElement("polygon", {
    points: "448.7000122 840.9999876 463.4000244 861.900012 449.7000122 861.6000242 448.7000122 840.9999876",
    fill: "#a82123"
  })), _polygon626 || (_polygon626 = /*#__PURE__*/React.createElement("polygon", {
    points: "449.7000122 861.6000242 428.3000488 852.1000242 464.4000244 903.9999876 449.7000122 861.6000242",
    fill: "#9b1f20"
  })), _polygon627 || (_polygon627 = /*#__PURE__*/React.createElement("polygon", {
    points: "449.7000122 861.6000242 463.4000244 861.900012 484.4000244 897.4999876 449.7000122 861.6000242",
    fill: "#a82123"
  })), _polygon628 || (_polygon628 = /*#__PURE__*/React.createElement("polygon", {
    points: "449.7000122 861.6000242 484.4000244 897.4999876 464.4000244 903.9999876 449.7000122 861.6000242",
    fill: "#a01f21"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m464.4000244,903.9999876l-23,4.2999878-6.1321386-9.8098617,29.1321386,5.5098739Z",
    fill: "#a01f21"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m464.4000244,903.9999876l.4000244,33.5-23.4000244-29.2000122,23-4.2999878Z",
    fill: "#9b1f20"
  })), _polygon629 || (_polygon629 = /*#__PURE__*/React.createElement("polygon", {
    points: "464.4000244 903.9999876 507.4000244 947.9999876 484.4000244 897.4999876 464.4000244 903.9999876",
    fill: "#a01f21"
  })), _polygon630 || (_polygon630 = /*#__PURE__*/React.createElement("polygon", {
    points: "507.4000244 947.9999876 464.8000488 937.4999876 464.4000244 903.9999876 507.4000244 947.9999876",
    fill: "#971d1f"
  })), _polygon631 || (_polygon631 = /*#__PURE__*/React.createElement("polygon", {
    points: "464.8000488 937.4999876 480.3000488 956.6000242 507.4000244 947.9999876 464.8000488 937.4999876",
    fill: "#8d1b1c"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m480.3000488,956.6000242s55.3000488,17.2000122,55.0999756,17.2999878c-.3000488.0999756-21.4000244,6.2000122-21.4000244,6.2000122l-33.6999512-23.5Z",
    fill: "#8d1b1c"
  })), _polygon632 || (_polygon632 = /*#__PURE__*/React.createElement("polygon", {
    points: "491.5999756 970.400012 497.2000732 976.6000242 514 980.1000242 480.3000488 956.6000242 491.5999756 970.400012",
    fill: "#971d1f"
  })), _polygon633 || (_polygon633 = /*#__PURE__*/React.createElement("polygon", {
    points: "480.3000488 956.6000242 507.4000244 947.9999876 535.4000244 973.900012 480.3000488 956.6000242",
    fill: "#851819"
  })), _polygon634 || (_polygon634 = /*#__PURE__*/React.createElement("polygon", {
    points: "484.4000244 897.4999876 540.5 940.9999876 507.4000244 947.9999876 484.4000244 897.4999876",
    fill: "#b62825"
  })), _polygon635 || (_polygon635 = /*#__PURE__*/React.createElement("polygon", {
    points: "540.5 940.9999876 535.4000244 973.900012 507.4000244 947.9999876 540.5 940.9999876",
    fill: "#a42022"
  })), _polygon636 || (_polygon636 = /*#__PURE__*/React.createElement("polygon", {
    points: "540.5 940.9999876 565.7000732 951.4999876 535.4000244 973.900012 540.5 940.9999876",
    fill: "#b62825"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m540.5,940.9999876c.6999512-.7000122,44.5999756,1.5,44.5999756,1.5l-19.4000244,9-25.1999512-10.5Z",
    fill: "#d52b28"
  })), _polygon637 || (_polygon637 = /*#__PURE__*/React.createElement("polygon", {
    points: "585.0999756 942.4999876 523.5999756 903.2999754 540.5 940.9999876 585.0999756 942.4999876",
    fill: "#df3027"
  })), _polygon638 || (_polygon638 = /*#__PURE__*/React.createElement("polygon", {
    points: "585.0999756 942.4999876 600.2000732 943.6999998 570.2000732 924.1999998 585.0999756 942.4999876",
    fill: "#c42c27"
  })), _polygon639 || (_polygon639 = /*#__PURE__*/React.createElement("polygon", {
    points: "585.0999756 942.4999876 599.8000488 956.7999754 600.2000732 943.6999998 585.0999756 942.4999876",
    fill: "#6e1211"
  })), _polygon640 || (_polygon640 = /*#__PURE__*/React.createElement("polygon", {
    points: "599.8000488 956.7999754 608.0999756 971.400012 607.2000732 958.9999876 599.8000488 956.7999754",
    fill: "#6e1211"
  })), _polygon641 || (_polygon641 = /*#__PURE__*/React.createElement("polygon", {
    points: "607.2000732 958.9999876 609 950.4999876 611.7000732 960.400012 607.2000732 958.9999876",
    fill: "#6e1211"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m607.2000732,958.9999876c0,.7000122.5999756,12.9000244.8000488,12.5.3000488-.4000244,3.6999512-11.0999756,3.6999512-11.0999756l-4.5-1.4000244Z",
    fill: "#631110"
  })), _polygon642 || (_polygon642 = /*#__PURE__*/React.createElement("polygon", {
    points: "607.2000732 958.9999876 600.2000732 943.6999998 609 950.4999876 607.2000732 958.9999876",
    fill: "#6e1211"
  })), _polygon643 || (_polygon643 = /*#__PURE__*/React.createElement("polygon", {
    points: "607.2000732 958.9999876 599.8000488 956.7999754 600.2000732 943.6999998 607.2000732 958.9999876",
    fill: "#631110"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m609,950.4999876c-.8000488-.7999878-7.5-9.9000244-7.5-9.9000244l-1.4000244,3.0999756,8.9000244,6.8000488Z",
    fill: "#9f2423"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m601.5,940.5999632l-21.4000244-15.3999634,20.0999756,18.5c.0001221,0,1.3000488-3.1000366,1.3000488-3.1000366Z",
    fill: "#9f2423"
  })), _polygon644 || (_polygon644 = /*#__PURE__*/React.createElement("polygon", {
    points: "580.0999756 925.1999998 570.2000732 924.1999998 600.2000732 943.6999998 580.0999756 925.1999998",
    fill: "#a92523"
  })), _polygon645 || (_polygon645 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.2000732 924.1999998 585.0999756 942.4999876 523.5999756 903.2999754 570.2000732 924.1999998",
    fill: "#c92b27"
  })), _polygon646 || (_polygon646 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.2000732 924.1999998 580.0999756 925.1999998 549.5 908.2999754 570.2000732 924.1999998",
    fill: "#ae2825"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m549.5,908.2999754c-.3000488-.2999878-25.9000244-5-25.9000244-5l46.6000977,20.9000244-20.7000732-15.9000244Z",
    fill: "#b62a26"
  })), _polygon647 || (_polygon647 = /*#__PURE__*/React.createElement("polygon", {
    points: "523.5999756 903.2999754 507.5 880.6999998 528.3000488 896.400012 523.5999756 903.2999754",
    fill: "#bd2e27"
  })), _polygon648 || (_polygon648 = /*#__PURE__*/React.createElement("polygon", {
    points: "523.5999756 903.2999754 549.5 908.2999754 528.3000488 896.400012 523.5999756 903.2999754",
    fill: "#c0372b"
  })), _polygon649 || (_polygon649 = /*#__PURE__*/React.createElement("polygon", {
    points: "523.5999756 903.2999754 484.4000244 897.4999876 540.5 940.9999876 523.5999756 903.2999754",
    fill: "#dc382e"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m523.5999756,903.2999754s-60.2999878-41.7000122-60.2000122-41.4000244,21.000061,35.5999756,21.000061,35.5999756l39.1999512,5.8000488Z",
    fill: "#c02827"
  })), _polygon650 || (_polygon650 = /*#__PURE__*/React.createElement("polygon", {
    points: "507.5 880.6999998 463.4000244 861.900012 523.5999756 903.2999754 507.5 880.6999998",
    fill: "#c92b27"
  })), _polygon651 || (_polygon651 = /*#__PURE__*/React.createElement("polygon", {
    points: "507.5 880.6999998 494.2000732 866.7999754 463.4000244 861.900012 507.5 880.6999998",
    fill: "#c92b27"
  })), _polygon652 || (_polygon652 = /*#__PURE__*/React.createElement("polygon", {
    points: "463.4000244 861.900012 466.9000244 843.900012 452.9000244 836.9999876 463.4000244 861.900012",
    fill: "#cb2a27"
  })), _polygon653 || (_polygon653 = /*#__PURE__*/React.createElement("polygon", {
    points: "463.4000244 861.900012 494.2000732 866.7999754 466.9000244 843.900012 463.4000244 861.900012",
    fill: "#c02827"
  })), _polygon654 || (_polygon654 = /*#__PURE__*/React.createElement("polygon", {
    points: "466.9000244 843.900012 471.4000244 831.6000242 481.5999756 849.4999876 466.9000244 843.900012",
    fill: "#d82e28"
  })), _polygon655 || (_polygon655 = /*#__PURE__*/React.createElement("polygon", {
    points: "481.5999756 849.4999876 494.0999756 866.7999754 466.9000244 843.900012 481.5999756 849.4999876",
    fill: "#ce2928"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m466.9000244,843.900012c-.4000244-.4000244-12.7000122-30.7999878-12.7000122-30.7999878l17.2000122,18.5-4.5,12.2999878Z",
    fill: "#ce2928"
  })), _polygon656 || (_polygon656 = /*#__PURE__*/React.createElement("polygon", {
    points: "466.9000244 843.900012 452.9000244 836.9999876 454.2000122 813.1000242 466.9000244 843.900012",
    fill: "#ba2926"
  })), _polygon657 || (_polygon657 = /*#__PURE__*/React.createElement("polygon", {
    points: "454.2000122 813.1000242 441.5 799.900012 452.9000244 836.9999876 454.2000122 813.1000242",
    fill: "#cb2a27"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m454.2000122,813.1000242c-.0999756-.0999756,2.7000122-16.9000244,2.7000122-16.9000244l6.7999878,17.7000122-9.5-.7999878Z",
    fill: "#df3127"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m463.7000122,813.900012l7.7000122,17.7999878-17.2000122-18.5999756c.1000366-.0999756,10,.5,9.5.7999878Z",
    fill: "#d32a28"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m454.2000122,813.1000242s-9.3999634-38.2000122-9.3999634-37.9000244c0,.4000244.2000122,18.5999756.2000122,18.5999756l9.1999512,19.3000488Z",
    fill: "#b42725"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m445,793.7999754c-.4000244.4000244-3.5,6.0999756-3.5,6.0999756l12.7000122,13.2000122-9.2000122-19.2999878Z",
    fill: "#d22d27"
  })), _polygon658 || (_polygon658 = /*#__PURE__*/React.createElement("polygon", {
    points: "444.8000488 775.1999998 456.9000244 796.1999998 454.2000122 813.1000242 444.8000488 775.1999998",
    fill: "#df3127"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m445,793.7999754c-.5999756-.5999756-6.5-31.5-6.5-31.5l6.2999878,12.9000244.2000122,18.5999756Z",
    fill: "#b42725"
  })), _polygon659 || (_polygon659 = /*#__PURE__*/React.createElement("polygon", {
    points: "445 793.7999754 434.9000244 766.6000242 441.5 799.9999876 445 793.7999754",
    fill: "#cb2a27"
  })), _polygon660 || (_polygon660 = /*#__PURE__*/React.createElement("polygon", {
    points: "434.9000244 766.6000242 438.5 762.2999754 445 793.7999754 434.9000244 766.6000242",
    fill: "#db3027"
  })), _polygon661 || (_polygon661 = /*#__PURE__*/React.createElement("polygon", {
    points: "438.5 762.2999754 436.3000488 732.400012 440.7000122 760.1999998 438.5 762.2999754",
    fill: "#b42725"
  })), _polygon662 || (_polygon662 = /*#__PURE__*/React.createElement("polygon", {
    points: "438.5 762.2999754 444.8000488 775.2999754 440.7000122 760.1999998 438.5 762.2999754",
    fill: "#b42725"
  })), _polygon663 || (_polygon663 = /*#__PURE__*/React.createElement("polygon", {
    points: "440.7000122 760.1999998 448.8000488 769.9999876 444.8000488 775.2999754 440.7000122 760.1999998",
    fill: "#d32a28"
  })), _polygon664 || (_polygon664 = /*#__PURE__*/React.createElement("polygon", {
    points: "448.8000488 769.9999876 456.9000244 796.1999998 444.8000488 775.2999754 448.8000488 769.9999876",
    fill: "#e23227"
  })), _polygon665 || (_polygon665 = /*#__PURE__*/React.createElement("polygon", {
    points: "438.5 762.2999754 432.1000366 744.400012 434.9000244 766.6000242 438.5 762.2999754",
    fill: "#d22d27"
  })), _polygon666 || (_polygon666 = /*#__PURE__*/React.createElement("polygon", {
    points: "432.1000366 744.400012 436.3000488 732.400012 438.5 762.2999754 432.1000366 744.400012",
    fill: "#db3027"
  })), _polygon667 || (_polygon667 = /*#__PURE__*/React.createElement("polygon", {
    points: "436.3000488 732.400012 443.9000244 747.4999876 440.7000122 760.1999998 436.3000488 732.400012",
    fill: "#d32a28"
  })), _polygon668 || (_polygon668 = /*#__PURE__*/React.createElement("polygon", {
    points: "436.3000488 732.400012 441.4000244 733.1999998 443.9000244 747.6000242 436.3000488 732.400012",
    fill: "#e23227"
  })), _polygon669 || (_polygon669 = /*#__PURE__*/React.createElement("polygon", {
    points: "443.9000244 747.4999876 448.8000488 769.9999876 440.7000122 760.1999998 443.9000244 747.4999876",
    fill: "#e23227"
  })), _polygon670 || (_polygon670 = /*#__PURE__*/React.createElement("polygon", {
    points: "352.3000488 905.9999876 369.4000244 918.6999998 365.2000122 889.2999754 352.3000488 905.9999876",
    fill: "#c8322c"
  })), _polygon671 || (_polygon671 = /*#__PURE__*/React.createElement("polygon", {
    points: "468.2000122 968.400012 483.2000732 965.7999754 464.4000244 950.6000242 468.2000122 968.400012",
    fill: "#ce2b27"
  })), _polygon672 || (_polygon672 = /*#__PURE__*/React.createElement("polygon", {
    points: "408.7000122 661.2999754 402 661.1000242 409.2000122 673.900012 408.7000122 661.2999754",
    fill: "#e87f62"
  })), _polygon673 || (_polygon673 = /*#__PURE__*/React.createElement("polygon", {
    points: "402 661.1000242 395.8000488 661.900012 396.6000366 669.9999876 402 661.1000242",
    fill: "#e8785c"
  })), _polygon674 || (_polygon674 = /*#__PURE__*/React.createElement("polygon", {
    points: "396.6000366 669.9999876 398.1000366 683.1999998 401.8000488 674.1000242 396.6000366 669.9999876",
    fill: "#eb3c2e"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m401.8000488,674.1000242l.1999512-13-5.3999634,8.8999634,5.2000122,4.1000366Z",
    fill: "#ea6c4f"
  })), _polygon675 || (_polygon675 = /*#__PURE__*/React.createElement("polygon", {
    points: "401.8000488 674.1000242 402.9000244 688.9999876 409 680.9999876 401.8000488 674.1000242",
    fill: "#ec2d29"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m401.8000488,674.1000242l7.4000244-.2000122-7.2000732-12.7999878-.1999512,13Z",
    fill: "#ea664b"
  })), _polygon676 || (_polygon676 = /*#__PURE__*/React.createElement("polygon", {
    points: "401.8000488 674.1000242 409 680.9999876 409.2000122 673.900012 401.8000488 674.1000242",
    fill: "#eb382d"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m402.9000244,688.9999876s4.7999878,16.2000122,5,15.9000244,1.0999756-23.9000244,1.0999756-23.9000244l-6.0999756,8Z",
    fill: "#ed2224"
  })), _polygon677 || (_polygon677 = /*#__PURE__*/React.createElement("polygon", {
    points: "402.9000244 688.9999876 398.1000366 683.1999998 401.8000488 674.1000242 402.9000244 688.9999876",
    fill: "#ed2025"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m402.9000244,688.9999876c0,.5999756-4.2000122,18.2999878-4.2000122,18.2999878l-.5999756-24.2000122,4.7999878,5.9000244Z",
    fill: "#ee2425"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m398.7000122,707.2999754l4.0999756,9.0999756s.2000122-28,.0999756-27.4000244c-.0999146.6000977-4.1999512,18.3000488-4.1999512,18.3000488Z",
    fill: "#e43027"
  })), _polygon678 || (_polygon678 = /*#__PURE__*/React.createElement("polygon", {
    points: "402.8000488 716.400012 407.9000244 704.900012 402.9000244 688.9999876 402.8000488 716.400012",
    fill: "#e92f27"
  })), _polygon679 || (_polygon679 = /*#__PURE__*/React.createElement("polygon", {
    points: "402.8000488 716.400012 402.4000244 733.2999754 406.1000366 722.6000242 402.8000488 716.400012",
    fill: "#ce2d27"
  })), _polygon680 || (_polygon680 = /*#__PURE__*/React.createElement("polygon", {
    points: "402.7999878 716.399951 406.1000366 722.6000242 407.2000122 712.4999876 407.9000244 704.7999754 402.7999878 716.399951",
    fill: "#d93028"
  })), _polygon681 || (_polygon681 = /*#__PURE__*/React.createElement("polygon", {
    points: "402.8000488 716.400012 398.8000488 730.6000242 398.1000366 722.9999876 398.7000122 707.2999754 402.8000488 716.400012",
    fill: "#d12f27"
  })), _polygon682 || (_polygon682 = /*#__PURE__*/React.createElement("polygon", {
    points: "402.7999878 716.399951 402.5 733.2999754 398.7809845 730.5687349 402.7999878 716.399951",
    fill: "#c22927"
  })), _polygon683 || (_polygon683 = /*#__PURE__*/React.createElement("polygon", {
    points: "402.4000244 733.2999754 404.9000244 756.2999754 406 743.6999998 402.4000244 733.2999754",
    fill: "#a61f24"
  })), _polygon684 || (_polygon684 = /*#__PURE__*/React.createElement("polygon", {
    points: "406 743.6999998 406.1000366 722.6000242 402.4000244 733.2999754 406 743.6999998",
    fill: "#ba2626"
  })), _polygon685 || (_polygon685 = /*#__PURE__*/React.createElement("polygon", {
    points: "402.4000244 733.2999754 398.8000488 730.6000242 402.1000366 751.900012 402.4000244 733.2999754",
    fill: "#ae2225"
  })), _polygon686 || (_polygon686 = /*#__PURE__*/React.createElement("polygon", {
    points: "402.4000244 733.2999754 404.9000244 756.2999754 402.1000366 751.900012 402.4000244 733.2999754",
    fill: "#a61f24"
  })), _polygon687 || (_polygon687 = /*#__PURE__*/React.createElement("polygon", {
    points: "404.9000244 756.2999754 407.1000366 757.1999998 410.4000244 783.1000242 403.2000122 757.400012 404.9000244 756.2999754",
    fill: "#961921"
  })), _polygon688 || (_polygon688 = /*#__PURE__*/React.createElement("polygon", {
    points: "404.9000244 756.2999754 406 743.6999998 407.1000366 757.1999998 404.9000244 756.2999754",
    fill: "#9f1d23"
  })), _polygon689 || (_polygon689 = /*#__PURE__*/React.createElement("polygon", {
    points: "404.9000244 756.2999754 402.1000366 751.900012 403.2000122 757.400012 404.9000244 756.2999754",
    fill: "#a61f24"
  })), _polygon690 || (_polygon690 = /*#__PURE__*/React.createElement("polygon", {
    points: "480.3000488 956.6000242 491.5999756 970.400012 483.2000732 965.7999754 480.3000488 956.6000242",
    fill: "#ce2b27"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m410.8000488,724.4999876l-.2999878,2.9000244s-5.7000122-3.7999878-5.5-4c.1999512,0,5.7999878,1.0999756,5.7999878,1.0999756Z",
    fill: "#ac9176"
  })), _polygon691 || (_polygon691 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.5 727.400012 404.4000244 727.400012 405 723.4999876 410.5 727.400012",
    fill: "#aa8a71"
  })), _polygon692 || (_polygon692 = /*#__PURE__*/React.createElement("polygon", {
    points: "404.8000488 731.4999876 403.2000122 728.900012 393.2000122 728.900012 404.8000488 731.4999876",
    fill: "#4d271d"
  })), _polygon693 || (_polygon693 = /*#__PURE__*/React.createElement("polygon", {
    points: "403.2000122 728.900012 410.5 727.400012 404.4000244 727.400012 393.2000122 728.900012 403.2000122 728.900012",
    fill: "#241a0f"
  })), _polygon694 || (_polygon694 = /*#__PURE__*/React.createElement("polygon", {
    points: "403.2000122 728.900012 404.8000488 731.4999876 412.8000488 729.6000242 403.2000122 728.900012",
    fill: "#703227"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m412.8000488,729.6000242s-1.7000122-2-2.2000122-2.0999756-7.2999878,1.5-7.2999878,1.5l9.5.5999756Z",
    fill: "#754435"
  })), _polygon695 || (_polygon695 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.5 727.400012 421.5 725.1000242 412.8000488 729.6000242 410.5 727.400012",
    fill: "#67281e"
  })), _polygon696 || (_polygon696 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.8000488 724.4999876 421.5 725.1000242 410.5 727.400012 410.8000488 724.4999876",
    fill: "#754b3f"
  })), _polygon697 || (_polygon697 = /*#__PURE__*/React.createElement("polygon", {
    points: "441.7000133 735.2999783 452.4000244 741.4999876 445.8000488 743.4999876 441.7000133 735.2999783",
    fill: "#d48252"
  })), _polygon698 || (_polygon698 = /*#__PURE__*/React.createElement("polygon", {
    points: "445.8000488 743.4999876 445.3000488 754.1000242 443.4000244 745.1999998 441.7000133 735.2999783 445.8000488 743.4999876",
    fill: "#27160f"
  })), _polygon699 || (_polygon699 = /*#__PURE__*/React.createElement("polygon", {
    points: "445.8000488 743.4999876 449.5 757.7999754 445.3000488 754.1000242 445.8000488 743.4999876",
    fill: "#6c321f"
  })), _polygon700 || (_polygon700 = /*#__PURE__*/React.createElement("polygon", {
    points: "449.5 757.7999754 449.6000366 772.4999876 448.8000488 769.9999876 445.3000488 754.1000242 449.5 757.7999754",
    fill: "#412313"
  })), _polygon701 || (_polygon701 = /*#__PURE__*/React.createElement("polygon", {
    points: "445.8000488 743.4999876 459.6000366 750.4999876 452.4000244 741.4999876 445.8000488 743.4999876",
    fill: "#d99471"
  })), _polygon702 || (_polygon702 = /*#__PURE__*/React.createElement("polygon", {
    points: "445.8000488 743.4999876 459.6000366 750.4999876 457.4000244 756.2999754 445.8000488 743.4999876",
    fill: "#d7875b"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m459.6000366,750.4999876s11.7000122,11.7000122,11.9000244,11.7000122c.2999878.0999756-14.1000366-5.9000244-14.1000366-5.9000244l2.2000122-5.7999878Z",
    fill: "#d48d68"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m471.5,762.1999998c.2999878.2999878,10.0999756,8.0999756,10.0999756,8.0999756l-14.0999756-3.5,4-4.5999756Z",
    fill: "#d99471"
  })), _polygon703 || (_polygon703 = /*#__PURE__*/React.createElement("polygon", {
    points: "467.5 766.7999754 457.4000244 756.2999754 471.5 762.1999998 467.5 766.7999754",
    fill: "#d99471"
  })), _polygon704 || (_polygon704 = /*#__PURE__*/React.createElement("polygon", {
    points: "467.5 766.7999754 479.1000366 776.400012 481.5999756 770.2999754 467.5 766.7999754",
    fill: "#d48d68"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m481.5999756,770.2999754c.1999512.2000122,6.8000488,6.4000244,6.8000488,6.4000244l-9.2999878-.2999878,2.499939-6.1000366Z",
    fill: "#e0ae92"
  })), _polygon705 || (_polygon705 = /*#__PURE__*/React.createElement("polygon", {
    points: "488.4000244 776.6999998 496.4000244 787.7999754 488.8000488 783.900012 488.4000244 776.6999998",
    fill: "#dda68b"
  })), _polygon706 || (_polygon706 = /*#__PURE__*/React.createElement("polygon", {
    points: "488.8000488 783.7999754 494.2000732 791.900012 496.4000244 787.6999998 488.8000488 783.7999754",
    fill: "#cc8768"
  })), _polygon707 || (_polygon707 = /*#__PURE__*/React.createElement("polygon", {
    points: "494.2000732 791.900012 488.7000732 797.2999754 488.8000488 783.7999754 494.2000732 791.900012",
    fill: "#d99471"
  })), _polygon708 || (_polygon708 = /*#__PURE__*/React.createElement("polygon", {
    points: "488.7000732 797.2999754 481.2000732 784.2999754 488.8000488 783.7999754 488.7000732 797.2999754",
    fill: "#a66a51"
  })), _polygon709 || (_polygon709 = /*#__PURE__*/React.createElement("polygon", {
    points: "481.2000732 784.2999754 479.1000366 776.400012 488.8000488 783.7999754 481.2000732 784.2999754",
    fill: "#bd8062"
  })), _polygon710 || (_polygon710 = /*#__PURE__*/React.createElement("polygon", {
    points: "479.1000366 776.400012 471.7000122 778.900012 481.2000732 784.2999754 479.1000366 776.400012",
    fill: "#b37153"
  })), _polygon711 || (_polygon711 = /*#__PURE__*/React.createElement("polygon", {
    points: "481.2000732 784.2999754 485 801.1000242 488.7000732 797.2999754 481.2000732 784.2999754",
    fill: "#a66344"
  })), _polygon712 || (_polygon712 = /*#__PURE__*/React.createElement("polygon", {
    points: "481.2000732 784.2999754 476.4000244 789.6000242 471.7000122 778.900012 481.2000732 784.2999754",
    fill: "#5c321c"
  })), _polygon713 || (_polygon713 = /*#__PURE__*/React.createElement("polygon", {
    points: "476.4000244 789.6000242 485 801.1000242 481.2000732 784.2999754 476.4000244 789.6000242",
    fill: "#704128"
  })), _polygon714 || (_polygon714 = /*#__PURE__*/React.createElement("polygon", {
    points: "476.4000244 789.6000242 475.9000244 798.1999998 485 800.9999876 476.4000244 789.6000242",
    fill: "#75472d"
  })), _polygon715 || (_polygon715 = /*#__PURE__*/React.createElement("polygon", {
    points: "475.9000244 798.1999998 482.8000488 804.6999998 485 800.9999876 475.9000244 798.1999998",
    fill: "#603623"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m475.9000244,798.1999998c-.5999756-.5999756-11.2000122-14.5-11.2000122-14.5l11.7000122,5.9000244-.5,8.5999756Z",
    fill: "#381d10"
  })), _polygon716 || (_polygon716 = /*#__PURE__*/React.createElement("polygon", {
    points: "464.7000122 783.6999998 471.7000122 778.900012 476.4000244 789.6000242 464.7000122 783.6999998",
    fill: "#61321f"
  })), _polygon717 || (_polygon717 = /*#__PURE__*/React.createElement("polygon", {
    points: "464.7000122 783.6999998 450.9000244 776.6999998 459.3000488 778.400012 464.7000122 783.6999998",
    fill: "#412313"
  })), _polygon718 || (_polygon718 = /*#__PURE__*/React.createElement("polygon", {
    points: "459.3000488 778.400012 449.6000366 772.4999876 450.9000244 776.6999998 459.3000488 778.400012",
    fill: "#482415"
  })), _polygon719 || (_polygon719 = /*#__PURE__*/React.createElement("polygon", {
    points: "449.5 772.4999876 449.5 757.7999754 459.3000488 778.400012 449.5 772.4999876",
    fill: "#5c321c"
  })), _polygon720 || (_polygon720 = /*#__PURE__*/React.createElement("polygon", {
    points: "459.3000488 778.400012 471.7000122 778.900012 464.7000122 783.6999998 459.3000488 778.400012",
    fill: "#381d10"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m471.7000122,778.900012c-1-1-12.0999756-11.7999878-12.0999756-11.7999878l-.2999878,11.2999878,12.3999634.5Z",
    fill: "#5c321c"
  })), _polygon721 || (_polygon721 = /*#__PURE__*/React.createElement("polygon", {
    points: "459.6000366 767.1000242 449.5 757.7999754 459.3000488 778.400012 459.6000366 767.1000242",
    fill: "#482415"
  })), _polygon722 || (_polygon722 = /*#__PURE__*/React.createElement("polygon", {
    points: "459.6000366 767.1000242 479.1000366 776.400012 471.7000122 778.900012 459.6000366 767.1000242",
    fill: "#a66344"
  })), _polygon723 || (_polygon723 = /*#__PURE__*/React.createElement("polygon", {
    points: "459.6000366 767.1000242 457.4000244 756.2999754 449.5 757.7999754 459.6000366 767.1000242",
    fill: "#6e391c"
  })), _polygon724 || (_polygon724 = /*#__PURE__*/React.createElement("polygon", {
    points: "457.4000244 756.2999754 445.8000488 743.4999876 449.5 757.7999754 457.4000244 756.2999754",
    fill: "#b9724e"
  })), _polygon725 || (_polygon725 = /*#__PURE__*/React.createElement("polygon", {
    points: "457.4000244 756.2999754 467.5 766.7999754 459.6000366 767.1000242 457.4000244 756.2999754",
    fill: "#8c4c32"
  })), _polygon726 || (_polygon726 = /*#__PURE__*/React.createElement("polygon", {
    points: "467.5 766.7999754 459.6000366 767.1000242 479.1000366 776.400012 467.5 766.7999754",
    fill: "#a66a51"
  })), _polygon727 || (_polygon727 = /*#__PURE__*/React.createElement("polygon", {
    points: "482.8000488 804.6999998 491.9000244 813.6000242 485 800.9999876 482.8000488 804.6999998",
    fill: "#5a4024"
  })), _polygon728 || (_polygon728 = /*#__PURE__*/React.createElement("polygon", {
    points: "485 800.9999876 488.7000732 797.2999754 495.2999268 806.900012 485 800.9999876",
    fill: "#8e7557"
  })), _polygon729 || (_polygon729 = /*#__PURE__*/React.createElement("polygon", {
    points: "495.2999268 806.900012 499.2000732 816.1000242 485 800.9999876 495.2999268 806.900012",
    fill: "#846a44"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m485,800.9999876c0,.5,6.9000244,12.5999756,6.9000244,12.5999756l7.3000488,2.5-14.2000732-15.0999756Z",
    fill: "#725b3d"
  })), _polygon730 || (_polygon730 = /*#__PURE__*/React.createElement("polygon", {
    points: "491.9000244 813.6000242 500 824.2999754 499.2000732 816.1000242 491.9000244 813.6000242",
    fill: "#523e27"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m500,824.2999754c.4000244.4000244,2,7.2000122,2,7.2000122l3.5-4.5-5.5-2.7000122Z",
    fill: "#5a4024"
  })), _polygon731 || (_polygon731 = /*#__PURE__*/React.createElement("polygon", {
    points: "505.4000244 827.1000242 510.5999756 830.1999998 502 831.4999876 505.4000244 827.1000242",
    fill: "#846a44"
  })), _polygon732 || (_polygon732 = /*#__PURE__*/React.createElement("polygon", {
    points: "510.5999756 830.1999998 515.8000488 826.1999998 505.4000244 827.1000242 510.5999756 830.1999998",
    fill: "#ab8d5e"
  })), _polygon733 || (_polygon733 = /*#__PURE__*/React.createElement("polygon", {
    points: "515.8000488 826.1999998 516.7000732 821.6000242 512.4000244 816.4999876 515.8000488 826.1999998",
    fill: "#e4ce98"
  })), _polygon734 || (_polygon734 = /*#__PURE__*/React.createElement("polygon", {
    points: "512.4000244 816.4999876 504.5 803.900012 505.5999756 811.900012 512.4000244 816.4999876",
    fill: "#faedba"
  })), _polygon735 || (_polygon735 = /*#__PURE__*/React.createElement("polygon", {
    points: "505.5999756 811.900012 515.8000488 826.1999998 512.4000244 816.4999876 505.5999756 811.900012",
    fill: "#decc9e"
  })), _polygon736 || (_polygon736 = /*#__PURE__*/React.createElement("polygon", {
    points: "505.4000244 827.1000242 503.2000732 820.9999876 500 824.2999754 505.4000244 827.1000242",
    fill: "#9f8761"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m503.2000732,820.9999876l-4-4.8999634.7999268,8.1999512s3.5999756-3.5,3.2000732-3.2999878Z",
    fill: "#725b3d"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m499.2000732,816.1000242l-3.9000244-9.2000122,11.0999756,11-7.1999512-1.7999878Z",
    fill: "#8e7557"
  })), _polygon737 || (_polygon737 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.2000732 816.1000242 503.2000732 820.9999876 506.4000244 817.900012 499.2000732 816.1000242",
    fill: "#846a44"
  })), _polygon738 || (_polygon738 = /*#__PURE__*/React.createElement("polygon", {
    points: "503.2000732 820.9999876 505.4000244 827.1000242 506.4000244 817.900012 503.2000732 820.9999876",
    fill: "#8e7557"
  })), _polygon739 || (_polygon739 = /*#__PURE__*/React.createElement("polygon", {
    points: "506.4000244 817.900012 515.8000488 826.1999998 505.4000244 827.1000242 506.4000244 817.900012",
    fill: "#e2c680"
  })), _polygon740 || (_polygon740 = /*#__PURE__*/React.createElement("polygon", {
    points: "506.4000244 817.900012 505.5999756 811.900012 515.8000488 826.1999998 506.4000244 817.900012",
    fill: "#d1ba8c"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m506.4000244,817.900012c0-.5-4.9000244-10.6000366-4.9000244-10.6000366l-6.2000732-.3999634,11.1000977,11Z",
    fill: "#e8d39e"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m501.5312096,807.3673865s-13.0312096-10.3673989-12.8312585-10.0674111,6.5999756,9.5999756,6.5999756,9.5999756l6.2312829.4674355Z",
    fill: "#dcbc72"
  })), _polygon741 || (_polygon741 = /*#__PURE__*/React.createElement("polygon", {
    points: "501.4261953 807.3000059 494.2000732 791.900012 488.7000732 797.2999754 501.4261953 807.3000059",
    fill: "#d1ba8c"
  })), _polygon742 || (_polygon742 = /*#__PURE__*/React.createElement("polygon", {
    points: "494.2000732 791.900012 496.4000244 787.6999998 502.4000244 798.2999754 494.2000732 791.900012",
    fill: "#faedba"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m504.5999756,804.1000242l-10.3999023-12.2000122,8.1999512,6.4000244,2.1999512,5.7999878Z",
    fill: "#e4ce98"
  })), _polygon743 || (_polygon743 = /*#__PURE__*/React.createElement("polygon", {
    points: "504.5999756 804.1000242 506.4000244 817.900012 494.2000732 791.900012 504.5999756 804.1000242",
    fill: "#ecdbac"
  })), _polygon744 || (_polygon744 = /*#__PURE__*/React.createElement("polygon", {
    points: "541.0999756 684.6000242 541.9000244 660.1000242 537.2000732 677.900012 541.0999756 684.6000242",
    fill: "#cbc0bc"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m541.0999756,684.6000242c0,.2999878-1.0999756,16.4000244-1.0999756,16.4000244l-2.7999268-23.1000366,3.8999023,6.7000122Z",
    fill: "#ada39a"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m540,700.9999876c-.3000488.2999878-1,7.7000122-1,7.7000122l-4.5999756.7999878,5.5999756-8.5Z",
    fill: "#c4bca9"
  })), _polygon745 || (_polygon745 = /*#__PURE__*/React.createElement("polygon", {
    points: "534.5 709.4999876 529.9000244 708.1999998 540 700.9999876 534.5 709.4999876",
    fill: "#9c8e83"
  })), _polygon746 || (_polygon746 = /*#__PURE__*/React.createElement("polygon", {
    points: "529.9000244 708.1999998 537.2000732 677.900012 540 700.9999876 529.9000244 708.1999998",
    fill: "#c0b7ad"
  })), _polygon747 || (_polygon747 = /*#__PURE__*/React.createElement("polygon", {
    points: "541.9000244 660.1000242 536.8000488 672.900012 537.2000732 677.900012 541.9000244 660.1000242",
    fill: "#564c42"
  })), _polygon748 || (_polygon748 = /*#__PURE__*/React.createElement("polygon", {
    points: "536.8000488 672.900012 531.5999756 691.1999998 537.2000732 677.900012 536.8000488 672.900012",
    fill: "#4f443e"
  })), _polygon749 || (_polygon749 = /*#__PURE__*/React.createElement("polygon", {
    points: "537.2000732 677.900012 529.9000244 708.1999998 531.5999756 691.1999998 537.2000732 677.900012",
    fill: "#2a2118"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m531.5999756,691.1999998c-.5.5-5.4000244,15.5-5.4000244,15.5l3.6999512,1.5,1.7000732-17Z",
    fill: "#494238"
  })), _polygon750 || (_polygon750 = /*#__PURE__*/React.createElement("polygon", {
    points: "531.5999756 691.1999998 526.5999756 697.1000242 526.1999512 706.6999998 531.5999756 691.1999998",
    fill: "#978d84"
  })), _polygon751 || (_polygon751 = /*#__PURE__*/React.createElement("polygon", {
    points: "526.5999756 696.9999876 523.2000732 704.9999876 526.2000732 706.6999998 526.5999756 696.9999876",
    fill: "#302919"
  })), _polygon752 || (_polygon752 = /*#__PURE__*/React.createElement("polygon", {
    points: "526.5999756 697.1999998 533 679.4999876 531.5999756 691.1999998 526.5999756 697.1999998",
    fill: "#72685f"
  })), _polygon753 || (_polygon753 = /*#__PURE__*/React.createElement("polygon", {
    points: "533 679.4999876 541.9000244 660.1000242 536.8000488 672.900012 533 679.4999876",
    fill: "#756b62"
  })), _polygon754 || (_polygon754 = /*#__PURE__*/React.createElement("polygon", {
    points: "533 679.4999876 531.5999756 691.1999998 536.8000488 672.900012 533 679.4999876",
    fill: "#7d7467"
  })), _polygon755 || (_polygon755 = /*#__PURE__*/React.createElement("polygon", {
    points: "534.5 709.4999876 527.8000488 741.1000242 529.5 724.7999754 534.5 709.4999876",
    fill: "#c7bfb2"
  })), _polygon756 || (_polygon756 = /*#__PURE__*/React.createElement("polygon", {
    points: "534.5 709.4999876 529.9000244 708.1999998 529.5 724.7999754 534.5 709.4999876",
    fill: "#e1d9cf"
  })), _polygon757 || (_polygon757 = /*#__PURE__*/React.createElement("polygon", {
    points: "529.5 724.7999754 524.3000488 740.1999998 527.8000488 741.1000242 529.5 724.7999754",
    fill: "#e1d9cf"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m529.5,724.7999754c0-.5999756.4000244-16.5999756.4000244-16.5999756l-5.5999756,32,5.1999512-15.4000244Z",
    fill: "#383126"
  })), _polygon758 || (_polygon758 = /*#__PURE__*/React.createElement("polygon", {
    points: "524.3000488 740.1999998 520.7000732 739.1999998 529.9000244 708.1999998 524.3000488 740.1999998",
    fill: "#9f988e"
  })), _polygon759 || (_polygon759 = /*#__PURE__*/React.createElement("polygon", {
    points: "529.9000244 708.1999998 527.2000732 707.1000242 520.7000732 739.1999998 529.9000244 708.1999998",
    fill: "#bab3ad"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m527.8000488,741.1000242c-.3000488.2999878-6,26.5999756-6,26.5999756l1-14.2000122,5-12.3999634Z",
    fill: "#362418"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m522.8000488,753.4999876c0-.5999756,1.5-13.2999878,1.5-13.2999878l3.5.9000244-5,12.3999634Z",
    fill: "#34201a"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m522.8000488,753.4999876c-.4000244.4000244-4.1999512,13.7000122-4.1999512,13.7000122l3.1999512.5,1-14.2000122Z",
    fill: "#2b110f"
  })), _polygon760 || (_polygon760 = /*#__PURE__*/React.createElement("polygon", {
    points: "522.8000488 753.4999876 519.5999756 746.6999998 524.3000488 740.1999998 522.8000488 753.4999876",
    fill: "#3b291f"
  })), _polygon761 || (_polygon761 = /*#__PURE__*/React.createElement("polygon", {
    points: "519.5999756 746.7999754 520.7000732 739.1999998 524.3000488 740.1999998 519.5999756 746.7999754",
    fill: "#54463b"
  })), _polygon762 || (_polygon762 = /*#__PURE__*/React.createElement("polygon", {
    points: "519.5999756 746.6999998 517.0999756 760.6999998 522.8000488 753.4999876 519.5999756 746.6999998",
    fill: "#59453c"
  })), _polygon763 || (_polygon763 = /*#__PURE__*/React.createElement("polygon", {
    points: "517.0999756 760.6999998 516.2000732 766.6000242 518.5999756 767.1999998 517.0999756 760.6999998",
    fill: "#675044"
  })), _polygon764 || (_polygon764 = /*#__PURE__*/React.createElement("polygon", {
    points: "517.0999756 760.6999998 522.8000488 753.4999876 518.5999756 767.1999998 517.0999756 760.6999998",
    fill: "#3a251a"
  })), _polygon765 || (_polygon765 = /*#__PURE__*/React.createElement("polygon", {
    points: "521.8000488 767.6999998 512.4000244 816.4999876 515.5999756 789.9999876 521.8000488 767.6999998",
    fill: "#b7a28b"
  })), _polygon766 || (_polygon766 = /*#__PURE__*/React.createElement("polygon", {
    points: "515.5999756 789.9999876 509.7627389 812.2937053 512.4000244 816.4999876 515.5999756 789.9999876",
    fill: "#9d8470"
  })), _polygon767 || (_polygon767 = /*#__PURE__*/React.createElement("polygon", {
    points: "515.5999756 789.9999876 518.5999756 767.1999998 521.8000488 767.6999998 515.5999756 789.9999876",
    fill: "#8c7062"
  })), _polygon768 || (_polygon768 = /*#__PURE__*/React.createElement("polygon", {
    points: "515.5999756 789.9999876 513.2000732 784.2999754 516.2000732 766.6000242 515.5999756 789.9999876",
    fill: "#ccc3bd"
  })), _polygon769 || (_polygon769 = /*#__PURE__*/React.createElement("polygon", {
    points: "516.2000732 766.6000242 518.5999756 767.1999998 515.5999756 789.9999876 516.2000732 766.6000242",
    fill: "#dbc8b8"
  })), _polygon770 || (_polygon770 = /*#__PURE__*/React.createElement("polygon", {
    points: "515.5999756 789.9999876 513.2000732 784.2999754 509.7627389 812.2937053 515.5999756 789.9999876",
    fill: "#c6baac"
  })), _polygon771 || (_polygon771 = /*#__PURE__*/React.createElement("polygon", {
    points: "513.2000732 784.2999754 508.397131 810.1156581 509.7627389 812.2937053 513.2000732 784.2999754",
    fill: "#e1d0c3"
  })), _polygon772 || (_polygon772 = /*#__PURE__*/React.createElement("polygon", {
    points: "516.7000732 821.6000242 520.5999756 827.7999754 519 833.1000242 516.7000732 821.6000242",
    fill: "#dea687"
  })), _polygon773 || (_polygon773 = /*#__PURE__*/React.createElement("polygon", {
    points: "515.8000488 826.1999998 519 833.1000242 516.7000732 821.6000242 515.8000488 826.1999998",
    fill: "#ddb193"
  })), _polygon774 || (_polygon774 = /*#__PURE__*/React.createElement("polygon", {
    points: "515.8000488 826.1999998 510.5999756 830.1999998 519 833.1000242 515.8000488 826.1999998",
    fill: "#ac6d52"
  })), _polygon775 || (_polygon775 = /*#__PURE__*/React.createElement("polygon", {
    points: "519 833.1000242 516.5 836.2999754 510.5999756 830.1999998 519 833.1000242",
    fill: "#965e51"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m516.5,836.2999754c-.4000244-.4000244-4.5999756-1.7999878-4.5999756-1.7999878l-1.3000488-4.2999878,5.9000244,6.0999756Z",
    fill: "#ac6d52"
  })), _polygon776 || (_polygon776 = /*#__PURE__*/React.createElement("polygon", {
    points: "511.9000244 834.400012 514.2000732 839.4999876 514.4827257 835.4091254 511.9000244 834.400012",
    fill: "#dea687"
  })), _polygon777 || (_polygon777 = /*#__PURE__*/React.createElement("polygon", {
    points: "514.2000732 839.4999876 508.8000488 836.1999998 511.9000244 834.400012 514.2000732 839.4999876",
    fill: "#9d5f4b"
  })), _polygon778 || (_polygon778 = /*#__PURE__*/React.createElement("polygon", {
    points: "508.8000488 836.1999998 510.5999756 830.1999998 511.9000244 834.400012 508.8000488 836.1999998",
    fill: "#905548"
  })), _polygon779 || (_polygon779 = /*#__PURE__*/React.createElement("polygon", {
    points: "508.8000488 836.1999998 502 831.4999876 510.5999756 830.1999998 508.8000488 836.1999998",
    fill: "#8a5444"
  })), _polygon780 || (_polygon780 = /*#__PURE__*/React.createElement("polygon", {
    points: "508.8000488 836.1999998 505.9000244 837.6000242 500.7000732 835.900012 508.8000488 836.1999998",
    fill: "#422113"
  })), _polygon781 || (_polygon781 = /*#__PURE__*/React.createElement("polygon", {
    points: "500.7000732 835.900012 502 831.4999876 508.8000488 836.1999998 500.7000732 835.900012",
    fill: "#5a3420"
  })), _polygon782 || (_polygon782 = /*#__PURE__*/React.createElement("polygon", {
    points: "505.9000244 837.6000242 514.2000732 839.4999876 508.8000488 836.1999998 505.9000244 837.6000242",
    fill: "#ac6d52"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m505.9000244,837.6000242l4.9000244,5.1999512,3.4000244-3.2999268-8.3000488-1.9000244Z",
    fill: "#a3634d"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m510.8000488,842.7999754h-3.5l-1.4000244-5.1999512,4.9000244,5.1999512Z",
    fill: "#6b3c30"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m501.7000732,836.1999998c0,.5-4.3000488,33.7000122-4.3000488,33.7000122l4.5999756-13.0999756-.2999268-20.6000366Z",
    fill: "#463426"
  })), _polygon783 || (_polygon783 = /*#__PURE__*/React.createElement("polygon", {
    points: "501.9000244 856.6999998 502.7000732 875.6999998 497.3000488 870.1000242 501.9000244 856.6999998",
    fill: "#38241e"
  })), _polygon784 || (_polygon784 = /*#__PURE__*/React.createElement("polygon", {
    points: "501.9000244 856.6999998 505.9000244 837.6000242 501.7000732 836.1999998 501.9000244 856.6999998",
    fill: "#726159"
  })), _polygon785 || (_polygon785 = /*#__PURE__*/React.createElement("polygon", {
    points: "501.9000244 856.6999998 505.8000488 856.900012 505.9000244 837.6000242 501.9000244 856.6999998",
    fill: "#4e3026"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m505.8000488,856.900012c0-.7999878,1.5-14.0999756,1.5-14.0999756l-1.4000244-5.2000122-.0999756,19.2999878Z",
    fill: "#2d1a10"
  })), _polygon786 || (_polygon786 = /*#__PURE__*/React.createElement("polygon", {
    points: "505.8000488 856.900012 502.5999756 875.6000242 501.9000244 856.6999998 505.8000488 856.900012",
    fill: "#432d24"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m359,738.6000242l-7.4000244,5.9000244-2.5059899,6.3999634s10.3060387-12.5,9.9060143-12.2999878Z",
    fill: "#d38555"
  })), _polygon787 || (_polygon787 = /*#__PURE__*/React.createElement("polygon", {
    points: "359 738.6000242 356.6000366 751.6999998 349.0939857 750.900012 359 738.6000242",
    fill: "#b17154"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m356.6000366,751.6999998c0,.7999878.7999878,19.4000244.7999878,19.4000244l3.7000122-22.4000244-4.5,3Z",
    fill: "#61321f"
  })), _polygon788 || (_polygon788 = /*#__PURE__*/React.createElement("polygon", {
    points: "359 738.6000242 361.1000366 748.6999998 363.4000244 736.7999754 359 738.6000242",
    fill: "#61321f"
  })), _polygon789 || (_polygon789 = /*#__PURE__*/React.createElement("polygon", {
    points: "356.6000366 751.6999998 359 738.6000242 361.1000366 748.6999998 356.6000366 751.6999998",
    fill: "#cc8768"
  })), _polygon790 || (_polygon790 = /*#__PURE__*/React.createElement("polygon", {
    points: "349.0939857 750.900012 345.1000366 761.1000242 356.6000366 751.6999998 349.0939857 750.900012",
    fill: "#d38555"
  })), _polygon791 || (_polygon791 = /*#__PURE__*/React.createElement("polygon", {
    points: "351.5999756 744.5000486 343.8000488 752.6000242 345.1000366 761.1000242 351.5999756 744.5000486",
    fill: "#d99471"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m343.8000488,752.6000242c-.5999756.5999756-3.2000122,6.6999512-3.2000122,6.6999512l4.5,1.8000488-1.2999878-8.5Z",
    fill: "#cc8768"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m345.1000366,761.1000242c0-.4000244,11.5-9.4000244,11.5-9.4000244l-5.0999756,14.0999756-6.4000244-4.6999512Z",
    fill: "#d99471"
  })), _polygon792 || (_polygon792 = /*#__PURE__*/React.createElement("polygon", {
    points: "351.5 765.7999754 357.4000244 771.1000242 356.6000366 751.6999998 351.5 765.7999754",
    fill: "#794831"
  })), _polygon793 || (_polygon793 = /*#__PURE__*/React.createElement("polygon", {
    points: "340.6000366 759.2999754 320.9000244 756.5999632 330.5 775.2999754 340.6000366 759.2999754",
    fill: "#d5d2cc"
  })), _polygon794 || (_polygon794 = /*#__PURE__*/React.createElement("polygon", {
    points: "340.6000366 759.2999754 345.1000366 761.1000242 351.5 765.7999754 330.5 775.2999754 340.6000366 759.2999754",
    fill: "#e4d1ce"
  })), _polygon795 || (_polygon795 = /*#__PURE__*/React.createElement("polygon", {
    points: "351.5 765.7999754 357.4000244 771.1000242 346.8000488 773.4999876 351.5 765.7999754",
    fill: "#b8a897"
  })), _polygon796 || (_polygon796 = /*#__PURE__*/React.createElement("polygon", {
    points: "346.8000488 773.4999876 330.5 775.2999754 351.5 765.7999754 346.8000488 773.4999876",
    fill: "#c7bab2"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m346.8000488,773.4999876l6.9038218,27.3530726,3.6961538-29.8530726-10.5999756,2.5Z",
    fill: "#b3a094"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m346.8000488,773.4999876s-16.2000122,1.7999878-16.3000488,1.7999878c-.0999756,0,23.0999756,24.9000244,23.0999756,24.9000244l-6.7999268-26.7000122Z",
    fill: "#a18f81"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m330.5,775.2999754c-.7999878,0-19-8.2000122-19-8.2000122l9.4000244-10.5,9.5999756,18.7000122Z",
    fill: "#c1b4ab"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m320.9000244,756.5999632l-21.3000488,14.1000366,12-3.5999756,9.3000488-10.500061Z",
    fill: "#a29787"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m299.5,770.6999998c-.7999878.7999878-10.5,18.7999878-10.5,18.7999878l11.7000122-12.7000122-1.2000122-6.0999756Z",
    fill: "#7f6e5c"
  })), _polygon797 || (_polygon797 = /*#__PURE__*/React.createElement("polygon", {
    points: "299.5 770.6999998 311.5 767.1000242 300.7000122 776.7999754 299.5 770.6999998",
    fill: "#9d8e79"
  })), _polygon798 || (_polygon798 = /*#__PURE__*/React.createElement("polygon", {
    points: "311.5 767.1000242 330.5 775.2999754 300.7000122 776.7999754 311.5 767.1000242",
    fill: "#ae9c90"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m330.5,775.2999754l-14.6999512,10.3000488-15.1000366-8.8000488,29.7999878-1.5Z",
    fill: "#a08d7d"
  })), _polygon799 || (_polygon799 = /*#__PURE__*/React.createElement("polygon", {
    points: "330.5 775.2999754 315.8000488 785.6000242 330.5 791.400012 330.5 775.2999754",
    fill: "#7c6b5c"
  })), _polygon800 || (_polygon800 = /*#__PURE__*/React.createElement("polygon", {
    points: "330.5 791.400012 353.6000366 800.1999998 330.5 775.2999754 330.5 791.400012",
    fill: "#9c8c71"
  })), _polygon801 || (_polygon801 = /*#__PURE__*/React.createElement("polygon", {
    points: "353.9096736 799.5770818 340.9000244 816.6999998 348.9000244 837.900012 353.9096736 799.5770818",
    fill: "#3e2c1b"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m340.9000244,816.6999998c-.0999756-.0999756-.2999878-.4000244-.5-.7999878-2.4000244-4.4000244-9.9000244-24.0999756-9.9000244-24.5s23.0999756,8.7000122,23.0999756,8.7000122l-12.6999512,16.5999756Z",
    fill: "#5c4c3d"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m340.9000244,816.6999998c-.7999878,0-20.9000244-9.2999878-20.9000244-9.2999878l10.5-16,10.4000244,25.2999878Z",
    fill: "#ad937d"
  })), _polygon802 || (_polygon802 = /*#__PURE__*/React.createElement("polygon", {
    points: "320 807.400012 315.8000488 785.6000242 330.5 791.400012 320 807.400012",
    fill: "#726253"
  })), _polygon803 || (_polygon803 = /*#__PURE__*/React.createElement("polygon", {
    points: "320 807.400012 300.7000122 776.7999754 315.8000488 785.6000242 320 807.400012",
    fill: "#7d624d"
  })), _polygon804 || (_polygon804 = /*#__PURE__*/React.createElement("polygon", {
    points: "300.7000122 776.7999754 294.6000366 815.2999754 289 789.4999876 300.7000122 776.7999754",
    fill: "#70614a"
  })), _polygon805 || (_polygon805 = /*#__PURE__*/React.createElement("polygon", {
    points: "294.6000366 815.2999754 284.6000366 832.2999754 284.4000244 808.900012 294.6000366 815.2999754",
    fill: "#b49880"
  })), _polygon806 || (_polygon806 = /*#__PURE__*/React.createElement("polygon", {
    points: "284.4000244 808.900012 289 789.4999876 294.6000366 815.2999754 284.4000244 808.900012",
    fill: "#6f5a47"
  })), _polygon807 || (_polygon807 = /*#__PURE__*/React.createElement("polygon", {
    points: "294.6000366 815.2999754 320 807.400012 300.7000122 776.7999754 294.6000366 815.2999754",
    fill: "#5c4c3d"
  })), _polygon808 || (_polygon808 = /*#__PURE__*/React.createElement("polygon", {
    points: "320 807.400012 313.3000488 848.6000242 294.6000366 815.2999754 320 807.400012",
    fill: "#af937e"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m320,807.400012l13,39.2000122-19.6999512,2,6.6999512-41.2000122Z",
    fill: "#9b806b"
  })), _polygon809 || (_polygon809 = /*#__PURE__*/React.createElement("polygon", {
    points: "320 807.400012 340.9000244 816.6999998 333 846.6000242 320 807.400012",
    fill: "#8f7869"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m340.9000244,816.6999998l-1.2000122,47.8000488,9.5-25.9000244-8.2999878-21.9000244Z",
    fill: "#af937e"
  })), _polygon810 || (_polygon810 = /*#__PURE__*/React.createElement("polygon", {
    points: "339.7000122 864.4999876 346.5 875.2999754 349.2000122 838.4999876 339.7000122 864.4999876",
    fill: "#3e2c1b"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m339.7000122,864.4999876c-.5-.5-6.7000122-17.9000244-6.7000122-17.9000244l7.9000244-29.9000244-1.2000122,47.8000488Z",
    fill: "#c4ab93"
  })), _polygon811 || (_polygon811 = /*#__PURE__*/React.createElement("polygon", {
    points: "339.7000122 864.4999876 324.2000122 872.7999754 333 846.6000242 339.7000122 864.4999876",
    fill: "#b59a85"
  })), _polygon812 || (_polygon812 = /*#__PURE__*/React.createElement("polygon", {
    points: "324.2000122 872.7999754 313.3000488 848.6000242 333 846.6000242 324.2000122 872.7999754",
    fill: "#9c8c71"
  })), _polygon813 || (_polygon813 = /*#__PURE__*/React.createElement("polygon", {
    points: "324.2000122 872.7999754 300.2000122 857.6999998 313.3000488 848.6000242 324.2000122 872.7999754",
    fill: "#63513d"
  })), _polygon814 || (_polygon814 = /*#__PURE__*/React.createElement("polygon", {
    points: "300.2000122 857.6999998 294.6000366 815.2999754 313.3000488 848.6000242 300.2000122 857.6999998",
    fill: "#6f5a47"
  })), _polygon815 || (_polygon815 = /*#__PURE__*/React.createElement("polygon", {
    points: "294.6000366 815.2999754 291.5 868.6000242 284.6000366 832.2999754 294.6000366 815.2999754",
    fill: "#c3aa90"
  })), _polygon816 || (_polygon816 = /*#__PURE__*/React.createElement("polygon", {
    points: "291.5 868.6000242 300.2000122 857.6999998 294.6000366 815.2999754 291.5 868.6000242",
    fill: "#7d624d"
  })), _polygon817 || (_polygon817 = /*#__PURE__*/React.createElement("polygon", {
    points: "302.7000122 876.900012 291.5 868.6000242 300.2000122 857.6999998 302.7000122 876.900012",
    fill: "#685746"
  })), _polygon818 || (_polygon818 = /*#__PURE__*/React.createElement("polygon", {
    points: "302.7000122 876.900012 304.6000366 893.6999998 291.5 868.6000242 302.7000122 876.900012",
    fill: "#574738"
  })), _polygon819 || (_polygon819 = /*#__PURE__*/React.createElement("polygon", {
    points: "304.6000366 893.6999998 314.1000366 904.7999754 311.7000122 894.1000242 304.6000366 893.6999998",
    fill: "#302414"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m311.7000122,894.1000242l-9-17.2000122,1.9000244,16.7999878,7.0999756.4000244Z",
    fill: "#5c483d"
  })), _polygon820 || (_polygon820 = /*#__PURE__*/React.createElement("polygon", {
    points: "302.7000122 876.900012 324.2000122 872.7999754 300.2000122 857.6999998 302.7000122 876.900012",
    fill: "#7d624d"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m302.6000366,876.899951l9,17.2999268,12.5999756-21.3999023-21.5999756,4.0999756Z",
    fill: "#4b3a29"
  })), _polygon821 || (_polygon821 = /*#__PURE__*/React.createElement("polygon", {
    points: "324.2000122 872.7999754 339.5 891.6999998 339.7000122 864.4999876 324.2000122 872.7999754",
    fill: "#9b806b"
  })), _polygon822 || (_polygon822 = /*#__PURE__*/React.createElement("polygon", {
    points: "339.5 891.6999998 346.5 875.2999754 339.7000122 864.4999876 339.5 891.6999998",
    fill: "#c0a590"
  })), _polygon823 || (_polygon823 = /*#__PURE__*/React.createElement("polygon", {
    points: "339.5 891.6999998 346.6199052 907.1000242 346.5 875.2999754 339.5 891.6999998",
    fill: "#3e2c1b"
  })), _polygon824 || (_polygon824 = /*#__PURE__*/React.createElement("polygon", {
    points: "339.5 891.6999998 340.6000366 918.6000242 346.6199052 907.1000242 339.5 891.6999998",
    fill: "#4e3b2b"
  })), _polygon825 || (_polygon825 = /*#__PURE__*/React.createElement("polygon", {
    points: "346.6199052 907.1000242 347.3000488 918.400012 340.6000366 918.6000242 346.6199052 907.1000242",
    fill: "#231b13"
  })), _polygon826 || (_polygon826 = /*#__PURE__*/React.createElement("polygon", {
    points: "340.6000366 918.6000242 322.7000122 911.9999876 330.8000488 907.6000242 340.6000366 918.6000242",
    fill: "#281e14"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m322.7000122,911.9999876l-8.5999756-7.2000122,8.2999878-3,.2999878,10.2000122Z",
    fill: "#4d331c"
  })), _polygon827 || (_polygon827 = /*#__PURE__*/React.createElement("polygon", {
    points: "322.4000244 901.7999754 330.8000488 907.6000242 322.7000122 911.9999876 322.4000244 901.7999754",
    fill: "#2a2014"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m322.4000244,901.7999754l1.7999878-29-12.5999756,21.2999878,10.7999878,7.7000122Z",
    fill: "#574738"
  })), _polygon828 || (_polygon828 = /*#__PURE__*/React.createElement("polygon", {
    points: "322.4000244 901.7999754 311.7000122 894.1000242 314.1000366 904.7999754 322.4000244 901.7999754",
    fill: "#4e3b2b"
  })), _polygon829 || (_polygon829 = /*#__PURE__*/React.createElement("polygon", {
    points: "339.5 891.6999998 324.2000122 872.7999754 322.4000244 901.7999754 339.5 891.6999998",
    fill: "#4b3a29"
  })), _polygon830 || (_polygon830 = /*#__PURE__*/React.createElement("polygon", {
    points: "322.4000244 901.7999754 330.8000488 907.6000242 339.5 891.6999998 322.4000244 901.7999754",
    fill: "#322b20"
  })), _polygon831 || (_polygon831 = /*#__PURE__*/React.createElement("polygon", {
    points: "330.8000488 907.6000242 340.6000366 918.6000242 339.5 891.6999998 330.8000488 907.6000242",
    fill: "#2f261b"
  })), _polygon832 || (_polygon832 = /*#__PURE__*/React.createElement("polygon", {
    points: "340.6000366 918.6000242 336 942.4999876 347.3000488 918.400012 340.6000366 918.6000242",
    fill: "#75472d"
  })), _polygon833 || (_polygon833 = /*#__PURE__*/React.createElement("polygon", {
    points: "342.4000244 937.400012 336 942.4999876 347.3000488 918.400012 342.4000244 937.400012",
    fill: "#6e391c"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m342.4000244,937.400012c.7999878,0,8.2000122-4.2000122,8.2000122-4.2000122l-3.2999878-14.7999878-4.9000244,19Z",
    fill: "#b9724e"
  })), _polygon834 || (_polygon834 = /*#__PURE__*/React.createElement("polygon", {
    points: "350.6000366 933.1999998 354 951.1999998 342.4000244 937.400012 350.6000366 933.1999998",
    fill: "#d48d68"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "m354,951.1999998c-1.2999878,0-12-6.7999878-12-6.7999878l.4000244-7,11.5999756,13.7999878Z",
    fill: "#cc8768"
  })), _polygon835 || (_polygon835 = /*#__PURE__*/React.createElement("polygon", {
    points: "342 944.400012 336 942.4999876 342.4000244 937.400012 342 944.400012",
    fill: "#bd8062"
  })), _polygon836 || (_polygon836 = /*#__PURE__*/React.createElement("polygon", {
    points: "336 942.4999876 330.2000122 946.6000242 327 957.6000242 336 942.4999876",
    fill: "#070707"
  })), _polygon837 || (_polygon837 = /*#__PURE__*/React.createElement("polygon", {
    points: "327 957.6000242 320.5 986.2999754 330.2000122 970.6999998 327 957.6000242",
    fill: "#121210"
  })), _polygon838 || (_polygon838 = /*#__PURE__*/React.createElement("polygon", {
    points: "327 957.6000242 338.2000122 953.1000242 336 942.4999876 327 957.6000242",
    fill: "#3c291e"
  })), _polygon839 || (_polygon839 = /*#__PURE__*/React.createElement("polygon", {
    points: "338.2000122 953.1000242 330.2000122 970.6999998 327 957.6000242 338.2000122 953.1000242",
    fill: "#3b2a19"
  })), _polygon840 || (_polygon840 = /*#__PURE__*/React.createElement("polygon", {
    points: "338.2000122 953.1000242 342 944.400012 336 942.4999876 338.2000122 953.1000242",
    fill: "#161411"
  })), _polygon841 || (_polygon841 = /*#__PURE__*/React.createElement("polygon", {
    points: "338.2000122 953.1000242 354 951.1999998 342 944.400012 338.2000122 953.1000242",
    fill: "#11120f"
  })), _polygon842 || (_polygon842 = /*#__PURE__*/React.createElement("polygon", {
    points: "338.2000122 953.1000242 354.4000244 963.7999754 354 951.1999998 338.2000122 953.1000242",
    fill: "#432d1c"
  })), _polygon843 || (_polygon843 = /*#__PURE__*/React.createElement("polygon", {
    points: "354.4000244 963.7999754 357.8000488 959.1000242 354 951.1999998 354.4000244 963.7999754",
    fill: "#342214"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m354.4000244,963.7999754c-1,1-5.9000244,19.7999878-5.9000244,19.7999878l-3.7000122-16.4000244,9.6000366-3.3999634Z",
    fill: "#3a281e"
  })), _polygon844 || (_polygon844 = /*#__PURE__*/React.createElement("polygon", {
    points: "344.9000244 967.1999998 338.2000122 953.1000242 354.4000244 963.7999754 344.9000244 967.1999998",
    fill: "#624b39"
  })), _polygon845 || (_polygon845 = /*#__PURE__*/React.createElement("polygon", {
    points: "344.9000244 967.1999998 335.2000122 999.400012 348.5 983.6000242 344.9000244 967.1999998",
    fill: "#533a28"
  })), _polygon846 || (_polygon846 = /*#__PURE__*/React.createElement("polygon", {
    points: "344.9000244 967.1999998 332.6000366 984.4999876 335.2000122 999.400012 344.9000244 967.1999998",
    fill: "#745e4e"
  })), _polygon847 || (_polygon847 = /*#__PURE__*/React.createElement("polygon", {
    points: "332.6000366 984.4999876 338.2000122 953.1000242 344.9000244 967.1999998 332.6000366 984.4999876",
    fill: "#735845"
  })), _polygon848 || (_polygon848 = /*#__PURE__*/React.createElement("polygon", {
    points: "332.6000366 984.6000242 330.2000122 970.6999998 338.2000122 953.1000242 332.6000366 984.6000242",
    fill: "#463020"
  })), _polygon849 || (_polygon849 = /*#__PURE__*/React.createElement("polygon", {
    points: "348.5 983.6000242 335.8000488 1012.6000242 335.2000122 999.400012 348.5 983.6000242",
    fill: "#291d15"
  })), _polygon850 || (_polygon850 = /*#__PURE__*/React.createElement("polygon", {
    points: "335.8000488 1012.6000242 331.7000122 1027.1000242 326 1021.7999754 335.8000488 1012.6000242",
    fill: "#3b2a19"
  })), _polygon851 || (_polygon851 = /*#__PURE__*/React.createElement("polygon", {
    points: "326 1021.7999754 319.9000244 1029.0000486 319.2000122 1014.899951 326 1021.7999754",
    fill: "#1d150f"
  })), _polygon852 || (_polygon852 = /*#__PURE__*/React.createElement("polygon", {
    points: "319.9000244 1029.0000486 311.7000122 1026.6999998 316.4000244 1013.2999754 319.9000244 1029.0000486",
    fill: "#392717"
  })), _polygon853 || (_polygon853 = /*#__PURE__*/React.createElement("polygon", {
    points: "316.4000244 1013.2999754 318.6000366 1001.6000242 319.2090517 1014.9988678 316.4000244 1013.2999754",
    fill: "#322016"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m316.4000244,1013.2999754c0,.7000122,3.5,15.7000732,3.5,15.7000732l-.6909728-14.0011809-2.8090272-1.6988924Z",
    fill: "#15120f"
  })), _polygon854 || (_polygon854 = /*#__PURE__*/React.createElement("polygon", {
    points: "319.2000122 1014.899951 326.7000122 999.400012 326 1021.7999754 319.2000122 1014.899951",
    fill: "#0c0c0c"
  })), _polygon855 || (_polygon855 = /*#__PURE__*/React.createElement("polygon", {
    points: "318.6000366 1001.6000242 320.5 986.2999754 326.7000122 999.400012 318.6000366 1001.6000242",
    fill: "#1b1611"
  })), _polygon856 || (_polygon856 = /*#__PURE__*/React.createElement("polygon", {
    points: "318.6000366 1001.6000242 319.2000122 1014.899951 326.7000122 999.400012 318.6000366 1001.6000242",
    fill: "#191512"
  })), _polygon857 || (_polygon857 = /*#__PURE__*/React.createElement("polygon", {
    points: "320.5 986.2999754 330.2000122 970.6999998 330.5 984.400012 320.5 986.2999754",
    fill: "#1e1810"
  })), _polygon858 || (_polygon858 = /*#__PURE__*/React.createElement("polygon", {
    points: "330.5 984.400012 326.7000122 999.400012 320.5 986.2999754 330.5 984.400012",
    fill: "#281916"
  })), _polygon859 || (_polygon859 = /*#__PURE__*/React.createElement("polygon", {
    points: "330.2000122 970.4999876 330.9000244 1009.400012 335.2000122 999.400012 330.2000122 970.4999876",
    fill: "#584535"
  })), _polygon860 || (_polygon860 = /*#__PURE__*/React.createElement("polygon", {
    points: "330.9000244 1009.400012 335.8000488 1012.6000242 335.2000122 999.400012 330.9000244 1009.400012",
    fill: "#251e16"
  })), _polygon861 || (_polygon861 = /*#__PURE__*/React.createElement("polygon", {
    points: "330.9000244 1009.400012 326 1021.7999754 335.8000488 1012.6000242 330.9000244 1009.400012",
    fill: "#382b2b"
  })), _polygon862 || (_polygon862 = /*#__PURE__*/React.createElement("polygon", {
    points: "330.9000244 1009.400012 326.7000122 999.400012 326 1021.7999754 330.9000244 1009.400012",
    fill: "#1d1514"
  })), _polygon863 || (_polygon863 = /*#__PURE__*/React.createElement("polygon", {
    points: "330.9000244 1009.400012 330.4534519 984.5837552 326.7000122 999.400012 330.9000244 1009.400012",
    fill: "#332218"
  })), _polygon864 || (_polygon864 = /*#__PURE__*/React.createElement("polygon", {
    points: "330.1000366 1025.5000486 324 1031.1999998 326 1021.7999754 330.1000366 1025.5000486",
    fill: "#ac6d52"
  })), _polygon865 || (_polygon865 = /*#__PURE__*/React.createElement("polygon", {
    points: "324 1031.1999998 319.9000244 1029.0000486 326 1021.7999754 324 1031.1999998",
    fill: "#5a3420"
  })), _polygon866 || (_polygon866 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.4000244 1035.1999998 330 1025.6000242 324 1031.1999998 326.4000244 1035.1999998",
    fill: "#845539"
  })), _polygon867 || (_polygon867 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.4000244 1035.1999998 328.8000488 1039.1999998 330 1025.6000242 326.4000244 1035.1999998",
    fill: "#ddb193"
  })), _polygon868 || (_polygon868 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.4000244 1035.1999998 322.2000122 1038.0000486 327.9000244 1049.0000486 326.4000244 1035.1999998",
    fill: "#663116"
  })), _polygon869 || (_polygon869 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.4000244 1035.1999998 328.8000488 1039.1999998 327.9000244 1049.0000486 326.4000244 1035.1999998",
    fill: "#5a2a14"
  })), _polygon870 || (_polygon870 = /*#__PURE__*/React.createElement("polygon", {
    points: "322.2000122 1038.0000486 312.4000244 1049.1999998 324 1031.1999998 322.2000122 1038.0000486",
    fill: "#301b0f"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m322.2000122,1038.0000486c0-1,1.7999878-6.8000488,1.7999878-6.8000488l2.4000244,4-4.2000122,2.8000488Z",
    fill: "#6f3e1c"
  })), _polygon871 || (_polygon871 = /*#__PURE__*/React.createElement("polygon", {
    points: "324 1031.1999998 319.9000244 1029.0000486 320 1034.1999998 324 1031.1999998",
    fill: "#3d1a10"
  })), _polygon872 || (_polygon872 = /*#__PURE__*/React.createElement("polygon", {
    points: "320 1034.1000242 314.9000244 1027.6000242 319.9000244 1029.0000486 320 1034.1000242",
    fill: "#2d1a12"
  })), _polygon873 || (_polygon873 = /*#__PURE__*/React.createElement("polygon", {
    points: "320 1034.1000242 308.9000244 1048.6999998 312.4000244 1049.1999998 324 1031.1999998 320 1034.1000242",
    fill: "#2f1a10"
  })), _polygon874 || (_polygon874 = /*#__PURE__*/React.createElement("polygon", {
    points: "312.4000244 1049.1999998 311.9000244 1052.1000242 320.1000366 1052.7999754 322.2000122 1038.0000486 312.4000244 1049.1999998",
    fill: "#8a5444"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m320.1000366,1052.7999754c.5,0,5.3999634-.4000244,5.3999634-.4000244l-3.2999878-14.3999023-2.0999756,14.7999268Z",
    fill: "#ac6d52"
  })), _polygon875 || (_polygon875 = /*#__PURE__*/React.createElement("polygon", {
    points: "325.5 1052.399951 327.9000244 1049.0000486 322.2000122 1038.0000486 325.5 1052.399951",
    fill: "#ddb193"
  })), _polygon876 || (_polygon876 = /*#__PURE__*/React.createElement("polygon", {
    points: "311.9000244 1052.1000242 308.9000244 1048.6999998 312.4000244 1049.1999998 311.9000244 1052.1000242",
    fill: "#130f0d"
  })), _polygon877 || (_polygon877 = /*#__PURE__*/React.createElement("polygon", {
    points: "311.9000244 1052.1000242 305.1000366 1049.5000486 303.9000244 1043.899951 308.9000244 1048.6999998 311.9000244 1052.1000242",
    fill: "#1f160d"
  })), _polygon878 || (_polygon878 = /*#__PURE__*/React.createElement("polygon", {
    points: "308.9000244 1048.6999998 307.2000122 1040.7999754 303.9000244 1043.899951 308.9000244 1048.6999998",
    fill: "#291910"
  })), _polygon879 || (_polygon879 = /*#__PURE__*/React.createElement("polygon", {
    points: "303.9000244 1043.899951 305 1040.1000242 308.9000244 1037.399951 307.2000122 1040.7999754 303.9000244 1043.899951",
    fill: "#2d1a12"
  })), _polygon880 || (_polygon880 = /*#__PURE__*/React.createElement("polygon", {
    points: "308.9000244 1037.399951 314.1000366 1033.0000486 308.9000244 1048.6999998 308.9000244 1037.399951",
    fill: "#61321f"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m308.9000244,1037.399951c-.5999756.5999756-1.7999878,3.4000244-1.7999878,3.4000244l1.7999878,7.9000244v-11.3000488Z",
    fill: "#5a2a14"
  })), _polygon881 || (_polygon881 = /*#__PURE__*/React.createElement("polygon", {
    points: "314.1000366 1033.0000486 314.9000244 1027.6000242 320 1034.1000242 314.1000366 1033.0000486",
    fill: "#5c321c"
  })), _polygon882 || (_polygon882 = /*#__PURE__*/React.createElement("polygon", {
    points: "314.1000366 1033.0000486 308.9000244 1048.6999998 320 1034.1000242 314.1000366 1033.0000486",
    fill: "#673b25"
  })), _polygon883 || (_polygon883 = /*#__PURE__*/React.createElement("polygon", {
    points: "305 1040.1000242 297.6000366 1047.5000486 303.9000244 1043.899951 305 1040.1000242",
    fill: "#5a2a14"
  })), _polygon884 || (_polygon884 = /*#__PURE__*/React.createElement("polygon", {
    points: "303.9000244 1043.899951 305.1000366 1049.5000486 300.3000488 1048.7999754 303.9000244 1043.899951",
    fill: "#61321f"
  })), _polygon885 || (_polygon885 = /*#__PURE__*/React.createElement("polygon", {
    points: "303.9000244 1043.899951 297.6000366 1047.5000486 300.3000488 1048.7999754 303.9000244 1043.899951",
    fill: "#663116"
  })), _polygon886 || (_polygon886 = /*#__PURE__*/React.createElement("polygon", {
    points: "297.6000366 1047.5000486 298.2000122 1050.6000242 300.4000244 1048.8000975 297.6000366 1047.5000486",
    fill: "#221e18"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "m298.2000122,1050.6000242c.7999878,0,12.2000122,5.3000488,12.2000122,5.3000488l-10-7.0999756-2.2000122,1.7999268Z",
    fill: "#1c1812"
  })), _polygon887 || (_polygon887 = /*#__PURE__*/React.createElement("polygon", {
    points: "300.3000488 1048.7999754 305.1000366 1049.5000486 310.3000488 1055.899951 300.3000488 1048.7999754",
    fill: "#1a140e"
  })), _polygon888 || (_polygon888 = /*#__PURE__*/React.createElement("polygon", {
    points: "305.1000366 1049.5000486 311.9000244 1052.1000242 310.3000488 1055.899951 305.1000366 1049.5000486",
    fill: "#231b13"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "m311.9000244,1052.1000242c.5,0,8.2000122.6999512,8.2000122.6999512l-9.7999878,3.0999756,1.5999756-3.7999268Z",
    fill: "#2d1a12"
  })), _polygon889 || (_polygon889 = /*#__PURE__*/React.createElement("polygon", {
    points: "310.3000488 1055.899951 314.4000244 1057.7999754 320.1000366 1052.7999754 310.3000488 1055.899951",
    fill: "#0f100f"
  })), _polygon890 || (_polygon890 = /*#__PURE__*/React.createElement("polygon", {
    points: "314.4000244 1057.7999754 330.7000122 1055.899951 320.1000366 1052.7999754 314.4000244 1057.7999754",
    fill: "#2e282c"
  })), _polygon891 || (_polygon891 = /*#__PURE__*/React.createElement("polygon", {
    points: "320.1000366 1052.7999754 325.5 1052.399951 330.7000122 1055.899951 320.1000366 1052.7999754",
    fill: "#7d4e32"
  })), _polygon892 || (_polygon892 = /*#__PURE__*/React.createElement("polygon", {
    points: "325.5 1052.399951 330 1051.7999754 330.7000122 1055.899951 325.5 1052.399951",
    fill: "#6e3315"
  })), _polygon893 || (_polygon893 = /*#__PURE__*/React.createElement("polygon", {
    points: "330 1051.7999754 327.9000244 1049.0000486 325.5 1052.399951 330 1051.7999754",
    fill: "#45271d"
  })), _polygon894 || (_polygon894 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.8000488 971.1000242 392.1000366 990.4999876 397.6000366 967.900012 387.8000488 971.1000242",
    fill: "#090907"
  })), _polygon895 || (_polygon895 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.1000366 990.4999876 403.7000122 979.1000242 397.6000366 967.900012 392.1000366 990.4999876",
    fill: "#1f1612"
  })), _polygon896 || (_polygon896 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.1000366 990.4999876 393.1000366 1009.9999876 397.9000244 1000.1999998 392.1000366 990.4999876",
    fill: "#181412"
  })), _polygon897 || (_polygon897 = /*#__PURE__*/React.createElement("polygon", {
    points: "397.8000488 1000.1999998 403.7000122 979.1000242 392.1000366 990.4999876 397.8000488 1000.1999998",
    fill: "#10100f"
  })), _polygon898 || (_polygon898 = /*#__PURE__*/React.createElement("polygon", {
    points: "393.1000366 1009.9999876 394.1000366 1024.5000486 398.1000366 1013.1000242 393.1000366 1009.9999876",
    fill: "#151411"
  })), _polygon899 || (_polygon899 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.1000366 1024.5000486 390.7000122 1040.899951 396.2000122 1036.0000486 394.1000366 1024.5000486",
    fill: "#574738"
  })), _polygon900 || (_polygon900 = /*#__PURE__*/React.createElement("polygon", {
    points: "390.7000122 1040.899951 390.5 1045.6000242 394.3000488 1048.2999754 390.7000122 1040.899951",
    fill: "#261c13"
  })), _polygon901 || (_polygon901 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.3000488 1048.2999754 396.2000122 1036.0000486 390.7000122 1040.899951 394.3000488 1048.2999754",
    fill: "#181410"
  })), _polygon902 || (_polygon902 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.3000488 1048.2999754 406.2000122 1052.399951 396.2000122 1036.0000486 394.3000488 1048.2999754",
    fill: "#291c13"
  })), _polygon903 || (_polygon903 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.3000488 1048.2999754 392.5 1055.6999998 397.8000488 1056.6000242 394.3000488 1048.2999754",
    fill: "#673b25"
  })), _polygon904 || (_polygon904 = /*#__PURE__*/React.createElement("polygon", {
    points: "397.8000488 1056.6000242 405.6000366 1057.0000486 394.3000488 1048.2999754 397.8000488 1056.6000242",
    fill: "#a3634d"
  })), _polygon905 || (_polygon905 = /*#__PURE__*/React.createElement("polygon", {
    points: "405.6000366 1057.0000486 411.6000366 1055.1999998 406.2000122 1052.399951 405.6000366 1057.0000486",
    fill: "#61321f"
  })), _polygon906 || (_polygon906 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.2000122 1052.399951 394.3000488 1048.2999754 405.6000366 1057.0000486 406.2000122 1052.399951",
    fill: "#a9725a"
  })), _polygon907 || (_polygon907 = /*#__PURE__*/React.createElement("polygon", {
    points: "411.6000366 1055.1999998 420 1050.6999998 406.2000122 1052.399951 411.6000366 1055.1999998",
    fill: "#2f1e14"
  })), _polygon908 || (_polygon908 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.2000122 1052.399951 409.2000122 1041.5000486 396.2000122 1036.0000486 406.2000122 1052.399951",
    fill: "#5f4430"
  })), _polygon909 || (_polygon909 = /*#__PURE__*/React.createElement("polygon", {
    points: "409.2000122 1041.5000486 420 1050.6999998 406.2000122 1052.399951 409.2000122 1041.5000486",
    fill: "#4a3424"
  })), _polygon910 || (_polygon910 = /*#__PURE__*/React.createElement("polygon", {
    points: "420 1050.6999998 423.9000244 1045.7999754 416.7000122 1044.6000242 420 1050.6999998",
    fill: "#221d17"
  })), _polygon911 || (_polygon911 = /*#__PURE__*/React.createElement("polygon", {
    points: "420 1050.6999998 416.7000122 1044.6000242 409.2000122 1041.5000486 420 1050.6999998",
    fill: "#4e3826"
  })), _polygon912 || (_polygon912 = /*#__PURE__*/React.createElement("polygon", {
    points: "416.7000122 1044.6000242 414.5 1041.1999998 423.9000244 1045.7999754 416.7000122 1044.6000242",
    fill: "#352319"
  })), _polygon913 || (_polygon913 = /*#__PURE__*/React.createElement("polygon", {
    points: "414.5 1041.1999998 409.2000122 1041.5000486 416.7000122 1044.6000242 414.5 1041.1999998",
    fill: "#463426"
  })), _polygon914 || (_polygon914 = /*#__PURE__*/React.createElement("polygon", {
    points: "414.5 1041.1999998 414.4000244 1029.6999998 409.2000122 1041.5000486 414.5 1041.1999998",
    fill: "#5f4432"
  })), _polygon915 || (_polygon915 = /*#__PURE__*/React.createElement("polygon", {
    points: "409.2000122 1041.5000486 396.2000122 1036.0000486 402.3000488 1023.0000486 409.2000122 1041.5000486",
    fill: "#573e2a"
  })), _polygon916 || (_polygon916 = /*#__PURE__*/React.createElement("polygon", {
    points: "402.3000488 1023.0000486 406.8000488 1011.1000242 409.2000122 1041.5000486 402.3000488 1023.0000486",
    fill: "#6b4d41"
  })), _polygon917 || (_polygon917 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.8000488 1011.1000242 414.4000244 1029.6999998 409.2000122 1041.5000486 406.8000488 1011.1000242",
    fill: "#54422e"
  })), _polygon918 || (_polygon918 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.1000366 1024.5000486 398.1000366 1013.1000242 396.2000122 1036.0000486 394.1000366 1024.5000486",
    fill: "#141310"
  })), _polygon919 || (_polygon919 = /*#__PURE__*/React.createElement("polygon", {
    points: "398.1000366 1013.1000242 402.3000488 1023.0000486 396.2000122 1036.0000486 398.1000366 1013.1000242",
    fill: "#3d2e20"
  })), _polygon920 || (_polygon920 = /*#__PURE__*/React.createElement("polygon", {
    points: "398.1000366 1013.1000242 397.8000488 1000.1999998 393.1000366 1009.9999876 398.1000366 1013.1000242",
    fill: "#291f16"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "m398.1000366,1013.1000242c.4000244-.4000244,8.7000122-2,8.7000122-2l-4.5,12-4.2000122-10Z",
    fill: "#352317"
  })), _polygon921 || (_polygon921 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.8000488 1011.1000242 397.8000488 1000.1999998 398.1000366 1013.1000242 406.8000488 1011.1000242",
    fill: "#36281e"
  })), _polygon922 || (_polygon922 = /*#__PURE__*/React.createElement("polygon", {
    points: "414.4000244 1029.6999998 417.6000366 1011.2999754 406.8000488 1011.1000242 414.4000244 1029.6999998",
    fill: "#6a5544"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "m417.6000366,1011.2999754c0-1.2000122,5-21.2999878,5-21.2999878l-8,8.9000244,3,12.3999634Z",
    fill: "#4d3627"
  })), _polygon923 || (_polygon923 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.8000488 1011.1000242 414.6000366 998.900012 417.6000366 1011.2999754 406.8000488 1011.1000242",
    fill: "#644131"
  })), _polygon924 || (_polygon924 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.8000488 1011.1000242 403.7000122 979.1000242 397.8000488 1000.1999998 406.8000488 1011.1000242",
    fill: "#302317"
  })), _polygon925 || (_polygon925 = /*#__PURE__*/React.createElement("polygon", {
    points: "414.6000366 998.900012 403.7000122 979.1000242 406.8000488 1011.1000242 414.6000366 998.900012",
    fill: "#533e29"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "m414.9000244,997.1000242c0-1,1.8462188-23.3000488,1.8462188-23.3000488l-13.046231,5.3000488,10.9000244,19.7999878.2999878-1.7999878Z",
    fill: "#5d381e"
  })), _polygon926 || (_polygon926 = /*#__PURE__*/React.createElement("polygon", {
    points: "414.6000366 998.900012 422.6000366 989.9999876 416.6000366 973.7999754 414.6000366 998.900012",
    fill: "#4f3929"
  })), _polygon927 || (_polygon927 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.6000366 989.9999876 424.9000244 978.6000242 416.6000366 973.7999754 422.6000366 989.9999876",
    fill: "#5b341b"
  })), _polygon928 || (_polygon928 = /*#__PURE__*/React.createElement("polygon", {
    points: "403.7000122 979.1000242 397.6000366 967.900012 416.7462432 973.7999754 403.7000122 979.1000242",
    fill: "#272016"
  })), _polygon929 || (_polygon929 = /*#__PURE__*/React.createElement("polygon", {
    points: "423.9000244 1045.7999754 425.8000488 1049.1999998 420 1050.6999998 423.9000244 1045.7999754",
    fill: "#ddb193"
  })), _polygon930 || (_polygon930 = /*#__PURE__*/React.createElement("polygon", {
    points: "425.8000488 1049.1999998 422.3000488 1053.6999998 420 1050.6999998 425.8000488 1049.1999998",
    fill: "#ac6d52"
  })), _polygon931 || (_polygon931 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.3000488 1053.6999998 411.6000366 1055.1999998 420 1050.6999998 422.3000488 1053.6999998",
    fill: "#61321f"
  })), _polygon932 || (_polygon932 = /*#__PURE__*/React.createElement("polygon", {
    points: "425.8000488 1049.1999998 427.5 1050.1999998 426.8000488 1053.6000242 425.8000488 1049.1999998",
    fill: "#5c3c25"
  })), _polygon933 || (_polygon933 = /*#__PURE__*/React.createElement("polygon", {
    points: "426.8000488 1053.6000242 422.3000488 1053.6999998 425.8000488 1049.1999998 426.8000488 1053.6000242",
    fill: "#5c2f16"
  })), _polygon934 || (_polygon934 = /*#__PURE__*/React.createElement("polygon", {
    points: "426.8000488 1053.6000242 416.8000488 1057.6000242 422.3000488 1053.6999998 426.8000488 1053.6000242",
    fill: "#4d2c1c"
  })), _polygon935 || (_polygon935 = /*#__PURE__*/React.createElement("polygon", {
    points: "416.8000488 1057.6000242 411.6000366 1055.1999998 422.3000488 1053.6999998 416.8000488 1057.6000242",
    fill: "#4c3629"
  })), _polygon936 || (_polygon936 = /*#__PURE__*/React.createElement("polygon", {
    points: "416.8000488 1057.6000242 407.5 1061.399951 411.6000366 1055.1999998 416.8000488 1057.6000242",
    fill: "#171617"
  })), _polygon937 || (_polygon937 = /*#__PURE__*/React.createElement("polygon", {
    points: "407.5 1061.399951 405.6000366 1057.0000486 411.6000366 1055.1999998 407.5 1061.399951",
    fill: "#573a2c"
  })), _polygon938 || (_polygon938 = /*#__PURE__*/React.createElement("polygon", {
    points: "407.5 1061.399951 396.9000244 1060.6999998 405.6000366 1057.0000486 407.5 1061.399951",
    fill: "#17181a"
  })), _polygon939 || (_polygon939 = /*#__PURE__*/React.createElement("polygon", {
    points: "396.9000244 1060.6999998 397.8000488 1056.6000242 405.6000366 1057.0000486 396.9000244 1060.6999998",
    fill: "#35241c"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "m396.9000244,1060.6999998c-1.0999756,0-5.5999756-1.1999512-5.5999756-1.1999512l6.5-2.9000244-.9000244,4.0999756Z",
    fill: "#111312"
  })), _polygon940 || (_polygon940 = /*#__PURE__*/React.createElement("polygon", {
    points: "391.3000488 1059.5000486 392.5 1055.6999998 397.8000488 1056.6000242 391.3000488 1059.5000486",
    fill: "#21140c"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "m486.2000732,967.400012c0,.7999878-10.9000244,49.2000122-10.9000244,49.2000122l4.2999268-33.5,6.6000977-15.7000122Z",
    fill: "#c6baac"
  })), _polygon941 || (_polygon941 = /*#__PURE__*/React.createElement("polygon", {
    points: "479.5999756 983.1000242 481.7000732 964.9999876 486.2000732 967.400012 479.5999756 983.1000242",
    fill: "#8c7062"
  })), _polygon942 || (_polygon942 = /*#__PURE__*/React.createElement("polygon", {
    points: "479.5999756 983.1000242 471.7000122 1015.1000242 475.3000488 1016.6000242 479.5999756 983.1000242",
    fill: "#9d8470"
  })), _polygon943 || (_polygon943 = /*#__PURE__*/React.createElement("polygon", {
    points: "471.7000122 1015.1000242 481.5999756 966.1999998 479.5999756 983.1000242 471.7000122 1015.1000242",
    fill: "#9d8470"
  })), _polygon944 || (_polygon944 = /*#__PURE__*/React.createElement("polygon", {
    points: "471.7000122 1015.1000242 464.2000122 1049.1999998 475.3000488 1016.6000242 471.7000122 1015.1000242",
    fill: "#9d8470"
  })), _polygon945 || (_polygon945 = /*#__PURE__*/React.createElement("polygon", {
    points: "475.3000488 1016.6000242 468.7000122 1049.7999754 464.2000122 1049.1999998 475.3000488 1016.6000242",
    fill: "#8c7062"
  })), _polygon946 || (_polygon946 = /*#__PURE__*/React.createElement("polygon", {
    points: "464.2000122 1049.1999998 469.8000488 1013.9999876 471.7000122 1015.1000242 464.2000122 1049.1999998",
    fill: "#ccc3bd"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m469.8000488,1013.9999876l11.8000488-48v.2000122l-9.9000854,48.9000244-1.8999634-1.1000366Z",
    fill: "#ccc3bd"
  })), _polygon947 || (_polygon947 = /*#__PURE__*/React.createElement("polygon", {
    points: "464.2000122 1049.1999998 461.1000366 1047.5000486 469.8000488 1013.9999876 464.2000122 1049.1999998",
    fill: "#e1d0c3"
  })), _polygon948 || (_polygon948 = /*#__PURE__*/React.createElement("polygon", {
    points: "488.4000244 776.6999998 479.1000366 776.400012 488.8000488 783.7999754 488.4000244 776.6999998",
    fill: "#d48d68"
  })), _polygon949 || (_polygon949 = /*#__PURE__*/React.createElement("polygon", {
    points: "409.2000122 673.900012 419.7000122 678.6000242 413.1000366 683.4999876 409.2000122 673.900012",
    fill: "#d1d2d4"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "m419.7000122,678.6000242l5.7000122,8.7000122-12.2999878-3.8000488,6.5999756-4.8999634Z",
    fill: "#f0edeb"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m413.1000366,683.4999876c.0999756.0999756,3.5,12.5999756,3.7999878,12.5s8.5-8.6999512,8.5-8.6999512l-12.2999878-3.8000488Z",
    fill: "#f4f3f2"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m425.4000244,687.3000364l1.2000122,14.3999634-9.7000122-5.7000122,8.5-8.6999512Z",
    fill: "#cdc2be"
  })), _polygon950 || (_polygon950 = /*#__PURE__*/React.createElement("polygon", {
    points: "426.6000366 701.6999998 422.9000244 715.6999998 417.8000488 705.6000242 426.6000366 701.6999998",
    fill: "#91807e"
  })), _polygon951 || (_polygon951 = /*#__PURE__*/React.createElement("polygon", {
    points: "417.8000488 705.6000242 426.6000366 701.6999998 416.9000244 695.9999876 417.8000488 705.6000242",
    fill: "#a2908c"
  })), _polygon952 || (_polygon952 = /*#__PURE__*/React.createElement("polygon", {
    points: "413.1000366 683.4999876 408.5 692.900012 409.2000122 673.900012 413.1000366 683.4999876",
    fill: "#babcbe"
  })), _polygon953 || (_polygon953 = /*#__PURE__*/React.createElement("polygon", {
    points: "413.1000366 683.4999876 416.9000244 695.9999876 408.3611711 692.900012 413.1000366 683.4999876",
    fill: "#c6bebc"
  })), _polygon954 || (_polygon954 = /*#__PURE__*/React.createElement("polygon", {
    points: "416.9000244 695.9999876 407.2000122 712.4999876 408.5 692.900012 416.9000244 695.9999876",
    fill: "#9e908d"
  })), _polygon955 || (_polygon955 = /*#__PURE__*/React.createElement("polygon", {
    points: "416.9000244 695.9999876 417.8000488 705.6000242 407.2000122 712.4999876 416.9000244 695.9999876",
    fill: "#877876"
  })), _polygon956 || (_polygon956 = /*#__PURE__*/React.createElement("polygon", {
    points: "417.8000488 705.6000242 422.9000244 715.6999998 414.7000122 720.6999998 417.8000488 705.6000242",
    fill: "#746767"
  })), _polygon957 || (_polygon957 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.9000244 715.6999998 424.1000366 723.6999998 414.7000122 720.6999998 422.9000244 715.6999998",
    fill: "#534a4d"
  })), _polygon958 || (_polygon958 = /*#__PURE__*/React.createElement("polygon", {
    points: "423.7000122 721.1000242 428.2000122 724.7999754 416.1000366 732.1000242 423.7000122 721.1000242",
    fill: "#2d2a2c"
  })), _polygon959 || (_polygon959 = /*#__PURE__*/React.createElement("polygon", {
    points: "423.7000122 721.1000242 414.6000366 720.6999998 416.1000366 732.1000242 423.7000122 721.1000242",
    fill: "#423d40"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "m416.1000366,732.1000242c-.5999756,0-10.2999878,3.4000244-10.2999878,3.4000244l-.4000244-6.2000122,10.7000122,2.7999878Z",
    fill: "#2d2a2c"
  })), _polygon960 || (_polygon960 = /*#__PURE__*/React.createElement("polygon", {
    points: "416.1000366 732.1000242 414.7000122 720.6999998 406.1000366 729.4999876 416.1000366 732.1000242",
    fill: "#463f42"
  })), _polygon961 || (_polygon961 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.1000366 729.6000242 406.1000366 722.6000242 407.2000122 712.4999876 410.4000244 719.400012 406.1000366 729.6000242",
    fill: "#463f42"
  })), _polygon962 || (_polygon962 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.4000244 719.2999754 414.7000122 720.6999998 406.1000366 729.4999876 410.4000244 719.2999754",
    fill: "#3d3839"
  })), _polygon963 || (_polygon963 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.4000244 719.400012 417.8000488 705.6000242 407.2000122 712.4999876 410.4000244 719.400012",
    fill: "#695e5e"
  })), _polygon964 || (_polygon964 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.4000244 719.400012 417.8000488 705.6000242 414.7000122 720.6999998 410.4000244 719.400012",
    fill: "#5e5556"
  })), _polygon965 || (_polygon965 = /*#__PURE__*/React.createElement("polygon", {
    points: "397.1000366 674.2999754 387.3000488 678.9999876 398.1000366 683.1999998 397.1000366 674.2999754",
    fill: "#9da3a2"
  })), _polygon966 || (_polygon966 = /*#__PURE__*/React.createElement("polygon", {
    points: "398.1000366 683.1999998 398.5 696.900012 392.9000244 688.4999876 398.1000366 683.1999998",
    fill: "#695e5e"
  })), _polygon967 || (_polygon967 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.9000244 688.4999876 387.3000488 678.9999876 398.1000366 683.1999998 392.9000244 688.4999876",
    fill: "#9c9896"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "m387.3000488,678.9999876l-7.1000366,14.5,12.7000122-5-5.5999756-9.5Z",
    fill: "#968f8c"
  })), _polygon968 || (_polygon968 = /*#__PURE__*/React.createElement("polygon", {
    points: "380.2000122 693.4999876 382.6000366 706.900012 386.9000244 698.6999998 380.2000122 693.4999876",
    fill: "#645855"
  })), _polygon969 || (_polygon969 = /*#__PURE__*/React.createElement("polygon", {
    points: "386.9000244 698.6999998 380.2000122 693.4999876 392.9000244 688.4999876 386.9000244 698.6999998",
    fill: "#867976"
  })), _polygon970 || (_polygon970 = /*#__PURE__*/React.createElement("polygon", {
    points: "386.9000244 698.6999998 398.5 696.900012 392.9000244 688.4999876 386.9000244 698.6999998",
    fill: "#827270"
  })), _polygon971 || (_polygon971 = /*#__PURE__*/React.createElement("polygon", {
    points: "398.5 696.8000364 398.8000488 707.2999754 398.5 713.400012 393.9432953 704.1907517 398.5 696.8000364",
    fill: "#45403f"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "m394,704.1000242s-7.4000244-5.2000122-7-5.5,11.5-1.7999878,11.5-1.7999878l-4.5,7.2999878Z",
    fill: "#716361"
  })), _polygon972 || (_polygon972 = /*#__PURE__*/React.createElement("polygon", {
    points: "394 704.1000242 382.6000366 706.900012 386.9000244 698.6999998 394 704.1000242",
    fill: "#564c4a"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "m382.6000366,706.900012c0,.7999878,2.2000122,12.5,2.2000122,12.5l4.2000122-5.7999878-6.4000244-6.7000122Z",
    fill: "#383433"
  })), _polygon973 || (_polygon973 = /*#__PURE__*/React.createElement("polygon", {
    points: "389 713.6000242 394 704.1000242 382.6000366 706.900012 389 713.6000242",
    fill: "#3e3937"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m389,713.6000242c.0999756.0999756,9.5-.2000122,9.5-.2000122l-4.5746054-9.3525382-4.9253946,9.5525504Z",
    fill: "#373433"
  })), _polygon974 || (_polygon974 = /*#__PURE__*/React.createElement("polygon", {
    points: "398.5 713.2999754 392.5 722.9999876 399.5 735.1000242 398.1000366 722.900012 398.5 713.2999754",
    fill: "#2d2a2c"
  })), _polygon975 || (_polygon975 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.5 722.9999876 384.5 729.1000242 399.5 735.1000242 392.5 722.9999876",
    fill: "#2d2a2c"
  })), _polygon976 || (_polygon976 = /*#__PURE__*/React.createElement("polygon", {
    points: "384.5 729.1000242 379.8000488 725.6000242 384.8000488 719.400012 384.5 729.1000242",
    fill: "#3d3839"
  })), _polygon977 || (_polygon977 = /*#__PURE__*/React.createElement("polygon", {
    points: "384.5 729.1000242 384.8000488 719.400012 392.5 722.9999876 384.5 729.1000242",
    fill: "#423d40"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m384.8000488,719.400012c.4000244-.4000244,13.7999878-6.0999756,13.7999878-6.0999756l-6.1000366,9.6999512-7.6999512-3.5999756Z",
    fill: "#383434"
  })), _polygon978 || (_polygon978 = /*#__PURE__*/React.createElement("polygon", {
    points: "384.8000488 719.400012 398.6000366 713.3000364 389 713.6000242 384.8000488 719.400012",
    fill: "#353131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEcommbxLandingPageLogo);
export default __webpack_public_path__ + "static/media/newEcommbxLandingPageLogo.851866a19ff9f5c71971aa323a7e63ad.svg";
export { ForwardRef as ReactComponent };